/*
sov - bootstrap unico funzionalità pdp

ultimo aggiornamento: 2026-03-23  europe/rome

prima:
ogni feature registrava il proprio domcontentloaded separato,
con ripetizione di querySelectorAll('product-info') e bootstrap duplicati.

dopo:
bootstrap unico centralizzato che inizializza tutte le feature pdp
sui nodi product-info trovati nel root corrente.
supporta anche reinizializzazione su shopify:section:load.
*/

function initSovPdpFeatures(root) {
	var scope = root || document;
	var productInfos = scope.matches && scope.matches('product-info')
		? [scope]
		: Array.prototype.slice.call(scope.querySelectorAll('product-info'));

	if (!productInfos.length) {
		return;
	}

	productInfos.forEach(function (productInfo) {
		initSovProductMediaLightbox(productInfo);
		initSovProductMediaLightboxTelemetry(productInfo);
		initSovGalleryBodyScrollLock(productInfo);
		initSovGalleryCarets(productInfo);
		initSovZoomIndicatorAlignment(productInfo);
		initSovPdpVideoTelemetry(productInfo);
		initSovPdpBreadcrumbTelemetry(productInfo);
		initSovGalleryCaretVerticalAlignment(productInfo);
		initSovBundleMegaOfferRouting(productInfo);
		initSovPdpAddToCartIntentTelemetry(productInfo);
		initSovScarcityMessage(productInfo);
		initSovOriginalMobileAtcButtonMode(productInfo);
		initSovPdpEditorialInfoRail(productInfo);
		initSovProductChoiceImagesImpressionTelemetry(productInfo);
		initSovProductChoiceImagesLightbox(productInfo);
		initSovProductChoiceImagesMainGallerySurprises(productInfo);
		initSovProductChoiceImagesCarousel(productInfo);
		initSovStoreReviewsPreviewModalClone(productInfo);
		initSovStoreReviewsPreviewCarousel(productInfo);
		initSovVariantThumbsAndPickers(productInfo);
		initSovVariantPickerRails(productInfo);
		initSovStoreReviewsPreviewTextExpansion(productInfo);
	});
}

function initSovScarcityMessage(productInfo) {
	if (!productInfo) {
		return;
	}

	var message = productInfo.querySelector('[data-sov-scarcity-message]');

	if (!message || message.dataset.sovScarcityMessageInit === 'true') {
		return;
	}

	var options = Array.prototype.slice.call(
		message.querySelectorAll('[data-sov-scarcity-copy]')
	);

	if (!options.length) {
		return;
	}

	var productId = String(
		message.getAttribute('data-sov-scarcity-product-id') || 'default'
	);

	window.__sovScarcityPageViewMessageIndexes =
		window.__sovScarcityPageViewMessageIndexes || {};

	var selectedIndex =
		window.__sovScarcityPageViewMessageIndexes[productId];

	if (
		typeof selectedIndex !== 'number' ||
		selectedIndex < 0 ||
		selectedIndex >= options.length
	) {
		selectedIndex = Math.floor(Math.random() * options.length);

		window.__sovScarcityPageViewMessageIndexes[productId] =
			selectedIndex;
	}

	options.forEach(function (option, index) {
		option.hidden =
			index !== selectedIndex;
	});

	message.hidden =
		false;

	message.dataset.sovScarcityMessageInit =
		'true';
}

function initSovPdpBootstrap() {
	initSovModalTriggerAriaExpandedSync(document);
	initSovPdpFeatures(document);
}


/*
sov - rail editoriale informazioni pdp

ultimo aggiornamento: 19/05/2026 europe/rome

*/
function initSovPdpEditorialInfoRail(productInfo) {
	if (!productInfo || productInfo.dataset.sovPdpEditorialInfoRailInit === 'true') {
		return;
	}

	var root = productInfo.querySelector('[data-sov-pdp-editorial-info="1"]');

	var collapsedLineCount = 5;
	var transitionFallbackMs = 920;
	var editorialBodyAnimationDurationMs = 760;
	var editorialHeaderAccordionCollapseAnimationDurationMs = 1280;
	var editorialHeaderAccordionCollapseAnimationEase = 'cubic-bezier(0.16, 0.84, 0.44, 1)';

	if (!root) {
		return;
	}

	var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-sov-pdp-editorial-tab]'));
	var panels = Array.prototype.slice.call(root.querySelectorAll('[data-sov-pdp-editorial-panel]'));
	var tabsRail = root.querySelector('.sov-pdp-editorial-info__tabs');
	var tabSliderTrack = root.querySelector('.sov-pdp-editorial-info__tab-slider-track');
	var tabSliderKnob = root.querySelector('.sov-pdp-editorial-info__tab-slider-knob');
	var tabSliderRaf = 0;


	var editorialAccordionMediaQuery = window.matchMedia('(max-width: 900px)');
	var editorialAccordionRaf = 0;

	function getActiveEditorialInfoTab() {
		return root.querySelector('[data-sov-pdp-editorial-tab].is-active') || tabs[0] || null;
	}

	function updateEditorialInfoTabSlider(activeTab) {
		var tab = activeTab || getActiveEditorialInfoTab();
		var tabRect;
		var railRect;
		var trackRect;
		var left;
		var width;

		if (!tab || !tabsRail || !tabSliderTrack || !tabSliderKnob) {
			return;
		}

		tabRect = tab.getBoundingClientRect();
		railRect = tabsRail.getBoundingClientRect();
		trackRect = tabSliderTrack.getBoundingClientRect();

		left = tabRect.left - trackRect.left;
		width = tabRect.width;

		if (left < 0) {
			width = Math.max(0, width + left);
			left = 0;
		}

		if (left + width > trackRect.width) {
			width = Math.max(0, trackRect.width - left);
		}

		tabSliderKnob.style.width = Math.round(width) + 'px';
		tabSliderKnob.style.transform = 'translateX(' + Math.round(left) + 'px)';
	}

	function scheduleEditorialInfoTabSliderUpdate(activeTab) {
		if (tabSliderRaf) {
			window.cancelAnimationFrame(tabSliderRaf);
		}

		tabSliderRaf = window.requestAnimationFrame(function () {
			tabSliderRaf = 0;
			updateEditorialInfoTabSlider(activeTab);
		});
	}

	function isEditorialInfoAccordionMode() {
		return editorialAccordionMediaQuery && editorialAccordionMediaQuery.matches;
	}

	function getSafeEditorialInfoDomKey(key) {
		return String(key || 'panel')
			.toLowerCase()
			.replace(/[^a-z0-9_-]+/g, '-')
			.replace(/^-+|-+$/g, '') || 'panel';
	}

	function getEditorialInfoPanelKey(panel) {
		return panel ? panel.getAttribute('data-sov-pdp-editorial-panel') || '' : '';
	}

	function getEditorialInfoTabByKey(key) {
		var matchedTab = null;

		tabs.some(function (tabNode) {
			if (tabNode.getAttribute('data-sov-pdp-editorial-tab') === key) {
				matchedTab = tabNode;
				return true;
			}

			return false;
		});

		return matchedTab;
	}

	function getDirectEditorialInfoChildByClass(parent, className) {
		var children = parent ? Array.prototype.slice.call(parent.children) : [];
		var matchedChild = null;

		children.some(function (child) {
			if (child.classList && child.classList.contains(className)) {
				matchedChild = child;
				return true;
			}

			return false;
		});

		return matchedChild;
	}

	function getEditorialInfoAccordionHeader(panel) {
		return getDirectEditorialInfoChildByClass(
			panel,
			'sov-pdp-editorial-info__accordion-header'
		);
	}

	function getEditorialInfoAccordionOuter(panel) {
		return getDirectEditorialInfoChildByClass(
			panel,
			'sov-pdp-editorial-info__accordion-content-outer'
		);
	}

	function getEditorialInfoAccordionInner(panel) {
		var outer = getEditorialInfoAccordionOuter(panel);

		return outer
			? outer.querySelector('.sov-pdp-editorial-info__accordion-content-inner')
			: null;
	}

	function buildEditorialInfoAccordionHeader(panel, label, key) {
		var header = document.createElement('button');
		var title = document.createElement('span');
		var caret = document.createElement('span');
		var safeKey = getSafeEditorialInfoDomKey(key);

		header.type = 'button';
		header.className = 'sov-pdp-editorial-info__accordion-header';
		header.setAttribute('data-sov-pdp-editorial-accordion-trigger', '1');
		header.setAttribute('aria-expanded', 'false');

		title.className = 'sov-pdp-editorial-info__accordion-title';
		title.textContent = label;

		caret.className = 'sov-pdp-editorial-info__accordion-caret';
		caret.setAttribute('aria-hidden', 'true');
		caret.innerHTML =
			'<svg viewBox="0 0 24 24" focusable="false">' +
				'<path d="M6.7 9.3a1 1 0 0 1 1.4 0L12 13.2l3.9-3.9a1 1 0 1 1 1.4 1.4l-4.6 4.6a1 1 0 0 1-1.4 0L6.7 10.7a1 1 0 0 1 0-1.4z"></path>' +
			'</svg>';

		header.appendChild(title);
		header.appendChild(caret);

		if (!panel.id) {
			panel.id = 'sov-pdp-editorial-panel-' + safeKey;
		}

		return header;
	}

	function ensureEditorialInfoAccordionStructure() {
		panels.forEach(function (panel) {
			var key = getEditorialInfoPanelKey(panel);
			var tab = getEditorialInfoTabByKey(key);
			var label = tab ? tab.textContent.trim() : key;
			var header = getEditorialInfoAccordionHeader(panel);
			var outer = getEditorialInfoAccordionOuter(panel);
			var inner;
			var originalNodes;
			var safeKey = getSafeEditorialInfoDomKey(key);

			if (!outer) {
				header = buildEditorialInfoAccordionHeader(panel, label, key);

				outer = document.createElement('div');
				outer.className = 'sov-pdp-editorial-info__accordion-content-outer';
				outer.id = 'sov-pdp-editorial-accordion-content-' + safeKey;

				inner = document.createElement('div');
				inner.className = 'sov-pdp-editorial-info__accordion-content-inner';

				originalNodes = Array.prototype.slice.call(panel.childNodes);

				panel.appendChild(header);
				outer.appendChild(inner);

				originalNodes.forEach(function (node) {
					inner.appendChild(node);
				});

				panel.appendChild(outer);
			} else {
				inner = outer.querySelector('.sov-pdp-editorial-info__accordion-content-inner');
			}

			if (!header) {
				header = buildEditorialInfoAccordionHeader(panel, label, key);
				panel.insertBefore(header, outer);
			}

			header.querySelector('.sov-pdp-editorial-info__accordion-title').textContent = label;
			header.setAttribute('aria-controls', outer.id);
		});
	}

	function setEditorialInfoAccordionHeight(panel, heightOverridePx) {
		var outer = getEditorialInfoAccordionOuter(panel);
		var inner = getEditorialInfoAccordionInner(panel);
		var isOpen = panel && panel.classList.contains('is-mobile-accordion-open');
		var nextHeight;

		if (!outer || !inner) {
			return;
		}

		if (!isOpen) {
			outer.style.maxHeight = '0px';
			return;
		}

		nextHeight =
			typeof heightOverridePx === 'number'
				? Math.max(0, Math.ceil(heightOverridePx))
				: inner.scrollHeight;

		outer.style.maxHeight = nextHeight + 'px';
	}

	function prepareEditorialInfoAccordionOuterForBodyAnimation(panel, startHeight, targetHeight) {
		var outer = getEditorialInfoAccordionOuter(panel);
		var inner = getEditorialInfoAccordionInner(panel);
		var currentOuterHeight;
		var currentInnerHeight;
		var targetOuterHeight;
		var previousTransition;

		if (!isEditorialInfoAccordionMode()) {
			return null;
		}

		if (!panel || !panel.classList.contains('is-mobile-accordion-open')) {
			return null;
		}

		if (!outer || !inner) {
			return null;
		}

		currentOuterHeight = outer.getBoundingClientRect().height;
		currentInnerHeight = inner.scrollHeight;
		targetOuterHeight = Math.max(0, currentInnerHeight + targetHeight - startHeight);

		if (!currentOuterHeight) {
			currentOuterHeight = currentInnerHeight;
		}

		previousTransition = outer.style.transition;

		outer.style.transition = 'none';
		outer.style.maxHeight = Math.ceil(currentOuterHeight) + 'px';

		outer.offsetHeight;

		outer.style.transition = previousTransition;

		return {
			outer: outer,
			targetOuterHeight: Math.ceil(targetOuterHeight)
		};
	}

	function setEditorialInfoAccordionHeaderState(panel, expanded) {
		var header = getEditorialInfoAccordionHeader(panel);

		if (header) {
			header.setAttribute('aria-expanded', expanded ? 'true' : 'false');
		}
	}

	function syncEditorialInfoTabsForAccordionKey(key) {
		tabs.forEach(function (tabNode) {
			var isActive = tabNode.getAttribute('data-sov-pdp-editorial-tab') === key;

			tabNode.classList.toggle('is-active', isActive);
			tabNode.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});
	}

	function closeEditorialInfoAccordionPanel(panel) {
		var body;
		var button;
		var outer;
		var currentBodyHeight;
		var collapsedHeight;
		var currentOuterHeight;
		var shouldAnimateExpandedPanelClose;
		var shouldRestoreScrollAfterExpandedPanelCloses;
		var finished = false;

		if (!panel) {
			return;
		}

		body = panel.querySelector('[data-sov-pdp-info-body="1"]');
		button = panel.querySelector('[data-sov-pdp-info-expand-button="1"]');
		outer = getEditorialInfoAccordionOuter(panel);
		shouldAnimateExpandedPanelClose =
			isEditorialInfoAccordionMode() &&
			!!body &&
			!!button &&
			!!outer &&
			panel.classList.contains('is-expanded');

		shouldRestoreScrollAfterExpandedPanelCloses =
			panel.classList.contains('is-expanded') &&
			!!panel.dataset.sovExpandableContentScrollReturnY;

		if (!shouldAnimateExpandedPanelClose) {
			if (body && button && panel.classList.contains('is-expanded')) {
				collapsedHeight = getCollapsedHeight(body);

				panel.dataset.sovPdpInfoBodyAnimating = 'false';
				panel.classList.remove('is-expanded');
				body.style.height = collapsedHeight + 'px';
				syncButtonState(button, false);
			}

			panel.classList.remove('is-mobile-accordion-open');
			panel.classList.remove('is-active');
			setEditorialInfoAccordionHeaderState(panel, false);
			setEditorialInfoAccordionHeight(panel);

			if (shouldRestoreScrollAfterExpandedPanelCloses) {
				sovRestoreWindowScrollYAfterExpandableContentCloses(panel, {
					durationMs: editorialHeaderAccordionCollapseAnimationDurationMs
				});
			}

			return;
		}

		currentBodyHeight = Math.max(
			1,
			Math.ceil(body.getBoundingClientRect().height)
		);
		collapsedHeight = getCollapsedHeight(body);
		currentOuterHeight = Math.max(
			1,
			Math.ceil(outer.getBoundingClientRect().height)
		);

		if (panel.__sovEditorialHeaderAccordionCloseTimer) {
			window.clearTimeout(panel.__sovEditorialHeaderAccordionCloseTimer);
			panel.__sovEditorialHeaderAccordionCloseTimer = 0;
		}

		panel.dataset.sovPdpInfoBodyAnimating = 'true';

		body.style.transition = 'none';
		body.style.height = currentBodyHeight + 'px';

		outer.style.transition = 'none';
		outer.style.maxHeight = currentOuterHeight + 'px';

		body.offsetHeight;
		outer.offsetHeight;

		panel.classList.remove('is-expanded');
		panel.classList.remove('is-mobile-accordion-open');
		panel.classList.remove('is-active');
		syncButtonState(button, false);
		setEditorialInfoAccordionHeaderState(panel, false);

		body.style.transition =
			'height ' +
			editorialHeaderAccordionCollapseAnimationDurationMs +
			'ms ' +
			editorialHeaderAccordionCollapseAnimationEase;

		outer.style.transition =
			'max-height ' +
			editorialHeaderAccordionCollapseAnimationDurationMs +
			'ms ' +
			editorialHeaderAccordionCollapseAnimationEase;

		window.requestAnimationFrame(function () {
			body.style.height = collapsedHeight + 'px';
			outer.style.maxHeight = '0px';

			if (shouldRestoreScrollAfterExpandedPanelCloses) {
				sovRestoreWindowScrollYAfterExpandableContentCloses(panel, {
					durationMs: editorialHeaderAccordionCollapseAnimationDurationMs
				});
			}
		});

		function finishHeaderAccordionCloseAnimation(event) {
			if (event && event.target !== body) {
				return;
			}

			if (event && event.propertyName !== 'height') {
				return;
			}

			if (finished) {
				return;
			}

			finished = true;

			if (panel.__sovEditorialHeaderAccordionCloseTimer) {
				window.clearTimeout(panel.__sovEditorialHeaderAccordionCloseTimer);
				panel.__sovEditorialHeaderAccordionCloseTimer = 0;
			}

			panel.dataset.sovPdpInfoBodyAnimating = 'false';
			body.style.transition = '';
			outer.style.transition = '';
			body.style.height = collapsedHeight + 'px';
			setEditorialInfoAccordionHeight(panel);
		}

		body.addEventListener(
			'transitionend',
			finishHeaderAccordionCloseAnimation,
			{ once: true }
		);

		panel.__sovEditorialHeaderAccordionCloseTimer = window.setTimeout(
			finishHeaderAccordionCloseAnimation,
			editorialHeaderAccordionCollapseAnimationDurationMs + 160
		);
	}

	function closeOtherEditorialInfoAccordionPanels(activePanel) {
		panels.forEach(function (panel) {
			if (panel !== activePanel) {
				closeEditorialInfoAccordionPanel(panel);
			}
		});
	}

	function sendEditorialInfoAccordionTelemetry(panel, action) {
		var key = getEditorialInfoPanelKey(panel);

		if (typeof window.gtag === 'function') {
			window.gtag('event', 'pdp_editorial_info_accordion_' + action, {
				event_category: 'pdp_content',
				tab_key: key,
				product_id: productInfo.getAttribute('data-product-id') || '',
				product_handle: productInfo.getAttribute('data-product-handle') || '',
				page_path: window.location.pathname || ''
			});
		}
	}

	function openEditorialInfoAccordionPanel(panel, skipTelemetry) {
		var key = getEditorialInfoPanelKey(panel);

		if (!panel) {
			return;
		}

		panel.hidden = false;
		closeOtherEditorialInfoAccordionPanels(panel);

		panel.classList.add('is-mobile-accordion-open');
		panel.classList.add('is-active');

		syncEditorialInfoTabsForAccordionKey(key);
		setEditorialInfoAccordionHeaderState(panel, true);
		applyStaticBodyState(panel);
		setEditorialInfoAccordionHeight(panel);
		root.classList.add('is-editorial-info-ready');

		if (!skipTelemetry) {
			sendEditorialInfoAccordionTelemetry(panel, 'open');
		}
	}

	function toggleEditorialInfoAccordionPanel(panel) {
		if (!panel) {
			return;
		}

		if (panel.classList.contains('is-mobile-accordion-open')) {
			closeEditorialInfoAccordionPanel(panel);
			sendEditorialInfoAccordionTelemetry(panel, 'close');
			return;
		}

		openEditorialInfoAccordionPanel(panel, false);
	}

	function syncEditorialInfoDesktopPanelsFromActiveTab() {
		var activeTab = getActiveEditorialInfoTab();
		var activeKey = activeTab
			? activeTab.getAttribute('data-sov-pdp-editorial-tab')
			: getEditorialInfoPanelKey(panels[0]);

		panels.forEach(function (panelNode) {
			var isActive = getEditorialInfoPanelKey(panelNode) === activeKey;
			var outer = getEditorialInfoAccordionOuter(panelNode);

			panelNode.classList.remove('is-mobile-accordion-open');
			panelNode.classList.toggle('is-active', isActive);
			panelNode.hidden = !isActive;
			setEditorialInfoAccordionHeaderState(panelNode, false);

			if (outer) {
				outer.style.maxHeight = '';
			}
		});

		window.requestAnimationFrame(refreshActivePanel);
	}

	function refreshEditorialInfoAccordionOpenPanel() {
		var openPanel = root.querySelector(
			'[data-sov-pdp-editorial-panel].is-mobile-accordion-open'
		);

		panels.forEach(function (panel) {
			panel.hidden = false;

			if (panel === openPanel) {
				applyStaticBodyState(panel);
			}

			setEditorialInfoAccordionHeight(panel);
		});

		root.classList.add('is-editorial-info-ready');
	}

	function applyEditorialInfoResponsiveMode() {
		var activePanel = root.querySelector('[data-sov-pdp-editorial-panel].is-active') || panels[0];

		ensureEditorialInfoAccordionStructure();

		if (isEditorialInfoAccordionMode()) {
			root.classList.add('is-mobile-accordion');

			panels.forEach(function (panel) {
				panel.hidden = false;
			});

			if (!root.querySelector('[data-sov-pdp-editorial-panel].is-mobile-accordion-open')) {
				openEditorialInfoAccordionPanel(activePanel, true);
			} else {
				refreshEditorialInfoAccordionOpenPanel();
			}

			return;
		}

		root.classList.remove('is-mobile-accordion');
		syncEditorialInfoDesktopPanelsFromActiveTab();
		scheduleEditorialInfoTabSliderUpdate();
	}

	function scheduleEditorialInfoResponsiveRefresh() {
		if (editorialAccordionRaf) {
			window.cancelAnimationFrame(editorialAccordionRaf);
		}

		editorialAccordionRaf = window.requestAnimationFrame(function () {
			editorialAccordionRaf = 0;
			applyEditorialInfoResponsiveMode();
		});
	}

	function getButtonLabel(button, mode) {
		if (!button) {
			return '';
		}

		if (mode === 'less') {
			return button.getAttribute('data-sov-pdp-info-expand-label-less') || 'Show less';
		}

		return button.getAttribute('data-sov-pdp-info-expand-label-more') || 'Show more';
	}

	function syncButtonState(button, isExpanded) {
		if (!button) {
			return;
		}

		button.textContent = getButtonLabel(button, isExpanded ? 'less' : 'more');
		button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
	}

	function getCollapsedHeight(body) {
		var styles = window.getComputedStyle(body);
		var fontSize = parseFloat(styles.fontSize) || 16;
		var lineHeight = parseFloat(styles.lineHeight);
		var paddingTop = parseFloat(styles.paddingTop) || 0;
		var paddingBottom = parseFloat(styles.paddingBottom) || 0;

		if (!lineHeight || Number.isNaN(lineHeight)) {
			lineHeight = fontSize * 1.55;
		}

		return Math.ceil(lineHeight * collapsedLineCount + paddingTop + paddingBottom);
	}

	function getExpandedHeight(body) {
		var previousHeight = body.style.height;
		var previousTransition = body.style.transition;
		var height;

		body.style.transition = 'none';
		body.style.height = 'auto';

		height = body.scrollHeight;

		body.style.height = previousHeight;
		body.style.transition = previousTransition;

		return Math.max(1, height);
	}

	function applyStaticBodyState(panel) {
		var body = panel ? panel.querySelector('[data-sov-pdp-info-body="1"]') : null;
		var button = panel ? panel.querySelector('[data-sov-pdp-info-expand-button="1"]') : null;
		var expandedHeight;
		var collapsedHeight;
		var hasOverflow;
		var isExpanded;

		if (!panel || panel.hidden || !body || !button) {
			return;
		}

		expandedHeight = getExpandedHeight(body);
		collapsedHeight = getCollapsedHeight(body);
		hasOverflow = expandedHeight > collapsedHeight + 3;
		isExpanded = panel.classList.contains('is-expanded');

		panel.classList.toggle('has-collapsed-content', hasOverflow);

		if (!hasOverflow) {
			body.style.height = '';
			button.hidden = true;
			button.setAttribute('aria-expanded', 'false');
			panel.classList.remove('is-expanded');
			return;
		}

		button.hidden = false;
		syncButtonState(button, isExpanded);

		if (isExpanded) {
			body.style.height = 'auto';
		} else {
			body.style.height = collapsedHeight + 'px';
		}
	}

	function refreshActivePanel() {
		var activePanel = root.querySelector('[data-sov-pdp-editorial-panel].is-active');

		if (isEditorialInfoAccordionMode()) {
			refreshEditorialInfoAccordionOpenPanel();
			return;
		}

		if (!activePanel) {
			return;
		}

		if (activePanel.dataset.sovPdpInfoBodyAnimating === 'true') {
			return;
		}

		applyStaticBodyState(activePanel);
		root.classList.add('is-editorial-info-ready');
		scheduleEditorialInfoTabSliderUpdate();
	}

	function animatePanelBody(panel, body, button, nextExpanded) {
		var startHeight = body.getBoundingClientRect().height;
		var expandedHeight = getExpandedHeight(body);
		var collapsedHeight = getCollapsedHeight(body);
		var targetHeight = nextExpanded ? expandedHeight : collapsedHeight;
		var accordionOuterAnimation;
		var fallbackTimer;
		var finished = false;

		if (panel.dataset.sovPdpInfoBodyAnimating === 'true') {
			return;
		}

		if (nextExpanded) {
			sovStoreWindowScrollYBeforeExpandableContentOpens(panel);
		}

		panel.dataset.sovPdpInfoBodyAnimating = 'true';

		body.style.transition = 'none';
		body.style.height = startHeight + 'px';

		body.offsetHeight;

		panel.classList.toggle('is-expanded', nextExpanded);
		syncButtonState(button, nextExpanded);

		accordionOuterAnimation = prepareEditorialInfoAccordionOuterForBodyAnimation(
			panel,
			startHeight,
			targetHeight
		);

		body.style.transition = '';

		window.requestAnimationFrame(function () {
			if (accordionOuterAnimation) {
				accordionOuterAnimation.outer.style.maxHeight =
					accordionOuterAnimation.targetOuterHeight + 'px';
			}

			body.style.height = targetHeight + 'px';

			if (!nextExpanded) {
				sovRestoreWindowScrollYAfterExpandableContentCloses(panel, {
					durationMs: editorialBodyAnimationDurationMs
				});
			}
		});

		function finishAnimation(event) {
			if (event && event.target !== body) {
				return;
			}

			if (event && event.propertyName !== 'height') {
				return;
			}

			if (finished) {
				return;
			}

			finished = true;
			window.clearTimeout(fallbackTimer);
			panel.dataset.sovPdpInfoBodyAnimating = 'false';

			if (nextExpanded) {
				body.style.height = 'auto';
			} else {
				body.style.height = collapsedHeight + 'px';
			}

			if (isEditorialInfoAccordionMode()) {
				setEditorialInfoAccordionHeight(panel);
			}
		}

		body.addEventListener('transitionend', finishAnimation, { once: true });

		fallbackTimer = window.setTimeout(function () {
			finishAnimation();
		}, transitionFallbackMs);
	}

	function scrollActiveEditorialTabIntoView(tab) {
		var tabList = tab ? tab.closest('.sov-pdp-editorial-info__tabs') : null;
		var reduceMotion = false;

		if (!tab || !tabList) {
			return;
		}

		try {
			reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		} catch (error) {}

		window.requestAnimationFrame(function () {
			var tabRect = tab.getBoundingClientRect();
			var tabListRect = tabList.getBoundingClientRect();
			var targetLeft =
				tabList.scrollLeft +
				tabRect.left -
				tabListRect.left -
				(tabListRect.width - tabRect.width) / 2;
			var maxLeft = tabList.scrollWidth - tabList.clientWidth;

			if (targetLeft < 0) {
				targetLeft = 0;
			}

			if (targetLeft > maxLeft) {
				targetLeft = maxLeft;
			}

			tabList.scrollTo({
				left: targetLeft,
				behavior: reduceMotion ? 'auto' : 'smooth'
			});
		});
	}

	function activateTab(tab) {
		var key = tab.getAttribute('data-sov-pdp-editorial-tab');

		tabs.forEach(function (tabNode) {
			var isActive = tabNode === tab;

			tabNode.classList.toggle('is-active', isActive);
			tabNode.setAttribute('aria-selected', isActive ? 'true' : 'false');
		});

		panels.forEach(function (panelNode) {
			var isActive = panelNode.getAttribute('data-sov-pdp-editorial-panel') === key;

			panelNode.classList.toggle('is-active', isActive);
			panelNode.hidden = !isActive;
		});

		scrollActiveEditorialTabIntoView(tab);
		scheduleEditorialInfoTabSliderUpdate(tab);
		window.requestAnimationFrame(refreshActivePanel);

		if (typeof window.gtag === 'function') {
			window.gtag('event', 'pdp_editorial_info_tab_open', {
				event_category: 'pdp_content',
				tab_key: key,
				product_id: productInfo.getAttribute('data-product-id') || '',
				product_handle: productInfo.getAttribute('data-product-handle') || '',
				page_path: window.location.pathname || ''
			});
		}
	}

	root.addEventListener('click', function (event) {
		var tab = event.target.closest('[data-sov-pdp-editorial-tab]');
		var accordionHeader = event.target.closest('[data-sov-pdp-editorial-accordion-trigger="1"]');
		var button = event.target.closest('[data-sov-pdp-info-expand-button="1"]');
		var panel;
		var body;
		var nextExpanded;

		if (accordionHeader && root.contains(accordionHeader)) {
			toggleEditorialInfoAccordionPanel(
				accordionHeader.closest('[data-sov-pdp-editorial-panel]')
			);
			return;
		}

		if (tab && root.contains(tab)) {
			activateTab(tab);
			return;
		}

		if (!button || !root.contains(button)) {
			return;
		}

		panel = button.closest('[data-sov-pdp-editorial-panel]');
		body = panel ? panel.querySelector('[data-sov-pdp-info-body="1"]') : null;

		if (!panel || !body) {
			return;
		}

		nextExpanded = !panel.classList.contains('is-expanded');
		animatePanelBody(panel, body, button, nextExpanded);
	});

	root.addEventListener('keydown', function (event) {
		var currentTab = event.target.closest('[data-sov-pdp-editorial-tab]');
		var currentIndex;
		var nextIndex;

		if (!currentTab || !root.contains(currentTab)) {
			return;
		}

		if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
			return;
		}

		event.preventDefault();

		currentIndex = tabs.indexOf(currentTab);
		nextIndex = event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;

		if (nextIndex < 0) {
			nextIndex = tabs.length - 1;
		}

		if (nextIndex >= tabs.length) {
			nextIndex = 0;
		}

		tabs[nextIndex].focus();
		activateTab(tabs[nextIndex]);
	});

	window.addEventListener(
		'resize',
		function () {
			scheduleEditorialInfoResponsiveRefresh();
		},
		{ passive: true }
	);

	if (tabsRail) {
		tabsRail.addEventListener(
			'scroll',
			function () {
				scheduleEditorialInfoTabSliderUpdate();
			},
			{ passive: true }
		);
	}

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function () {
			scheduleEditorialInfoResponsiveRefresh();
		});
	}

	ensureEditorialInfoAccordionStructure();
	applyEditorialInfoResponsiveMode();

	productInfo.dataset.sovPdpEditorialInfoRailInit = 'true';
}

function initSovStoreReviewsPreviewModalClone(productInfo) {
	if (!productInfo || productInfo.dataset.sovStoreReviewsPreviewModalCloneInit === 'true') {
		return;
	}

	var source = productInfo.querySelector('.sov-pdp-store-reviews-preview-payload');
	var overlay = document.getElementById('sov-modal-pdp_store_reviews-overlay');
	var slot = overlay
		? overlay.querySelector('[data-sov-store-reviews-modal-slot="1"]')
		: null;

	if (!source || !overlay || !slot) {
		return;
	}

	function syncCloneIntoModal() {
		var clone;

		slot.innerHTML = '';

		clone = source.cloneNode(true);
		clone.classList.add('is-cloned-for-modal');

		slot.appendChild(clone);
		slot.hidden = false;
	}

window.addEventListener('sov:modal:opened', function (event) {
	if (!event || !event.detail || event.detail.key !== 'pdp_store_reviews') {
		return;
	}

	syncCloneIntoModal();
});

window.addEventListener('sov:modal:closed', function (event) {
	if (!event || !event.detail || event.detail.key !== 'pdp_store_reviews') {
		return;
	}

	slot.innerHTML = '';
	slot.hidden = true;
});

	productInfo.dataset.sovStoreReviewsPreviewModalCloneInit = 'true';
}


/*
sov - ripristino scroll dopo chiusura contenuti espansi

ultimo aggiornamento: 17/05/2026 17:40 europe/rome

prima:
la chiusura di un contenuto espanso riduceva l'altezza della card senza riportare
la viewport al punto registrato prima dell'apertura.

dopo:
al click su mostra di più viene salvata la posizione scroll verticale.
al click su mostra meno, dopo la chiusura animata, la viewport torna alla posizione salvata.
*/
function sovStoreWindowScrollYBeforeExpandableContentOpens(expandableContainer) {
	if (!expandableContainer) {
		return;
	}

	expandableContainer.dataset.sovExpandableContentScrollReturnY = String(
		Math.max(
			0,
			window.scrollY ||
				document.documentElement.scrollTop ||
				document.body.scrollTop ||
				0
		)
	);
}

function sovGetCurrentWindowScrollY() {
	return (
		window.scrollY ||
		document.documentElement.scrollTop ||
		document.body.scrollTop ||
		0
	);
}

function sovEaseOutSoftQuart(progress) {
	return 1 - Math.pow(1 - progress, 4);
}

function sovRestoreWindowScrollYAfterExpandableContentCloses(expandableContainer, options) {
	var rawScrollY;
	var targetScrollY;
	var currentScrollY;
	var startScrollY;
	var distance;
	var durationMs;
	var startTime = null;
	var reduceMotion = false;

	if (!expandableContainer) {
		return;
	}

	rawScrollY = expandableContainer.dataset.sovExpandableContentScrollReturnY;
	targetScrollY = parseFloat(rawScrollY);

	delete expandableContainer.dataset.sovExpandableContentScrollReturnY;

	if (isNaN(targetScrollY)) {
		return;
	}

	targetScrollY = Math.max(0, targetScrollY);
	currentScrollY = sovGetCurrentWindowScrollY();

	if (Math.abs(currentScrollY - targetScrollY) <= 8) {
		return;
	}

	try {
		reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	} catch (error) {}

	if (reduceMotion) {
		window.scrollTo(0, targetScrollY);
		return;
	}

	if (expandableContainer.__sovExpandableContentScrollReturnRaf) {
		window.cancelAnimationFrame(expandableContainer.__sovExpandableContentScrollReturnRaf);
	}

	durationMs =
		options && typeof options.durationMs === 'number'
			? Math.max(180, options.durationMs)
			: 680;

	startScrollY = currentScrollY;
	distance = targetScrollY - startScrollY;

	function step(timestamp) {
		var elapsed;
		var progress;
		var easedProgress;
		var nextScrollY;

		if (startTime === null) {
			startTime = timestamp;
		}

		elapsed = timestamp - startTime;
		progress = Math.min(1, elapsed / durationMs);
		easedProgress = sovEaseOutSoftQuart(progress);
		nextScrollY = startScrollY + distance * easedProgress;

		window.scrollTo(0, Math.round(nextScrollY));

		if (progress < 1) {
			expandableContainer.__sovExpandableContentScrollReturnRaf =
				window.requestAnimationFrame(step);
			return;
		}

		window.scrollTo(0, targetScrollY);
		expandableContainer.__sovExpandableContentScrollReturnRaf = 0;
	}

	expandableContainer.__sovExpandableContentScrollReturnRaf =
		window.requestAnimationFrame(step);
}

/*
sov - espansione e chiusura animata testo recensioni preview pdp

ultimo aggiornamento: 17/05/2026 14:08 europe/rome

prima:
la chiusura poteva saltare perché lo stato aperto terminava con altezza automatica
o con cambio css non numerico.

dopo:
apertura e chiusura animano sempre tra due valori height in pixel.
lo stile visuale della card resta separato dalla logica.
*/
function initSovStoreReviewsPreviewTextExpansion(productInfo) {
	if (!productInfo || productInfo.dataset.sovStoreReviewsPreviewTextExpansionInit === 'true') {
		return;
	}

	var collapsedLineCount = 4;
	var transitionFallbackMs = 460;	

	function getButtonLabel(button, mode) {
		if (!button) {
			return '';
		}

		if (mode === 'less') {
			return button.getAttribute('data-sov-review-expand-label-less') || 'Show less';
		}

		return button.getAttribute('data-sov-review-expand-label-more') || 'Show more';
	}

	function syncButtonState(button, isExpanded) {
		if (!button) {
			return;
		}

		button.textContent = getButtonLabel(button, isExpanded ? 'less' : 'more');
		button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
	}

	function getCollapsedHeight(body) {
		var styles = window.getComputedStyle(body);
		var fontSize = parseFloat(styles.fontSize) || 16;
		var lineHeight = parseFloat(styles.lineHeight);
		var paddingTop = parseFloat(styles.paddingTop) || 0;
		var paddingBottom = parseFloat(styles.paddingBottom) || 0;

		if (!lineHeight || Number.isNaN(lineHeight)) {
			lineHeight = fontSize * 1.55;
		}

		return Math.ceil((lineHeight * collapsedLineCount) + paddingTop + paddingBottom);
	}

	function getExpandedHeight(body) {
		var previousHeight = body.style.height;
		var previousTransition = body.style.transition;
		var height;

		body.style.transition = 'none';
		body.style.height = 'auto';

		height = body.scrollHeight;

		body.style.height = previousHeight;
		body.style.transition = previousTransition;

		return Math.max(1, height);
	}

	function applyStaticBodyState(card, body, button) {
		var isInsideModalClone = !!body.closest('.sov-pdp-store-reviews-preview-payload.is-cloned-for-modal');
		var expandedHeight;
		var collapsedHeight;
		var hasOverflow;
		var isExpanded;

		if (isInsideModalClone) {
			body.style.height = '';
			button.hidden = true;
			button.setAttribute('aria-expanded', 'false');
			card.classList.remove('has-review-collapsed-text');
			card.classList.remove('is-review-expanded');
			return;
		}

		expandedHeight = getExpandedHeight(body);
		collapsedHeight = getCollapsedHeight(body);
		hasOverflow = expandedHeight > collapsedHeight + 3;
		isExpanded = card.classList.contains('is-review-expanded');

		card.classList.toggle('has-review-collapsed-text', hasOverflow);

		if (!hasOverflow) {
			body.style.height = '';
			button.hidden = true;
			button.setAttribute('aria-expanded', 'false');
			card.classList.remove('is-review-expanded');
			return;
		}

		button.hidden = false;
		syncButtonState(button, isExpanded);

		if (isExpanded) {
			body.style.height = 'auto';
		} else {
			body.style.height = collapsedHeight + 'px';
		}
	}

	function refreshExpandableReviewBodies(root) {
		var scope = root || productInfo;
		var bodies = Array.prototype.slice.call(
			scope.querySelectorAll('[data-sov-review-expandable-body="1"]')
		);

		bodies.forEach(function (body) {
			var card = body.closest('.sov-store-review-card');
			var button = card ? card.querySelector('[data-sov-review-expand-button="1"]') : null;

			if (!card || !button) {
				return;
			}

			if (body.dataset.sovReviewBodyAnimating === 'true') {
				return;
			}

			applyStaticBodyState(card, body, button);
		});
	}

	function animateReviewBody(card, body, button, nextExpanded) {
		var startHeight = body.getBoundingClientRect().height;
		var expandedHeight = getExpandedHeight(body);
		var collapsedHeight = getCollapsedHeight(body);
		var targetHeight = nextExpanded ? expandedHeight : collapsedHeight;
		var fallbackTimer;
		var finished = false;

		if (body.dataset.sovReviewBodyAnimating === 'true') {
			return;
		}

		if (nextExpanded) {
			sovStoreWindowScrollYBeforeExpandableContentOpens(card);
		}

		body.dataset.sovReviewBodyAnimating = 'true';

		body.style.transition = 'none';
		body.style.height = startHeight + 'px';

		body.offsetHeight;

		card.classList.toggle('is-review-expanded', nextExpanded);
		syncButtonState(button, nextExpanded);

		body.style.transition = '';

		window.requestAnimationFrame(function () {
			body.style.height = targetHeight + 'px';
		});

		function finishAnimation(event) {
			if (event && event.target !== body) {
				return;
			}

			if (event && event.propertyName !== 'height') {
				return;
			}

			if (finished) {
				return;
			}

			finished = true;
			window.clearTimeout(fallbackTimer);
			body.dataset.sovReviewBodyAnimating = 'false';

			if (nextExpanded) {
				body.style.height = 'auto';
			} else {
				body.style.height = collapsedHeight + 'px';
				sovRestoreWindowScrollYAfterExpandableContentCloses(card);
			}
		}

		body.addEventListener('transitionend', finishAnimation, { once: true });

		fallbackTimer = window.setTimeout(function () {
			finishAnimation();
		}, transitionFallbackMs);

		if (typeof window.gtag === 'function') {
			window.gtag('event', nextExpanded ? 'pdp_store_review_expand' : 'pdp_store_review_collapse', {
				event_category: 'reviews',
				product_id: productInfo.getAttribute('data-product-id') || '',
				product_handle: productInfo.getAttribute('data-product-handle') || '',
				page_path: window.location.pathname || ''
			});
		}
	}

	function scheduleRefresh(root) {
		window.requestAnimationFrame(function () {
			refreshExpandableReviewBodies(root);
		});
	}

	productInfo.addEventListener('click', function (event) {
		var button = event.target.closest('[data-sov-review-expand-button="1"]');
		var card;
		var body;
		var nextExpanded;

		if (!button || !productInfo.contains(button)) {
			return;
		}

		card = button.closest('.sov-store-review-card');
		body = card ? card.querySelector('[data-sov-review-expandable-body="1"]') : null;

		if (!card || !body) {
			return;
		}

		nextExpanded = !card.classList.contains('is-review-expanded');
		animateReviewBody(card, body, button, nextExpanded);
	});

	window.addEventListener(
		'resize',
		function () {
			scheduleRefresh(productInfo);
		},
		{ passive: true }
	);

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(function () {
			scheduleRefresh(productInfo);
		});
	}

	scheduleRefresh(productInfo);

	productInfo.dataset.sovStoreReviewsPreviewTextExpansionInit = 'true';
}


/*
sov - telemetria gtag immagini di chi ha scelto il prodotto.
*/
function pushSovProductChoiceTelemetry(productInfo, eventName, detail) {
	if (!productInfo || !eventName || typeof window.gtag !== 'function') {
		return;
	}

	window.gtag(
		'event',
		eventName,
		Object.assign(
			{
				product_id:
					productInfo.getAttribute('data-product-id') || '',
				product_handle:
					productInfo.getAttribute('data-product-handle') || '',
				device:
					window.matchMedia('(max-width: 749px)').matches
						? 'mobile'
						: 'desktop',
				since_pageload_s:
					Math.round(performance.now() / 1000),
			},
			detail || {}
		)
	);
}

/*
sov - impression viewport immagini di chi ha scelto il prodotto.
*/
function initSovProductChoiceImagesImpressionTelemetry(productInfo) {
	if (
		!productInfo ||
		productInfo.dataset.sovProductChoiceImagesImpressionTelemetryInit === 'true'
	) {
		return;
	}

	var section =
		productInfo.querySelector(
			'.sov-pdp-product-choice-images-section'
		);

	if (!section) {
		return;
	}

	var imageCount =
		section.querySelectorAll(
			'.sov-product-choice-image-card'
		).length;

	if (!imageCount || typeof IntersectionObserver === 'undefined') {
		return;
	}

	var observer =
		new IntersectionObserver(
			function (entries) {
				var entry = entries[0];

				if (
					!entry ||
					!entry.isIntersecting ||
					entry.intersectionRatio < 0.5
				) {
					return;
				}

				pushSovProductChoiceTelemetry(
					productInfo,
					'pdp_product_choice_impression',
					{
						image_count: imageCount,
					}
				);

				observer.disconnect();
			},
			{
				threshold: [0.5],
			}
		);

	observer.observe(section);

	productInfo.dataset.sovProductChoiceImagesImpressionTelemetryInit =
		'true';
}


/*
sov - lightbox immagini scelte prodotto.
La sorgente tecnica resta indipendente dalla rail visibile e viene condivisa con la gallery principale.
*/
function initSovProductChoiceImagesLightbox(productInfo) {
	if (!productInfo || productInfo.dataset.sovProductChoiceImagesLightboxInit === 'true') {
		return;
	}

	var sourceRoot = productInfo.querySelector('[data-sov-product-choice-source="1"]');
	var overlay = productInfo.querySelector('#sov-modal-pdp_product_choice_image-overlay');
	var stage = overlay ? overlay.querySelector('.sov-product-choice-image-lightbox__stage') : null;
	var modalImage = overlay ? overlay.querySelector('[data-sov-product-choice-lightbox-image]') : null;
	var prevButton = overlay ? overlay.querySelector('[data-sov-product-choice-lightbox-prev]') : null;
	var nextButton = overlay ? overlay.querySelector('[data-sov-product-choice-lightbox-next]') : null;
	var counter = overlay ? overlay.querySelector('[data-sov-product-choice-lightbox-counter]') : null;

	if (!sourceRoot || !overlay || !stage || !modalImage || !prevButton || !nextButton || !counter) {
		return;
	}

	var sourceItems = Array.prototype.slice.call(
		sourceRoot.querySelectorAll('[data-sov-product-choice-source-item="1"]')
	);

	if (!sourceItems.length) {
		return;
	}

	var mobileMediaQuery = window.matchMedia('(max-width: 749px)');
	var currentIndex = -1;
	var mobileRail = null;
	var mobileSlides = [];
	var mobileScrollTimer = 0;

	function normalizeIndex(index) {
		return Math.max(0, Math.min(index, sourceItems.length - 1));
	}

	function updateNavigationState() {
		prevButton.disabled = currentIndex <= 0;
		nextButton.disabled = currentIndex < 0 || currentIndex >= sourceItems.length - 1;
		counter.textContent = currentIndex >= 0
			? (currentIndex + 1) + ' / ' + sourceItems.length
			: '— / ' + sourceItems.length;
	}

	function findNearestMobileSlideIndex() {
		var railCenter;
		var nearestIndex = 0;
		var nearestDistance = Number.POSITIVE_INFINITY;

		if (!mobileRail || !mobileSlides.length) {
			return -1;
		}

		railCenter = mobileRail.scrollLeft + (mobileRail.clientWidth / 2);

		mobileSlides.forEach(function (slide, index) {
			var slideCenter = slide.offsetLeft + (slide.offsetWidth / 2);
			var distance = Math.abs(slideCenter - railCenter);

			if (distance < nearestDistance) {
				nearestDistance = distance;
				nearestIndex = index;
			}
		});

		return nearestIndex;
	}

	function handleMobileScrollSettled() {
		var nextIndex;
		var previousIndex;

		if (!mobileMediaQuery.matches || !overlay.classList.contains('active')) {
			return;
		}

		nextIndex = findNearestMobileSlideIndex();

		if (nextIndex < 0 || nextIndex === currentIndex) {
			return;
		}

		previousIndex = currentIndex;

		if (!renderImage(nextIndex, 'swipe', false)) {
			return;
		}

		pushSovProductChoiceTelemetry(
			productInfo,
			'pdp_product_choice_lightbox_swipe',
			{
				direction: nextIndex > previousIndex ? 'next' : 'prev',
				from_index: previousIndex + 1,
				to_index: currentIndex + 1,
				total: sourceItems.length
			}
		);
	}

	function ensureMobileRail() {
		if (mobileRail) {
			return;
		}

		mobileRail = document.createElement('div');
		mobileRail.className = 'sov-product-choice-image-lightbox__mobile-rail';

		sourceItems.forEach(function (sourceItem, index) {
			var slide = document.createElement('div');
			var image = document.createElement('img');

			slide.className = 'sov-product-choice-image-lightbox__mobile-slide';
			slide.setAttribute('data-sov-product-choice-mobile-index', String(index));

			image.className = 'sov-product-choice-image-lightbox__mobile-image';
			image.src = sourceItem.getAttribute('data-sov-product-choice-image-full') || '';
			image.alt = sourceItem.getAttribute('data-sov-product-choice-image-alt') || '';
			image.loading = 'lazy';
			image.decoding = 'async';

			slide.appendChild(image);
			mobileRail.appendChild(slide);
			mobileSlides.push(slide);
		});

		mobileRail.addEventListener(
			'scroll',
			function () {
				window.clearTimeout(mobileScrollTimer);
				mobileScrollTimer = window.setTimeout(handleMobileScrollSettled, 90);
			},
			{ passive: true }
		);

		stage.appendChild(mobileRail);
	}

	function showMobileSlide(index, behavior) {
		var slide = mobileSlides[index];

		if (!slide) {
			return;
		}

		window.setTimeout(function () {
			slide.scrollIntoView({
				behavior: behavior || 'auto',
				block: 'nearest',
				inline: 'center'
			});
		}, 0);
	}

	function renderImage(index, source, moveMobileRail) {
		var normalizedIndex = normalizeIndex(index);
		var sourceItem = sourceItems[normalizedIndex];
		var fullUrl = sourceItem.getAttribute('data-sov-product-choice-image-full') || '';
		var alt = sourceItem.getAttribute('data-sov-product-choice-image-alt') || '';
		var shouldJumpWithoutAnimation =
			source === 'rail_open' ||
			String(source || '').indexOf('main_gallery') === 0;

		if (!fullUrl) {
			return false;
		}

		currentIndex = normalizedIndex;
		modalImage.alt = alt;

		if (modalImage.getAttribute('src') !== fullUrl) {
			modalImage.setAttribute('src', fullUrl);
		}

		updateNavigationState();

		if (mobileMediaQuery.matches) {
			ensureMobileRail();

			if (moveMobileRail !== false) {
				showMobileSlide(
					currentIndex,
					shouldJumpWithoutAnimation ? 'auto' : 'smooth'
				);
			}
		}

		pushSovProductChoiceTelemetry(
			productInfo,
			'pdp_product_choice_lightbox_image_view',
			{
				index: currentIndex + 1,
				total: sourceItems.length,
				source: source || 'unknown'
			}
		);

		return true;
	}

	function navigate(direction, inputSource) {
		var targetIndex = currentIndex + direction;
		var previousIndex = currentIndex;

		if (targetIndex < 0 || targetIndex >= sourceItems.length) {
			return;
		}

		if (!renderImage(targetIndex, inputSource || 'lightbox', true)) {
			return;
		}

		pushSovProductChoiceTelemetry(
			productInfo,
			'pdp_product_choice_lightbox_nav_click',
			{
				direction: direction < 0 ? 'prev' : 'next',
				from_index: previousIndex + 1,
				to_index: currentIndex + 1,
				total: sourceItems.length,
				input: inputSource || 'caret'
			}
		);
	}

	productInfo.addEventListener(
		'click',
		function (event) {
			var trigger = event.target.closest(
				'[data-sov-product-choice-open="1"], [data-sov-product-choice-source-trigger="1"]'
			);
			var triggerIndex;
			var openSource;
			var isMainGalleryOpen;

			if (!trigger || !productInfo.contains(trigger)) {
				return;
			}

			triggerIndex = parseInt(
				trigger.getAttribute('data-sov-product-choice-image-index'),
				10
			);

			if (!Number.isFinite(triggerIndex)) {
				return;
			}

			openSource =
				trigger.__sovProductChoiceOpenSource ||
				(trigger.hasAttribute('data-sov-product-choice-source-trigger')
					? 'source_trigger'
					: 'rail_open');

			isMainGalleryOpen =
				String(openSource).indexOf('main_gallery') === 0;

			if (!isMainGalleryOpen) {
				pushSovProductChoiceTelemetry(
					productInfo,
					'pdp_product_choice_lightbox_open_click',
					{
						index: triggerIndex + 1,
						total: sourceItems.length,
						source: 'rail'
					}
				);
			}

			renderImage(
				triggerIndex,
				isMainGalleryOpen ? openSource : 'rail_open',
				true
			);
		},
		true
	);

	prevButton.addEventListener('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		navigate(-1, 'caret');
	});

	nextButton.addEventListener('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		navigate(1, 'caret');
	});

	document.addEventListener('keydown', function (event) {
		if (!overlay.classList.contains('active')) {
			return;
		}

		if (event.key === 'ArrowLeft') {
			event.preventDefault();
			navigate(-1, 'keyboard');
			return;
		}

		if (event.key === 'ArrowRight') {
			event.preventDefault();
			navigate(1, 'keyboard');
		}
	});

	mobileMediaQuery.addEventListener('change', function (event) {
		if (!event.matches || !overlay.classList.contains('active') || currentIndex < 0) {
			return;
		}

		ensureMobileRail();
		showMobileSlide(currentIndex, 'auto');
	});

	window.addEventListener('sov:modal:closed', function (event) {
		if (
			!event.detail ||
			event.detail.overlay_id !== 'sov-modal-pdp_product_choice_image-overlay'
		) {
			return;
		}

		window.clearTimeout(mobileScrollTimer);
		modalImage.removeAttribute('src');
		modalImage.alt = '';
		currentIndex = -1;
		updateNavigationState();
	});

	updateNavigationState();
	productInfo.dataset.sovProductChoiceImagesLightboxInit = 'true';
}

/*
sov - immagini Choice a sorpresa nella gallery principale.
La selezione viene rigenerata a ogni caricamento e a ogni cambio variante, mai durante il semplice scroll.
*/
function initSovProductChoiceImagesMainGallerySurprises(productInfo) {
	if (
		!productInfo ||
		productInfo.dataset.sovProductChoiceImagesMainGallerySurprisesInit === 'true'
	) {
		return;
	}

	var gallery = productInfo.querySelector('.sov-gallery');
	var sourceRoot = productInfo.querySelector('[data-sov-product-choice-source="1"]');

	if (
		!gallery ||
		!sourceRoot ||
		gallery.getAttribute('data-sov-product-choice-main-gallery-enabled') !== 'true'
	) {
		return;
	}

	var sourceItems = Array.prototype.slice.call(
		sourceRoot.querySelectorAll('[data-sov-product-choice-source-item="1"]')
	);
	var mobileGalleryMediaQuery = window.matchMedia('(max-width: 900px)');
	var rebuildTimer = 0;
	var impressionObserver = null;
	var lastVariantId = getCurrentVariantId();

	if (!sourceItems.length) {
		return;
	}

	function getCurrentVariantId() {
		var variantInput =
			productInfo.querySelector('#variant-select-main') ||
			productInfo.querySelector('select[name="id"]') ||
			productInfo.querySelector('input[name="id"]');

		return variantInput && variantInput.value
			? String(variantInput.value)
			: '';
	}

	function shuffle(items) {
		var result = items.slice();

		for (var index = result.length - 1; index > 0; index--) {
			var randomIndex = Math.floor(Math.random() * (index + 1));
			var temporary = result[index];

			result[index] = result[randomIndex];
			result[randomIndex] = temporary;
		}

		return result;
	}

	function getSourceIndex(sourceItem) {
		var index = parseInt(
			sourceItem.getAttribute('data-sov-product-choice-image-index'),
			10
		);

		return Number.isFinite(index)
			? index
			: sourceItems.indexOf(sourceItem);
	}

	function resizeChoiceImageUrl(sourceItem, width) {
		var url = sourceItem.getAttribute('data-sov-product-choice-image-full') || '';

		if (/([?&]width=)\d+/i.test(url)) {
			return url.replace(/([?&]width=)\d+/i, '$1' + String(width));
		}

		return url;
	}

	function buildChoiceImageSrcSet(sourceItem) {
		return [480, 750, 1000, 1400]
			.map(function (width) {
				return resizeChoiceImageUrl(sourceItem, width) + ' ' + width + 'w';
			})
			.join(', ');
	}

	function getNativeVignettes() {
		return Array.prototype.slice.call(
			gallery.querySelectorAll(
				'.vignette:not([data-sov-clone="1"]):not([data-sov-product-choice-main-gallery-item="1"])'
			)
		);
	}

	function getVisibleNativeMediaId() {
		if (typeof window.getVisibleMediaInGallery !== 'function') {
			return '';
		}

		var visibleMedia = window.getVisibleMediaInGallery();
		var vignette = visibleMedia ? visibleMedia.closest('.vignette') : null;

		if (
			!vignette ||
			vignette.hasAttribute('data-sov-product-choice-main-gallery-item')
		) {
			return '';
		}

		return vignette.getAttribute('data-media-id') || '';
	}

	function removeGeneratedItemsAndInfiniteClones() {
		if (impressionObserver) {
			impressionObserver.disconnect();
			impressionObserver = null;
		}

		Array.prototype.slice.call(
			gallery.querySelectorAll('[data-sov-product-choice-main-gallery-item="1"]')
		).forEach(function (node) {
			node.remove();
		});

		Array.prototype.slice.call(
			gallery.querySelectorAll('.vignette[data-sov-clone="1"]')
		).forEach(function (node) {
			node.remove();
		});

		gallery.__sovInfiniteBuilt = false;
	}

	function createChoiceImageVignette(sourceItem, token) {
		var sourceIndex = getSourceIndex(sourceItem);
		var alt = sourceItem.getAttribute('data-sov-product-choice-image-alt') || '';
		var originalWidth = parseInt(
			sourceItem.getAttribute('data-sov-product-choice-image-width'),
			10
		);
		var originalHeight = parseInt(
			sourceItem.getAttribute('data-sov-product-choice-image-height'),
			10
		);
		var vignette = document.createElement('div');
		var button = document.createElement('button');
		var backdrop = document.createElement('img');
		var image = document.createElement('img');

		vignette.className = 'vignette sov-product-choice-main-gallery-item sov-product-choice-main-gallery-image-item';
		vignette.setAttribute('data-sov-product-choice-main-gallery-item', '1');
		vignette.setAttribute('data-sov-product-choice-main-gallery-item-kind', 'image');
		vignette.setAttribute('data-sov-product-choice-image-index', String(sourceIndex));
		vignette.setAttribute('data-media-id', token);

		button.type = 'button';
		button.className = 'sov-product-choice-main-gallery-button';
		button.setAttribute('data-sov-product-choice-main-gallery-open', '1');
		button.setAttribute('data-sov-product-choice-image-index', String(sourceIndex));
		button.setAttribute('aria-haspopup', 'dialog');
		button.setAttribute('aria-controls', 'sov-modal-pdp_product_choice_image-overlay');
		button.setAttribute('aria-label', alt);

		backdrop.className = 'sov-product-choice-main-gallery-backdrop';
		backdrop.src = resizeChoiceImageUrl(sourceItem, 800);
		backdrop.alt = '';
		backdrop.loading = 'lazy';
		backdrop.decoding = 'async';
		backdrop.setAttribute('aria-hidden', 'true');

		image.className = 'sov-gallery-image sov-product-choice-main-gallery-image';
		image.src = resizeChoiceImageUrl(sourceItem, 800);
		image.srcset = buildChoiceImageSrcSet(sourceItem);
		image.sizes = '(max-width: 900px) 100vw, 50vw';
		image.alt = alt;
		image.loading = 'lazy';
		image.decoding = 'async';

		if (Number.isFinite(originalWidth) && originalWidth > 0) {
			image.style.setProperty(
				'--sov-product-choice-original-width',
				originalWidth + 'px'
			);
		}

		if (Number.isFinite(originalHeight) && originalHeight > 0) {
			image.style.setProperty(
				'--sov-product-choice-original-height',
				originalHeight + 'px'
			);
		}

		button.appendChild(backdrop);
		button.appendChild(image);
		vignette.appendChild(button);

		return vignette;
	}

	function createChoiceCollageVignette(collageItems, token) {
		if (collageItems.length < 2) {
			return null;
		}

		var firstSourceIndex = 0;
		var collageLabel =
			sourceRoot.getAttribute('data-sov-product-choice-gallery-collage-label') || '';
		var vignette = document.createElement('div');
		var button = document.createElement('button');
		var backdrop = document.createElement('img');
		var grid = document.createElement('span');
		var label = document.createElement('span');

		vignette.className = 'vignette sov-product-choice-main-gallery-item sov-product-choice-main-gallery-collage';
		vignette.setAttribute('data-sov-product-choice-main-gallery-item', '1');
		vignette.setAttribute('data-sov-product-choice-main-gallery-item-kind', 'collage');
		vignette.setAttribute('data-sov-product-choice-image-index', String(firstSourceIndex));
		vignette.setAttribute(
			'data-sov-product-choice-indices',
			collageItems.map(function (sourceItem) {
				return getSourceIndex(sourceItem) + 1;
			}).join(',')
		);
		vignette.setAttribute('data-sov-product-choice-collage-count', String(collageItems.length));
		vignette.setAttribute('data-media-id', token + '-collage');

		button.type = 'button';
		button.className = 'sov-product-choice-main-gallery-button sov-product-choice-main-gallery-collage__button';
		button.setAttribute('data-sov-product-choice-main-gallery-open', '1');
		button.setAttribute('data-sov-product-choice-image-index', String(firstSourceIndex));
		button.setAttribute('aria-haspopup', 'dialog');
		button.setAttribute('aria-controls', 'sov-modal-pdp_product_choice_image-overlay');
		button.setAttribute('aria-label', collageLabel);

		backdrop.className = 'sov-gallery-image sov-product-choice-main-gallery-collage__backdrop';
		backdrop.src = resizeChoiceImageUrl(collageItems[0], 700);
		backdrop.alt = '';
		backdrop.loading = 'lazy';
		backdrop.decoding = 'async';
		backdrop.setAttribute('aria-hidden', 'true');

		grid.className = 'sov-product-choice-main-gallery-collage__grid';
		grid.setAttribute('aria-hidden', 'true');

		collageItems.forEach(function (sourceItem) {
			var tile = document.createElement('span');
			var image = document.createElement('img');

			tile.className = 'sov-product-choice-main-gallery-collage__tile';
			image.className = 'sov-product-choice-main-gallery-collage__image';
			image.src = resizeChoiceImageUrl(sourceItem, 700);
			image.alt = '';
			image.loading = 'lazy';
			image.decoding = 'async';
			tile.appendChild(image);
			grid.appendChild(tile);
		});

		label.className = 'sov-product-choice-main-gallery-collage__label';
		label.textContent = collageLabel;

		button.appendChild(backdrop);
		button.appendChild(grid);
		button.appendChild(label);
		vignette.appendChild(button);

		return vignette;
	}

	function getTelemetryDetail(galleryItem) {
		var galleryPosition = parseInt(
			galleryItem.getAttribute('data-sov-product-choice-main-gallery-position'),
			10
		);
		var sourceIndex = parseInt(
			galleryItem.getAttribute('data-sov-product-choice-image-index'),
			10
		);

		return {
			source: 'main_gallery',
			item_kind: galleryItem.getAttribute('data-sov-product-choice-main-gallery-item-kind') || 'image',
			gallery_position: Number.isFinite(galleryPosition) ? galleryPosition : 0,
			choice_index: Number.isFinite(sourceIndex) ? sourceIndex + 1 : 0,
			choice_indices: galleryItem.getAttribute('data-sov-product-choice-indices') || '',
			choice_image_count: sourceItems.length
		};
	}

	function wireImpressions() {
		if (typeof IntersectionObserver === 'undefined') {
			return;
		}

		impressionObserver = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (
						!entry.isIntersecting ||
						entry.intersectionRatio < 0.5 ||
						entry.target.dataset.sovProductChoiceMainGalleryImpressionSent === 'true'
					) {
						return;
					}

					entry.target.dataset.sovProductChoiceMainGalleryImpressionSent = 'true';
					pushSovProductChoiceTelemetry(
						productInfo,
						'choice_gallery_impression',
						getTelemetryDetail(entry.target)
					);
					impressionObserver.unobserve(entry.target);
				});
			},
			{ threshold: [0.5] }
		);

		Array.prototype.slice.call(
			gallery.querySelectorAll(
				'[data-sov-product-choice-main-gallery-item="1"]:not([data-sov-clone="1"])'
			)
		).forEach(function (galleryItem) {
			impressionObserver.observe(galleryItem);
		});
	}

	function assignGalleryPositions() {
		Array.prototype.slice.call(
			gallery.querySelectorAll('.vignette:not([data-sov-clone="1"])')
		).forEach(function (galleryItem, index) {
			if (galleryItem.hasAttribute('data-sov-product-choice-main-gallery-item')) {
				galleryItem.setAttribute(
					'data-sov-product-choice-main-gallery-position',
					String(index + 1)
				);
			}
		});
	}

	function restoreVisibleNativeMedia(mediaId) {
		if (!mediaId || !window.matchMedia('(max-width: 900px)').matches) {
			return;
		}

		window.requestAnimationFrame(function () {
			var media = gallery.querySelector(
				'.vignette[data-media-id="' + mediaId + '"]:not([data-sov-clone="1"])'
			);

			if (!media) {
				return;
			}

			var previousBehavior = gallery.style.scrollBehavior;
			gallery.style.scrollBehavior = 'auto';
			gallery.scrollLeft = media.offsetLeft;

			window.requestAnimationFrame(function () {
				gallery.style.scrollBehavior = previousBehavior || '';
			});
		});
	}

	function rebuild(reason) {
		var visibleNativeMediaId = getVisibleNativeMediaId();
		var randomizedSources;
		var nativeVignettes;
		var nativeCursor;
		var sourceCursor = 0;
		var token;

		removeGeneratedItemsAndInfiniteClones();

		if (!mobileGalleryMediaQuery.matches) {
			return;
		}

		randomizedSources = shuffle(sourceItems);
		token =
			'sov-choice-main-' +
			String(Date.now()) +
			'-' +
			String(Math.floor(Math.random() * 100000));

		nativeVignettes = getNativeVignettes();

		if (!nativeVignettes.length) {
			return;
		}

		nativeCursor = Math.min(nativeVignettes.length, 2);

		while (
			sourceCursor < randomizedSources.length &&
			nativeCursor <= nativeVignettes.length
		) {
			gallery.insertBefore(
				createChoiceImageVignette(
					randomizedSources[sourceCursor],
					token + '-' + String(sourceCursor)
				),
				nativeVignettes[nativeCursor] || null
			);

			sourceCursor++;
			nativeCursor += 2;
		}

		var collage = createChoiceCollageVignette(
			shuffle(sourceItems).slice(0, Math.min(4, sourceItems.length)),
			token
		);

		if (collage) {
			gallery.appendChild(collage);
		}

		assignGalleryPositions();
		wireImpressions();
		restoreVisibleNativeMedia(visibleNativeMediaId);

		window.requestAnimationFrame(function () {
			window.dispatchEvent(
				new CustomEvent('variantGalleryUpdated', {
					detail: {
						source: 'product_choice_main_gallery_rebuild',
						reason: reason || 'unknown'
					}
				})
			);
		});
	}

	function scheduleRebuild(reason) {
		window.clearTimeout(rebuildTimer);
		rebuildTimer = window.setTimeout(function () {
			rebuildTimer = 0;
			rebuild(reason);
		}, 0);
	}

	productInfo.addEventListener('click', function (event) {
		var button = event.target.closest('[data-sov-product-choice-main-gallery-open="1"]');
		var galleryItem = button
			? button.closest('[data-sov-product-choice-main-gallery-item="1"]')
			: null;
		var sourceIndex = button
			? parseInt(button.getAttribute('data-sov-product-choice-image-index'), 10)
			: NaN;
		var sourceTrigger;

		if (!button || !galleryItem || !gallery.contains(button) || !Number.isFinite(sourceIndex)) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();

		pushSovProductChoiceTelemetry(
			productInfo,
			'choice_gallery_open',
			getTelemetryDetail(galleryItem)
		);

		sourceTrigger = sourceItems[sourceIndex];
		if (!sourceTrigger) {
			return;
		}

		sourceTrigger.__sovProductChoiceOpenSource =
			galleryItem.getAttribute('data-sov-product-choice-main-gallery-item-kind') === 'collage'
				? 'main_gallery_collage'
				: 'main_gallery_image';

		try {
			sourceTrigger.click();
		} finally {
			sourceTrigger.__sovProductChoiceOpenSource = '';
		}
	});

	productInfo.addEventListener('change', function (event) {
		if (!event.target || event.target.name !== 'id') {
			return;
		}

		var nextVariantId = String(event.target.value || '');

		if (!nextVariantId || nextVariantId === lastVariantId) {
			return;
		}

		lastVariantId = nextVariantId;
		scheduleRebuild('variant_change');
	});

	function handleChoiceMainGalleryResponsiveChange() {
		scheduleRebuild(
			mobileGalleryMediaQuery.matches
				? 'enter_mobile'
				: 'enter_desktop'
		);
	}

	if (typeof mobileGalleryMediaQuery.addEventListener === 'function') {
		mobileGalleryMediaQuery.addEventListener(
			'change',
			handleChoiceMainGalleryResponsiveChange
		);
	} else if (typeof mobileGalleryMediaQuery.addListener === 'function') {
		mobileGalleryMediaQuery.addListener(
			handleChoiceMainGalleryResponsiveChange
		);
	}

	rebuild('initial');
	productInfo.dataset.sovProductChoiceImagesMainGallerySurprisesInit = 'true';
}

/*
sov - carousel immagini di chi ha scelto il prodotto

ultimo aggiornamento: 2026-09-14 03:05 europe/rome

prima:
la nuova rail fotografica non disponeva di navigazione carousel client-side.

dopo:
la rail usa la stessa strategia consolidata della preview recensioni:
caret desktop soltanto con overflow reale, scroll a step calcolato dalla
larghezza della card, wheel desktop, scroll nativo touch e ResizeObserver.
*/
function initSovProductChoiceImagesCarousel(productInfo) {
	if (!productInfo || productInfo.dataset.sovProductChoiceImagesCarouselInit === 'true') {
		return;
	}

	var section = productInfo.querySelector('.sov-pdp-product-choice-images-section');
	var payload = section ? section.querySelector('.sov-pdp-product-choice-images-payload') : null;
	var rail = payload ? payload.querySelector('.sov-product-choice-image-list') : null;
	var desktopFinePointer = window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
	var resizeObserver;

	if (!section || !payload || !rail || rail.children.length < 2) {
		return;
	}

	function buildProductChoiceImageCaret(direction) {
		var button = document.createElement('button');

		button.type = 'button';
		button.className =
			'sov-pdp-product-choice-images-caret ' +
			'sov-pdp-product-choice-images-caret--' + direction;

		button.setAttribute(
			'aria-label',
			direction === 'prev'
				? 'immagini precedenti'
				: 'immagini successive'
		);

		button.innerHTML =
			'<svg viewBox="0 -2 20 20" aria-hidden="true" focusable="false">' +
				'<path d="M5.5 7.5L10 12l4.5-4.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>' +
			'</svg>';

		return button;
	}

	var prev = buildProductChoiceImageCaret('prev');
	var next = buildProductChoiceImageCaret('next');

	payload.appendChild(prev);
	payload.appendChild(next);

	function bindProductChoiceImagesMediaQueryChange(mediaQuery, handler) {
		if (typeof mediaQuery.addEventListener === 'function') {
			mediaQuery.addEventListener('change', handler);
			return;
		}

		if (typeof mediaQuery.addListener === 'function') {
			mediaQuery.addListener(handler);
		}
	}

	function productChoiceImagesRailHasOverflow() {
		return rail.scrollWidth - rail.clientWidth > 2;
	}

	function getProductChoiceImagesScrollStep() {
		var firstCard = rail.children.length ? rail.children[0] : null;
		var styles = window.getComputedStyle(rail);
		var gap = parseFloat(styles.columnGap || styles.gap || '0');

		if (firstCard) {
			return Math.max(
				1,
				firstCard.getBoundingClientRect().width + gap
			);
		}

		return Math.max(
			1,
			rail.clientWidth * 0.85
		);
	}

	function updateProductChoiceImagesCaretState() {
		var maxScroll = rail.scrollWidth - rail.clientWidth;
		var railHasOverflow = productChoiceImagesRailHasOverflow();
		var canShowCarets = desktopFinePointer.matches && railHasOverflow;

		section.classList.toggle(
			'has-product-choice-images-carousel-overflow',
			canShowCarets
		);

		section.classList.toggle(
			'has-product-choice-images-rail-overflow',
			railHasOverflow
		);

		section.classList.toggle(
			'is-product-choice-images-rail-at-start',
			rail.scrollLeft <= 1
		);

		section.classList.toggle(
			'is-product-choice-images-rail-at-end',
			rail.scrollLeft >= maxScroll - 1
		);

		prev.hidden = !canShowCarets;
		next.hidden = !canShowCarets;

		if (!canShowCarets) {
			prev.setAttribute('disabled', '');
			next.setAttribute('disabled', '');
			return;
		}

		prev.toggleAttribute(
			'disabled',
			rail.scrollLeft <= 1
		);

		next.toggleAttribute(
			'disabled',
			rail.scrollLeft >= maxScroll - 1
		);
	}

	var productChoiceRailScrollStepsSent =
		{};

	function sendProductChoiceRailScrollDepth() {
		var maxScroll =
			rail.scrollWidth -
			rail.clientWidth;

		if (maxScroll <= 0) {
			return;
		}

		var progress =
			Math.max(
				0,
				Math.min(
					100,
					Math.round(
						rail.scrollLeft /
						maxScroll *
						100
					)
				)
			);

		[25, 50, 75, 100].forEach(function (step) {
			if (
				progress >= step &&
				!productChoiceRailScrollStepsSent[step]
			) {
				productChoiceRailScrollStepsSent[step] =
					true;

				pushSovProductChoiceTelemetry(
					productInfo,
					'pdp_product_choice_rail_scroll',
					{
						step: step,
						image_count:
							rail.children.length,
					}
				);
			}
		});
	}

	function scrollProductChoiceImagesRail(direction) {
		rail.scrollBy({
			left: getProductChoiceImagesScrollStep() * direction,
			behavior: 'smooth',
		});
	}

	prev.addEventListener('click', function () {
		pushSovProductChoiceTelemetry(
			productInfo,
			'pdp_product_choice_rail_caret_click',
			{
				direction: 'prev',
				image_count: rail.children.length,
			}
		);

		scrollProductChoiceImagesRail(-1);
	});

	next.addEventListener('click', function () {
		pushSovProductChoiceTelemetry(
			productInfo,
			'pdp_product_choice_rail_caret_click',
			{
				direction: 'next',
				image_count: rail.children.length,
			}
		);

		scrollProductChoiceImagesRail(1);
	});

	rail.addEventListener(
		'wheel',
		function (event) {
			var maxScroll;
			var delta;
			var isAtStart;
			var isAtEnd;

			if (!desktopFinePointer.matches || !productChoiceImagesRailHasOverflow()) {
				return;
			}

			maxScroll = rail.scrollWidth - rail.clientWidth;
			delta =
				Math.abs(event.deltaX) > Math.abs(event.deltaY)
					? event.deltaX
					: event.deltaY;

			isAtStart = rail.scrollLeft <= 1;
			isAtEnd = rail.scrollLeft >= maxScroll - 1;

			if ((delta < 0 && isAtStart) || (delta > 0 && isAtEnd)) {
				return;
			}

			event.preventDefault();
			rail.scrollLeft += delta;

			window.requestAnimationFrame(
				updateProductChoiceImagesCaretState
			);
		},
		{ passive: false }
	);

	rail.addEventListener(
		'scroll',
		function () {
			updateProductChoiceImagesCaretState();
			sendProductChoiceRailScrollDepth();
		},
		{ passive: true }
	);

	window.addEventListener(
		'resize',
		updateProductChoiceImagesCaretState,
		{ passive: true }
	);

	bindProductChoiceImagesMediaQueryChange(
		desktopFinePointer,
		updateProductChoiceImagesCaretState
	);

	if (typeof ResizeObserver !== 'undefined') {
		resizeObserver = new ResizeObserver(function () {
			window.requestAnimationFrame(
				updateProductChoiceImagesCaretState
			);
		});

		resizeObserver.observe(rail);
		section.__sovProductChoiceImagesCarouselResizeObserver = resizeObserver;
	}

	window.requestAnimationFrame(
		updateProductChoiceImagesCaretState
	);

	productInfo.dataset.sovProductChoiceImagesCarouselInit = 'true';
}


/*
sov - carousel preview recensioni pdp

ultimo aggiornamento: 17/05/2026 11:58 europe/rome

prima:
i caret della preview recensioni usavano classi gallery e venivano nascosti dalle regole
responsive della gallery.

dopo:
la preview recensioni usa caret dedicati, mostrati solo su desktop con puntatore fine
e solo quando la rail ha overflow reale.
*/
function initSovStoreReviewsPreviewCarousel(productInfo) {
	if (!productInfo || productInfo.dataset.sovStoreReviewsPreviewCarouselInit === 'true') {
		return;
	}

	var section = productInfo.querySelector('.sov-pdp-store-reviews-preview-section');
	var payload = section ? section.querySelector('.sov-pdp-store-reviews-preview-payload') : null;
	var rail = payload ? payload.querySelector('.sov-store-review-card-list') : null;
	var desktopFinePointer = window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
	var resizeObserver;

	if (!section || !payload || !rail || rail.children.length < 2) {
		return;
	}

	function buildReviewCaret(direction) {
		var button = document.createElement('button');

		button.type = 'button';
		button.className =
			'sov-pdp-store-reviews-preview-caret ' +
			'sov-pdp-store-reviews-preview-caret--' + direction;
		button.setAttribute('aria-label', direction === 'prev' ? 'previous reviews' : 'next reviews');
		button.innerHTML =
			'<svg viewBox="0 -2 20 20" aria-hidden="true" focusable="false">' +
				'<path d="M5.5 7.5L10 12l4.5-4.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path>' +
			'</svg>';

		return button;
	}

	var prev = buildReviewCaret('prev');
	var next = buildReviewCaret('next');

	payload.appendChild(prev);
	payload.appendChild(next);

	function bindMediaQueryChange(mediaQuery, handler) {
		if (typeof mediaQuery.addEventListener === 'function') {
			mediaQuery.addEventListener('change', handler);
			return;
		}

		if (typeof mediaQuery.addListener === 'function') {
			mediaQuery.addListener(handler);
		}
	}

	function hasOverflow() {
		return rail.scrollWidth - rail.clientWidth > 2;
	}

	function getScrollStep() {
		var firstCard = rail.children.length ? rail.children[0] : null;
		var styles = window.getComputedStyle(rail);
		var gap = parseFloat(styles.columnGap || styles.gap || '0');

		if (firstCard) {
			return Math.max(1, firstCard.getBoundingClientRect().width + gap);
		}

		return Math.max(1, rail.clientWidth * 0.85);
	}

	function updateCaretState() {
		var maxScroll = rail.scrollWidth - rail.clientWidth;
		var railHasOverflow = hasOverflow();
		var canShowCarets = desktopFinePointer.matches && railHasOverflow;

		section.classList.toggle('has-review-carousel-overflow', canShowCarets);
		section.classList.toggle('has-review-rail-overflow', railHasOverflow);
		section.classList.toggle('is-review-rail-at-start', rail.scrollLeft <= 1);
		section.classList.toggle('is-review-rail-at-end', rail.scrollLeft >= maxScroll - 1);
		prev.hidden = !canShowCarets;
		next.hidden = !canShowCarets;

		if (!canShowCarets) {
			prev.setAttribute('disabled', '');
			next.setAttribute('disabled', '');
			return;
		}

		prev.toggleAttribute('disabled', rail.scrollLeft <= 1);
		next.toggleAttribute('disabled', rail.scrollLeft >= maxScroll - 1);
	}

	function scrollReviewRail(direction) {
		rail.scrollBy({
			left: getScrollStep() * direction,
			behavior: 'smooth',
		});
	}

	prev.addEventListener('click', function () {
		scrollReviewRail(-1);
	});

	next.addEventListener('click', function () {
		scrollReviewRail(1);
	});

	rail.addEventListener(
		'wheel',
		function (event) {
			var maxScroll;
			var delta;
			var isAtStart;
			var isAtEnd;

			if (!desktopFinePointer.matches || !hasOverflow()) {
				return;
			}

			maxScroll = rail.scrollWidth - rail.clientWidth;
			delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
			isAtStart = rail.scrollLeft <= 1;
			isAtEnd = rail.scrollLeft >= maxScroll - 1;

			if ((delta < 0 && isAtStart) || (delta > 0 && isAtEnd)) {
				return;
			}

			event.preventDefault();
			rail.scrollLeft += delta;

			window.requestAnimationFrame(updateCaretState);
		},
		{ passive: false }
	);

	rail.addEventListener('scroll', updateCaretState, { passive: true });
	window.addEventListener('resize', updateCaretState, { passive: true });
	bindMediaQueryChange(desktopFinePointer, updateCaretState);

	if (typeof ResizeObserver !== 'undefined') {
		resizeObserver = new ResizeObserver(function () {
			window.requestAnimationFrame(updateCaretState);
		});

		resizeObserver.observe(rail);
		section.__sovStoreReviewsPreviewCarouselResizeObserver = resizeObserver;
	}

	window.requestAnimationFrame(updateCaretState);

	productInfo.dataset.sovStoreReviewsPreviewCarouselInit = 'true';
}

/*
sov - sync aria-expanded trigger modali

ultimo aggiornamento: 2026-03-24  europe/rome

prima:
script inline globale con listener document-level e observer sugli overlay
presenti al load iniziale.

dopo:
funzione esterna singleton globale.
mantiene i listener una sola volta e osserva anche overlay aggiunti dopo.
*/
function initSovModalTriggerAriaExpandedSync(root) {
	var scope = root || document;
	var triggerSelector = 'a[aria-haspopup="dialog"][aria-controls]';
	var globalState = window.__sovModalTriggerAriaExpandedSyncState;

	if (!globalState) {
		globalState = {
			mutationObserver: null,
			treeObserver: null,
			isBound: false,
		};

		window.__sovModalTriggerAriaExpandedSyncState = globalState;
	}

	function setExpandedForOverlay(overlay, expanded) {
		if (!overlay || !overlay.id) {
			return;
		}

		Array.prototype.slice
			.call(document.querySelectorAll(triggerSelector + '[aria-controls="' + overlay.id + '"]'))
			.forEach(function (anchor) {
				anchor.setAttribute('aria-expanded', expanded ? 'true' : 'false');
			});
	}

	function observeOverlay(overlay) {
		if (!overlay || !overlay.id || overlay.dataset.sovAriaExpandedObserved === 'true') {
			return;
		}

		globalState.mutationObserver.observe(overlay, {
			attributes: true,
			attributeFilter: ['class', 'hidden', 'style'],
		});

		overlay.dataset.sovAriaExpandedObserved = 'true';
	}

	function observeOverlaysInScope(scanRoot) {
		if (!scanRoot) {
			return;
		}

		if (
			scanRoot.matches &&
			scanRoot.matches('.sov-modal-overlay[id]')
		) {
			observeOverlay(scanRoot);
		}

		Array.prototype.slice
			.call(scanRoot.querySelectorAll('.sov-modal-overlay[id]'))
			.forEach(observeOverlay);
	}

	if (!globalState.isBound) {
		globalState.isBound = true;

		document.addEventListener(
			'click',
			function (event) {
				var anchor = event.target.closest(triggerSelector);

				if (anchor) {
					anchor.setAttribute('aria-expanded', 'true');
				}
			},
			true
		);

		document.addEventListener(
			'keydown',
			function (event) {
				if (event.key !== 'Enter' && event.key !== ' ') {
					return;
				}

				var anchor = event.target.closest(triggerSelector);

				if (anchor) {
					anchor.setAttribute('aria-expanded', 'true');
				}
			},
			true
		);

		document.addEventListener(
			'click',
			function (event) {
				var closeButton = event.target.closest('.sov-modal-close, .sov-modal-close-mobile');

				if (closeButton) {
					var overlayFromClose = closeButton.closest('.sov-modal-overlay');
					setExpandedForOverlay(overlayFromClose, false);
					return;
				}

				var overlayFromBackdrop =
					event.target &&
					event.target.classList &&
					event.target.classList.contains('sov-modal-overlay')
						? event.target
						: null;

				if (overlayFromBackdrop) {
					setExpandedForOverlay(overlayFromBackdrop, false);
				}
			},
			true
		);

		document.addEventListener('sov:modal:closed', function (event) {
			setExpandedForOverlay(event.target, false);
		});

		globalState.mutationObserver = new MutationObserver(function (mutationList) {
			mutationList.forEach(function (mutation) {
				var target = mutation.target;

				if (!target || !target.classList || !target.id) {
					return;
				}

				if (
					target.classList.contains('sov-modal-overlay') &&
					!target.classList.contains('active')
				) {
					setExpandedForOverlay(target, false);
				}
			});
		});

		globalState.treeObserver = new MutationObserver(function (mutationList) {
			mutationList.forEach(function (mutation) {
				Array.prototype.slice.call(mutation.addedNodes || []).forEach(function (node) {
					if (!node || node.nodeType !== 1) {
						return;
					}

					observeOverlaysInScope(node);
				});
			});
		});

		if (document.body) {
			globalState.treeObserver.observe(document.body, {
				childList: true,
				subtree: true,
			});
		}
	}

	observeOverlaysInScope(scope);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initSovPdpBootstrap, { once: true });
} else {
	initSovPdpBootstrap();
}

document.addEventListener('shopify:section:load', function (event) {
	var scope = event.target || document;
	initSovModalTriggerAriaExpandedSync(scope);
	initSovPdpFeatures(scope);
});

function initSovProductMediaLightbox(productInfo) {
  if (!productInfo || productInfo.dataset.sovMediaLightboxInit === 'true') {
    return;
  }

  var modalId = productInfo.getAttribute('data-product-modal-id');
  var modal = modalId ? document.getElementById(modalId) : null;

  if (!modal) {
    return;
  }

  productInfo.querySelectorAll('.sov-gallery .vignette[data-media-id]').forEach(function (el) {
    el.addEventListener('click', function (ev) {
      ev.preventDefault();

      if (typeof modal.show === 'function') {
        modal.show(el);
      } else {
        modal.setAttribute('open', '');
      }
    });
  });

  productInfo.dataset.sovMediaLightboxInit = 'true';
}
function initSovProductMediaLightboxTelemetry(productInfo) {
  if (!productInfo || productInfo.dataset.sovMediaTelemetryInit === 'true') {
    return;
  }

  var modalId = productInfo.getAttribute('data-product-modal-id');
  var productId = productInfo.getAttribute('data-product-id') || '';
  var productHandle = productInfo.getAttribute('data-product-handle') || '';
  var modalSelector = modalId ? '#' + modalId : '';
  var modal =
    (modalId && document.getElementById(modalId)) ||
    document.querySelector('product-modal, modal-dialog.product-media-modal');

  function pushEvt(name, data) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, data);
    }
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function sinceStart() {
    return Math.round(performance.now() / 1000);
  }

  var openersSelector =
    '.sov-gallery .sov-gallery-image, ' +
    '.sov-gallery .vignette, ' +
    '.product__modal-opener' +
    (modalSelector ? ', [data-modal="' + modalSelector + '"]' : '');

  productInfo.querySelectorAll(openersSelector).forEach(function (el, idx) {
    el.addEventListener(
      'click',
      function () {
        var holder = el.closest('[data-media-id]');
        var mediaId = holder ? holder.getAttribute('data-media-id') : null;

        pushEvt('pdp_media_lightbox_open_click', {
          product_id: productId,
          product_handle: productHandle,
          media_id: mediaId,
          index: idx + 1,
          device: isDesktop() ? 'desktop' : 'mobile',
          since_pageload_s: sinceStart(),
        });
      },
      { capture: true }
    );
  });

  if (!modal) {
    productInfo.dataset.sovMediaTelemetryInit = 'true';
    return;
  }

  var lastOpen = modal.hasAttribute('open');

  new MutationObserver(function () {
    var nowOpen = modal.hasAttribute('open');

    if (nowOpen !== lastOpen) {
      lastOpen = nowOpen;

      pushEvt(nowOpen ? 'pdp_media_lightbox_opened' : 'pdp_media_lightbox_closed', {
        product_id: productId,
        product_handle: productHandle,
        device: isDesktop() ? 'desktop' : 'mobile',
        since_pageload_s: sinceStart(),
      });
    }
  }).observe(modal, {
    attributes: true,
    attributeFilter: ['open'],
  });

  var scroller = modal.querySelector('.product-media-modal__content') || modal;
  var sent = {};

  function onScroll() {
    var max = scroller.scrollHeight - scroller.clientHeight;

    if (max <= 0) {
      return;
    }

    var p = Math.round((scroller.scrollTop / max) * 100);

    [25, 50, 75, 100].forEach(function (step) {
      if (p >= step && !sent[step]) {
        sent[step] = true;

        pushEvt('pdp_media_lightbox_scroll', {
          product_id: productId,
          product_handle: productHandle,
          step: step,
        });
      }
    });
  }

  if (scroller) {
    scroller.addEventListener('scroll', onScroll, { passive: true });
  }

  var closeBtn = modal.querySelector('.product-media-modal__toggle');

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      pushEvt('pdp_media_lightbox_close_click', {
        product_id: productId,
        product_handle: productHandle,
      });
    });
  }

  productInfo.dataset.sovMediaTelemetryInit = 'true';
}

/*
sov - gestione scroll lock gallery e caret prev/next esternalizzati

ultimo aggiornamento: 2026-03-23  europe/rome

prima:
script inline separati nel template prodotto:
- blocco lock-scroll su .sov-gallery-scroll
- blocco caret prev/next su .sov-gallery

dopo:
inizializzazione esterna centralizzata per ogni nodo product-info.
la logica resta scoped al singolo product-info e usa flag dataset per evitare wiring duplicati.

funzionamento:
- initSovGalleryBodyScrollLock:
  controlla lo stato di scroll interno della gallery verticale e aggiunge/rimuove la classe lock-scroll sul body
  quando la gallery può ancora consumare lo scroll oppure quando è arrivata ai limiti utili.

- initSovGalleryCarets:
  abilita i caret prev/next sulla gallery orizzontale solo con viewport <= 900px e puntatore fine,
  calcola la vignetta precedente/successiva rispetto allo scroll corrente,
  aggiorna disabled dei pulsanti e mantiene supporto tastiera.

note operative:
- nessuna dipendenza liquid diretta nel file js esterno
- inizializzazione per istanza product-info
- listener media query compatibili con addEventListener e addListener
*/
function initSovGalleryBodyScrollLock(productInfo) {
	if (!productInfo || productInfo.dataset.sovGalleryBodyScrollLockInit === 'true') {
		return;
	}

	var gallery = productInfo.querySelector('.sov-gallery-scroll');

	if (!gallery) {
		return;
	}

	gallery.addEventListener(
		'wheel',
		function (e) {
			var totalScroll = gallery.scrollHeight - gallery.clientHeight;
			var isAtStart = e.deltaY < 0 && gallery.scrollTop === 0;
			var isAtEnd = e.deltaY > 0 && gallery.scrollTop >= totalScroll;

			if (isAtStart || isAtEnd) {
				document.body.classList.remove('lock-scroll');
			} else {
				document.body.classList.add('lock-scroll');
			}
		},
		{ passive: false }
	);

	productInfo.dataset.sovGalleryBodyScrollLockInit = 'true';
}

function initSovGalleryCarets(productInfo) {
	if (!productInfo || productInfo.dataset.sovGalleryCaretsInit === 'true') {
		return;
	}

	var mql = window.matchMedia('(max-width: 900px)');
	var hasMouse = window.matchMedia('(hover: hover) and (pointer: fine)');
	var gallery = productInfo.querySelector('.sov-gallery');

	if (!gallery) {
		return;
	}

	var prev = gallery.querySelector('.sov-gallery-caret--prev');
	var next = gallery.querySelector('.sov-gallery-caret--next');

	if (!prev || !next) {
		return;
	}

	function getItems() {
		return Array.from(gallery.querySelectorAll('.vignette'));
	}

	function scrollToEl(el) {
		if (!el) {
			return;
		}

		gallery.scrollTo({
			left: el.offsetLeft,
			behavior: 'smooth',
		});
	}

	function findPrev() {
		var x = gallery.scrollLeft;
		var items = getItems();

		return items.filter(function (n) {
			return n.offsetLeft < x - 2;
		}).pop() || null;
	}

	function findNext() {
		var x = gallery.scrollLeft;
		var vw = gallery.clientWidth;
		var items = getItems();

		return (
			items.find(function (n) {
				return n.offsetLeft > x + 2;
			}) ||
			items.find(function (n) {
				return n.offsetLeft >= x + vw - 2;
			}) ||
			null
		);
	}

	function updateDisabled() {
		var max = gallery.scrollWidth - gallery.clientWidth;
		var atStart = gallery.scrollLeft <= 1;
		var atEnd = gallery.scrollLeft >= max - 1;

		prev.toggleAttribute('disabled', atStart || !findPrev());
		next.toggleAttribute('disabled', atEnd || !findNext());
	}

	function onPrevClick() {
		scrollToEl(findPrev());
	}

	function onNextClick() {
		scrollToEl(findNext());
	}

	function onCaretKeydown(e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			e.currentTarget.click();
		}
	}

	function enableCaretsIfNeeded() {
		var shouldEnable = mql.matches && hasMouse.matches;

		if (!shouldEnable) {
			prev.setAttribute('disabled', '');
			next.setAttribute('disabled', '');
			return;
		}

		updateDisabled();
	}

	function bindMediaQueryChange(mq, handler) {
		if (typeof mq.addEventListener === 'function') {
			mq.addEventListener('change', handler);
			return;
		}

		if (typeof mq.addListener === 'function') {
			mq.addListener(handler);
		}
	}

	prev.addEventListener('click', onPrevClick);
	next.addEventListener('click', onNextClick);
	prev.addEventListener('keydown', onCaretKeydown);
	next.addEventListener('keydown', onCaretKeydown);
	gallery.addEventListener('scroll', updateDisabled, { passive: true });

	window.addEventListener(
		'resize',
		function () {
			enableCaretsIfNeeded();
		},
		{ passive: true }
	);

	bindMediaQueryChange(mql, enableCaretsIfNeeded);
	bindMediaQueryChange(hasMouse, enableCaretsIfNeeded);

	setTimeout(function () {
		enableCaretsIfNeeded();
	}, 0);

	productInfo.dataset.sovGalleryCaretsInit = 'true';
}

/*
sov - allineamento indicatori zoom al trigger wishlist su mobile

ultimo aggiornamento: 2026-03-23  europe/rome

prima:
script inline dedicato al posizionamento orizzontale di tutte le .sov-zoom-indicator
rispetto al cuore wishlist nell'area .sov-info-sticky.

dopo:
funzione esterna scoped al singolo product-info.
la routine legge gallery e area info dello stesso product-info, calcola l'allineamento
solo sotto 900px e aggiorna la proprietà right degli indicatori.
fuori dalla soglia mobile ripristina il valore inline.

funzionamento:
- cerca .sov-gallery nel product-info corrente
- raccoglie tutte le .sov-zoom-indicator della gallery
- su mobile cerca il trigger wishlist dentro .sov-info-sticky
- se il trigger esiste usa il suo centro orizzontale come riferimento
- se il trigger non esiste usa il bordo destro utile di .sov-info-sticky come fallback
- limita il valore right con clamp per evitare overflow
- reagisce a load, resize, orientationchange, section load, page load,
  cambi media, aggiornamenti gallery variante e resize della gallery
- usa requestanimationframe per accorpare aggiornamenti ravvicinati
- usa un flag dataset per evitare binding duplicati
*/
function initSovZoomIndicatorAlignment(productInfo) {
	if (!productInfo || productInfo.dataset.sovZoomIndicatorAlignmentInit === 'true') {
		return;
	}

	var mq = window.matchMedia('(max-width: 900px)');
	var raf = 0;
	var gallery = productInfo.querySelector('.sov-gallery');

	if (!gallery) {
		return;
	}

	function q(selector, root) {
		return (root || productInfo).querySelector(selector);
	}

	function qa(selector, root) {
		return Array.prototype.slice.call((root || productInfo).querySelectorAll(selector));
	}

	function schedule() {
		if (raf) {
			return;
		}

		raf = window.requestAnimationFrame(function () {
			raf = 0;
			placeAll();
		});
	}

	function placeAll() {
		try {
			var icons = qa('.sov-gallery .sov-zoom-indicator');

			if (!icons.length) {
				return;
			}

			if (!mq.matches) {
				icons.forEach(function (icon) {
					icon.style.right = '';
				});
				return;
			}

			var heart = q(
				'.sov-info-sticky [data-wishlist], ' +
					'.sov-info-sticky .wishlist, ' +
					'.sov-info-sticky .wishlist-button, ' +
					'.sov-info-sticky .icon-heart, ' +
					'.sov-info-sticky [aria-label*="wish" i]'
			);

			var gr = gallery.getBoundingClientRect();
			var iconW = icons[0].getBoundingClientRect().width || 20;

			var heartCenter = (function () {
				if (heart) {
					var hr = heart.getBoundingClientRect();
					return hr.left + hr.width / 2;
				}

				var info = q('.sov-info-sticky');

				if (!info) {
					return gr.right - 12;
				}

				var ir = info.getBoundingClientRect();
				var pr = parseFloat(window.getComputedStyle(info).paddingRight) || 0;

				return ir.right - pr - iconW / 2;
			})();

			var desired = Math.round(gr.right - heartCenter - iconW / 2) + 1;
			var min = 8;
			var max = Math.max(min, gr.width - iconW - min);

			desired = Math.max(min, Math.min(desired, max));

			icons.forEach(function (icon) {
				icon.style.right = desired + 'px';
			});
		} catch (e) {}
	}

	function bindWindowEvent(eventName) {
		window.addEventListener(eventName, schedule, { passive: true });
	}

	function bindDocumentEvent(eventName, useCapture) {
		document.addEventListener(eventName, schedule, useCapture ? true : false);
	}

	function bindMediaQueryChange(mediaQueryList, handler) {
		if (typeof mediaQueryList.addEventListener === 'function') {
			mediaQueryList.addEventListener('change', handler);
			return;
		}

		if (typeof mediaQueryList.addListener === 'function') {
			mediaQueryList.addListener(handler);
		}
	}

	['load', 'resize', 'orientationchange'].forEach(bindWindowEvent);
	['shopify:section:load', 'page:load'].forEach(function (eventName) {
		bindDocumentEvent(eventName, false);
	});

	bindDocumentEvent('product-media:after-change', true);
	window.addEventListener('variantGalleryUpdated', schedule, { passive: true });

	qa('img,video', gallery).forEach(function (el) {
		var eventName = el.tagName === 'VIDEO' ? 'loadeddata' : 'load';
		el.addEventListener(eventName, schedule, { once: true, passive: true });
	});

	if ('ResizeObserver' in window) {
		var resizeObserver = new ResizeObserver(schedule);
		resizeObserver.observe(gallery);
	}

	bindMediaQueryChange(mq, schedule);

	schedule();

	productInfo.dataset.sovZoomIndicatorAlignmentInit = 'true';
}
/*
sov - ga4 telemetry video pdp esternalizzata

ultimo aggiornamento: 2026-03-23  europe/rome

prima:
script inline dedicato alla telemetria dei video dentro .sov-gallery,
con lettura metadati prodotto da window.meta.product e wiring globale su document.

dopo:
funzione esterna scoped al singolo product-info.
i metadati prodotto vengono letti dal dataset del product-info e il wiring viene applicato
solo ai video della gallery appartenente a quella istanza.

funzionamento:
- intercetta i video dentro .sov-gallery
- invia eventi ga4 prefissati con pdp_
- traccia impression, play, pause, complete, mute, unmute, seek
- traccia quartili 25/50/75 tramite timeupdate
- traccia visibilità video con intersectionobserver
- evita doppio wiring su ogni video con flag __sov_video_wired
- consente re-scan dopo section load e aggiornamenti media

eventi emessi:
- pdp_video_impression
- pdp_video_start
- pdp_video_play
- pdp_video_pause
- pdp_video_complete
- pdp_video_mute
- pdp_video_unmute
- pdp_video_seek
- pdp_video_quartile
- pdp_video_visibility
*/
function initSovPdpVideoTelemetry(productInfo) {
	if (!productInfo || productInfo.dataset.sovPdpVideoTelemetryInit === 'true') {
		return;
	}

	function qa(selector, root) {
		return Array.prototype.slice.call((root || productInfo).querySelectorAll(selector));
	}

	function hasGtag() {
		return typeof window.gtag === 'function';
	}

	function send(name, params) {
		if (hasGtag()) {
			window.gtag('event', 'pdp_' + name, params);
		}
	}

	function setupVideo(videoEl, idx) {
		if (!videoEl || videoEl.__sov_video_wired) {
			return;
		}

		videoEl.__sov_video_wired = true;

		var wrap = videoEl.closest('[data-media-id]');
		var videoId = wrap ? wrap.getAttribute('data-media-id') : null;
		var base = {
			video_id: videoId,
			gallery_index: idx,
			product_id: productInfo.getAttribute('data-product-id') || null,
			product_handle: productInfo.getAttribute('data-product-handle') || null,
			autoplay: !!videoEl.autoplay,
			muted: !!videoEl.muted,
			loop: !!videoEl.loop,
		};

		var state = {
			started: false,
			q25: false,
			q50: false,
			q75: false,
			visible: null,
			duration: 0,
		};

		function onTimeUpdate() {
			if (!state.duration) {
				state.duration = videoEl.duration || 0;
			}

			var currentTime = videoEl.currentTime || 0;

			if (!state.started && currentTime > 0.2) {
				state.started = true;
				send(
					'video_start',
					Object.assign({}, base, {
						current_time: currentTime,
						duration: state.duration,
					})
				);
			}

			var progress = state.duration ? currentTime / state.duration : 0;

			if (!state.q25 && progress >= 0.25) {
				state.q25 = true;
				send(
					'video_quartile',
					Object.assign({}, base, {
						quartile: 25,
						current_time: currentTime,
						duration: state.duration,
					})
				);
			}

			if (!state.q50 && progress >= 0.5) {
				state.q50 = true;
				send(
					'video_quartile',
					Object.assign({}, base, {
						quartile: 50,
						current_time: currentTime,
						duration: state.duration,
					})
				);
			}

			if (!state.q75 && progress >= 0.75) {
				state.q75 = true;
				send(
					'video_quartile',
					Object.assign({}, base, {
						quartile: 75,
						current_time: currentTime,
						duration: state.duration,
					})
				);
			}
		}

		videoEl.addEventListener(
			'loadedmetadata',
			function () {
				state.duration = videoEl.duration || 0;
				send('video_impression', Object.assign({}, base));
			},
			{ once: true, passive: true }
		);

		videoEl.addEventListener(
			'play',
			function () {
				send(
					'video_play',
					Object.assign({}, base, {
						current_time: videoEl.currentTime || 0,
					})
				);
			},
			{ passive: true }
		);

		videoEl.addEventListener(
			'pause',
			function () {
				send(
					'video_pause',
					Object.assign({}, base, {
						current_time: videoEl.currentTime || 0,
					})
				);
			},
			{ passive: true }
		);

		videoEl.addEventListener(
			'ended',
			function () {
				send(
					'video_complete',
					Object.assign({}, base, {
						duration: videoEl.duration || 0,
					})
				);
			},
			{ passive: true }
		);

		videoEl.addEventListener(
			'volumechange',
			function () {
				send(
					videoEl.muted ? 'video_mute' : 'video_unmute',
					Object.assign({}, base, {
						volume: videoEl.volume,
					})
				);
			},
			{ passive: true }
		);

		videoEl.addEventListener(
			'seeked',
			function () {
				send(
					'video_seek',
					Object.assign({}, base, {
						current_time: videoEl.currentTime || 0,
					})
				);
			},
			{ passive: true }
		);

		videoEl.addEventListener('timeupdate', onTimeUpdate, { passive: true });

		if ('IntersectionObserver' in window) {
			var io = new IntersectionObserver(
				function (entries) {
					var entry = entries[0];
					var visible = !!(entry && entry.intersectionRatio >= 0.5);

					if (visible !== state.visible) {
						state.visible = visible;
						send(
							'video_visibility',
							Object.assign({}, base, {
								visible: visible ? 1 : 0,
							})
						);
					}
				},
				{ threshold: [0, 0.5, 1] }
			);

			io.observe(videoEl);
		}
	}

	function wireAllVideos() {
		qa('.sov-gallery video').forEach(function (videoEl, index) {
			setupVideo(videoEl, index);
		});
	}

	function bindDocumentEvent(eventName, useCapture) {
		document.addEventListener(
			eventName,
			function () {
				wireAllVideos();
			},
			useCapture ? true : false
		);
	}

	wireAllVideos();
	bindDocumentEvent('shopify:section:load', false);
	bindDocumentEvent('product-media:after-change', true);

	productInfo.dataset.sovPdpVideoTelemetryInit = 'true';
}
/*
sov - telemetria breadcrumb pdp esternalizzata

ultimo aggiornamento: 2026-03-23  europe/rome

prima:
script inline con runtime liquid diretto per product_id, product_handle e variant_id.

dopo:
funzione esterna scoped al singolo product-info.
product_id e product_handle vengono letti dal dataset del product-info.
variant_id viene letto a runtime dal campo variante corrente del form prodotto,
così il dato resta aggiornato anche dopo i cambi variante.

funzionamento:
- intercetta i click sui link breadcrumb con data-analytics="pdp-breadcrumb"
- costruisce il payload analytics con livello, testo, url e category id
- invia pdp_breadcrumb_click a gtag quando disponibile
- emette anche l'evento custom storeofvalues:pdp:breadcrumb_click
- evita doppio wiring tramite flag dataset sul singolo link
*/
function initSovPdpBreadcrumbTelemetry(productInfo) {
	if (!productInfo || productInfo.dataset.sovPdpBreadcrumbTelemetryInit === 'true') {
		return;
	}

	var links = productInfo.querySelectorAll('.sov-breadcrumb-inline a[data-analytics="pdp-breadcrumb"]');

	if (!links || links.length === 0) {
		return;
	}

	function getCurrentVariantId() {
		var variantInput =
			productInfo.querySelector('product-form form input[name="id"]') ||
			productInfo.querySelector('form[action*="/cart/add"] input[name="id"]') ||
			productInfo.querySelector('input[name="id"]');

		return variantInput ? variantInput.value || '' : '';
	}

	links.forEach(function (link) {
		if (link.dataset.sovBreadcrumbTelemetryWired === 'true') {
			return;
		}

		link.addEventListener('click', function () {
			var level = link.getAttribute('data-bc-level') || '';
			var categoryId = link.getAttribute('data-category-id') || '';
			var text = (link.textContent || '').trim();
			var href = link.getAttribute('href') || '';

			var payload = {
				event_category: 'pdp_navigation',
				event_label: text,
				breadcrumb_level: level,
				breadcrumb_text: text,
				breadcrumb_url: href,
				breadcrumb_category_id: categoryId,
				product_id: productInfo.getAttribute('data-product-id') || '',
				product_handle: productInfo.getAttribute('data-product-handle') || '',
				variant_id: getCurrentVariantId(),
			};

			if (typeof window.gtag === 'function') {
				window.gtag('event', 'pdp_breadcrumb_click', payload);
			}

			if (typeof window.CustomEvent === 'function') {
				window.dispatchEvent(
					new CustomEvent('storeofvalues:pdp:breadcrumb_click', {
						detail: payload,
					})
				);
			}
		});

		link.dataset.sovBreadcrumbTelemetryWired = 'true';
	});

	productInfo.dataset.sovPdpBreadcrumbTelemetryInit = 'true';
}

/*
sov - allineamento verticale caret gallery rispetto al centro della gallery

ultimo aggiornamento: 2026-03-23  europe/rome

prima:
script inline isolato che centrava verticalmente i caret prev/next della gallery
calcolando il top assoluto rispetto all'offsetParent.

dopo:
funzione esterna scoped al singolo product-info.
la routine forza position absolute sui caret, ricalcola il top al centro della gallery
e aggiorna la posizione su resize, scroll e cambi dimensionali della gallery.

funzionamento:
- cerca .sov-gallery e i due caret nello stesso product-info
- forza position absolute inline per proteggere il comportamento da override css
- calcola il centro verticale della gallery nel sistema di riferimento dell'offsetParent
- applica top con !important ai due caret
- reagisce a resize, scroll, resizeobserver e load/loadeddata di immagini e video
- usa requestanimationframe per accorpare i ricalcoli
- evita binding duplicati con flag dataset
*/

function initSovGalleryCaretVerticalAlignment(productInfo) {
	if (!productInfo || productInfo.dataset.sovGalleryCaretVerticalAlignmentInit === 'true') {
		return;
	}

	var gallery = productInfo.querySelector('.sov-gallery');
	var prev = productInfo.querySelector('.sov-gallery-caret--prev');
	var next = productInfo.querySelector('.sov-gallery-caret--next');
	var rafId = 0;

	if (!gallery || !prev || !next) {
		return;
	}

	prev.style.position = 'absolute';
	next.style.position = 'absolute';

	function placeTop() {
		var galleryRect = gallery.getBoundingClientRect();
		var galleryHeight = gallery.clientHeight || galleryRect.height || 0;
		var offsetParent = prev.offsetParent || document.documentElement;
		var offsetParentRect = offsetParent.getBoundingClientRect();
		var deltaTop = galleryRect.top - offsetParentRect.top;
		var topPx = Math.round(deltaTop + galleryHeight / 2);

		prev.style.setProperty('top', topPx + 'px', 'important');
		next.style.setProperty('top', topPx + 'px', 'important');

		prev.setAttribute('data-top', String(topPx));
		next.setAttribute('data-top', String(topPx));
	}

	function schedule() {
		if (rafId) {
			return;
		}

		rafId = window.requestAnimationFrame(function () {
			rafId = 0;
			placeTop();
		});
	}

	window.addEventListener('resize', schedule, { passive: true });
	window.addEventListener('scroll', schedule, { passive: true });

	if ('ResizeObserver' in window) {
		var resizeObserver = new ResizeObserver(schedule);
		resizeObserver.observe(gallery);
	}

	Array.prototype.slice.call(gallery.querySelectorAll('img,video')).forEach(function (el) {
		var eventName = el.tagName === 'VIDEO' ? 'loadeddata' : 'load';
		el.addEventListener(eventName, schedule, { once: true, passive: true });
	});

	schedule();

	productInfo.dataset.sovGalleryCaretVerticalAlignmentInit = 'true';
}
/*
sov - routing bundle mega offer

ultimo aggiornamento: 2026-03-31 europe/rome

prima:
nessun cta dedicato per il flusso mega offer.
il bottone sticky continuava a comportarsi come submit diretto del form.

dopo:
nuovo bottone routerizzato in pdp che apre la modale bundle.
sticky intercettato solo quando il prodotto ha bundle mega offer attivo.
il bottone atc nativo nella colonna principale resta intatto.
*/
function initSovBundleMegaOfferRouting(productInfo) {
	if (!productInfo || productInfo.dataset.sovBundleMegaOfferRoutingInit === 'true') {
		return;
	}

	productInfo.dataset.sovBundleMegaOfferRoutingInit = 'true';

	if (productInfo.getAttribute('data-sov-bundle-mega-offer') !== 'true') {
		return;
	}

	var routerButtons = Array.prototype.slice.call(
		productInfo.querySelectorAll('[data-sov-bundle-router-open="1"]')
	);
	var stickyButton = productInfo.querySelector('#sovStickyAtcBtn');

	function getVariantId() {
		var select =
			productInfo.querySelector('#variant-select-main') ||
			productInfo.querySelector('select[name="id"]');

		if (select && select.value) {
			return String(select.value);
		}

		return '';
	}

	function openBundle(trigger, source) {
		if (!window.SovBundleEngine || typeof window.SovBundleEngine.openFromTrigger !== 'function') {
			return false;
		}

		var opened = window.SovBundleEngine.openFromTrigger(trigger, {
			playRevealSequence: true,
			source: source || ''
		});

		if (opened && typeof window.gtag === 'function') {
			window.gtag('event', 'pdp_bundle_modal_open', {
				event_category: 'bundle',
				open_source: source || '',
				product_id: productInfo.getAttribute('data-product-id') || '',
				product_handle: productInfo.getAttribute('data-product-handle') || '',
				variant_id: getVariantId(),
				page_path: window.location.pathname || ''
			});
		}

		return opened;
	}

	routerButtons.forEach(function (buttonNode) {
		if (buttonNode.dataset.sovBundleRouterBound === 'true') {
			return;
		}

		buttonNode.addEventListener('click', function (event) {
			event.preventDefault();
			event.stopPropagation();
			openBundle(buttonNode, 'pdp_router_button');
		});

		buttonNode.dataset.sovBundleRouterBound = 'true';
	});

	if (stickyButton && !stickyButton.__sovBundleStickyIntercept) {
		stickyButton.__sovBundleStickyIntercept = true;

		stickyButton.addEventListener(
			'click',
			function (event) {
				if (stickyButton.disabled) {
					return;
				}

				event.preventDefault();
				event.stopPropagation();
				openBundle(stickyButton, 'sticky_atc');
			},
			true
		);
	}
}
/*
sov - telemetria intent add to cart pdp

ultimo aggiornamento: 2026-03-24  europe/rome

prima:
script inline iife con riferimenti liquid diretti a product.id e product.handle
e wiring globale sul form acquisto principale.

dopo:
funzione esterna scoped al singolo product-info.
product_id e product_handle vengono letti dal dataset del product-info.
form, bottone e variante vengono letti a runtime nello scope della pdp.

funzionamento:
- intercetta hover del bottone add to cart solo su pointer fine
- intercetta click sul bottone e submit del form
- invia eventi gtag con metadati prodotto e variante correnti
- evita doppio wiring tramite flag dataset sul product-info e flag sui nodi form/bottone
*/
function initSovPdpAddToCartIntentTelemetry(productInfo) {
	if (!productInfo || productInfo.dataset.sovPdpAddToCartIntentTelemetryInit === 'true') {
		return;
	}

	function hasGtag() {
		return typeof window.gtag === 'function';
	}

	function getForm() {
		return (
			productInfo.querySelector('#sov-buy-form') ||
			productInfo.querySelector('form[id="sov-buy-form"]') ||
			productInfo.querySelector('product-form form') ||
			productInfo.querySelector('form[action*="/cart/add"]')
		);
	}

	function getVariantId(form) {
		var select =
			productInfo.querySelector('#variant-select-main') ||
			productInfo.querySelector('select[name="id"]') ||
			document.getElementById('variant-select-main');

		if (select && select.value) {
			return String(select.value);
		}

		var idInput = form ? form.querySelector('[name="id"]') : null;

		if (idInput && idInput.value) {
			return String(idInput.value);
		}

		return '';
	}

	function send(eventName, extra) {
		if (!hasGtag()) {
			return;
		}

		var form = getForm();
		var payload = Object.assign(
			{
				event_category: 'pdp_intent',
				product_id: productInfo.getAttribute('data-product-id') || '',
				product_handle: productInfo.getAttribute('data-product-handle') || '',
				variant_id: getVariantId(form),
				page_path: window.location.pathname || '',
			},
			extra || {}
		);

		window.gtag('event', eventName, payload);
	}

	function wire() {
		var form = getForm();

		if (!form) {
			return;
		}

		var btn =
			form.querySelector('button[type="submit"]') ||
			form.querySelector('button[name="add"]') ||
			form.querySelector('.product-form__submit');

		if (!btn) {
			return;
		}

		if (!btn.__sovHoverWired) {
			btn.__sovHoverWired = true;

			var hoverSent = false;
			var finePointer = false;

			try {
				finePointer =
					typeof window.matchMedia === 'function' &&
					window.matchMedia('(hover: hover) and (pointer: fine)').matches;
			} catch (e) {}

			if (finePointer) {
				btn.addEventListener(
					'mouseenter',
					function () {
						if (hoverSent) {
							return;
						}

						hoverSent = true;

						send('pdp_add_to_cart_hover', {
							button_text: (btn.textContent || '').trim().slice(0, 80),
						});
					},
					{ passive: true }
				);
			}

			btn.addEventListener(
				'click',
				function () {
					send('pdp_add_to_cart_click', {
						button_text: (btn.textContent || '').trim().slice(0, 80),
					});
				},
				true
			);
		}

		if (!form.__sovSubmitWired) {
			form.__sovSubmitWired = true;

			form.addEventListener(
				'submit',
				function () {
					send('pdp_add_to_cart_submit', {});
				},
				true
			);
		}
	}

	wire();

	productInfo.dataset.sovPdpAddToCartIntentTelemetryInit = 'true';
}

/*
sov - bottone acquisto originale sticky mobile configurabile

ultimo aggiornamento: 2026-06-20 10:58 europe/rome

prima:
le modalità original_sticky e original_sticky_price erano gestite solo tramite position sticky
css. in mobile, la presenza di antenati con overflow e il layout PDP rendevano il comportamento
non affidabile. il prezzo nel bottone veniva aggiornato solo durante il cambio variante.

dopo:
le modalità original_sticky e original_sticky_price vengono gestite da un controller mobile
dedicato. il blocco reale .buy-buttons-wrapper diventa fixed sotto l'header quando raggiunge
la soglia superiore, resta nel form originale, usa un placeholder anti-jump e sincronizza il
prezzo leggendo il blocco prezzo reale della PDP.
*/
function initSovOriginalMobileAtcButtonMode(productInfo) {
	if (!productInfo || productInfo.dataset.sovOriginalMobileAtcButtonModeInit === 'true') {
		return;
	}

	var wrapper = productInfo.querySelector(
		'.buy-buttons-wrapper[data-sov-atc-button-mode="original_sticky"], ' +
		'.buy-buttons-wrapper[data-sov-atc-button-mode="original_sticky_price"]'
	);

	if (!wrapper) {
		return;
	}

	var mode = wrapper.getAttribute('data-sov-atc-button-mode') || '';

	if (mode !== 'original_sticky' && mode !== 'original_sticky_price') {
		return;
	}

	var mobileMediaQuery = window.matchMedia('(max-width: 900px)');
	var placeholder = document.createElement('div');
	var rafId = 0;
	var originalMobileAtcTouchScrollFrameId = 0;
	var priceMutationObserver = null;
	var layoutResizeObserver = null;
	var originalMobileAtcAnchorTop = 0;
	var originalMobileAtcAnchorHeight = 0;
	var originalMobileAtcAnchorBottom = 0;
	var originalMobileAtcStickyPlacement = '';
	var originalMobileAtcStickyHysteresisPx = 0;
	var originalMobileAtcStickyDock = null;
	var originalMobileAtcProductFormHost = wrapper.querySelector(
		'product-form.form-buy-button, product-form'
	);
	var originalMobileAtcAcceleratedCheckoutStatic = wrapper.querySelector(
		'.sov-accelerated-checkout-static'
	);
	placeholder.className = 'sov-original-atc-sticky-placeholder';
	placeholder.setAttribute('aria-hidden', 'true');

	function ensureOriginalMobileAtcStickyDock() {
		var existingDock;
		var stickyTarget;
		var dock;
		var parentNode;

		existingDock = wrapper.querySelector(
			'.sov-original-atc-sticky-dock'
		);

		if (existingDock) {
			if (
				!placeholder.isConnected &&
				existingDock.parentNode
			) {
				existingDock.parentNode.insertBefore(
					placeholder,
					existingDock
				);
			}

			return existingDock;
		}

		stickyTarget =
			wrapper.querySelector('.product-form__buttons') ||
			wrapper.querySelector('.sov-bundle-router-btn');

		if (!stickyTarget || !stickyTarget.parentNode) {
			return null;
		}

		parentNode = stickyTarget.parentNode;

		dock = document.createElement('div');
		dock.className =
			'sov-original-atc-sticky-dock';

		parentNode.insertBefore(
			placeholder,
			stickyTarget
		);

		parentNode.insertBefore(
			dock,
			stickyTarget
		);

		dock.appendChild(
			stickyTarget
		);

		return dock;
	}

	originalMobileAtcStickyDock = ensureOriginalMobileAtcStickyDock();

	function bindMediaQueryChange(mediaQuery, handler) {
		if (typeof mediaQuery.addEventListener === 'function') {
			mediaQuery.addEventListener('change', handler);
			return;
		}

		if (typeof mediaQuery.addListener === 'function') {
			mediaQuery.addListener(handler);
		}
	}

	function getHeaderOffset() {
		var header = document.querySelector('.header-wrapper');
		var fallbackRaw = window
			.getComputedStyle(document.documentElement)
			.getPropertyValue('--header-height')
			.trim();
		var fallback = parseInt(fallbackRaw, 10);

		if (Number.isNaN(fallback) || fallback <= 0) {
			fallback = header ? Math.round(header.getBoundingClientRect().height) : 0;
		}

		if (!header) {
			return fallback;
		}

		var headerRect = header.getBoundingClientRect();

		return Math.max(
			0,
			Math.round(Math.min(headerRect.bottom, fallback))
		);
	}

	function syncStickyTopOffsetVar() {
		document.documentElement.style.setProperty(
			'--sov-sticky-top-offset',
			getHeaderOffset() + 'px'
		);
	}

	function getOriginalMobileAtcStickyGapPx() {
		var rawGap = window
			.getComputedStyle(wrapper)
			.getPropertyValue('--sov-original-atc-sticky-gap')
			.trim();

		var parsedGap = parseFloat(rawGap);

		if (Number.isNaN(parsedGap)) {
			return 10;
		}

		return Math.max(0, parsedGap);
	}

	function isElementVisible(element) {
		var style;

		if (!element) {
			return false;
		}

		style = window.getComputedStyle(element);

		return (
			style.display !== 'none' &&
			style.visibility !== 'hidden' &&
			element.getClientRects().length > 0
		);
	}

	function getFirstVisibleText(selectorList, root) {
		var index;
		var node;
		var text;

		for (index = 0; index < selectorList.length; index++) {
			node = root.querySelector(selectorList[index]);

			if (!isElementVisible(node)) {
				continue;
			}

			text = (node.textContent || '').replace(/\s+/g, ' ').trim();

			if (text) {
				return text;
			}
		}

		return '';
	}

	function getVisiblePdpPriceText() {
		var priceRoot =
			productInfo.querySelector('.sov-info-sticky .price') ||
			productInfo.querySelector('.product__info-container .price') ||
			productInfo.querySelector('.price');

		if (!priceRoot) {
			return '';
		}

		return getFirstVisibleText(
			[
				'.price-line-first .price-now',
				'.price-line-second .price-item--regular',
				'.price-item--sale.price-final',
				'.price__sale .price-item--sale',
				'.price__regular .price-item--regular',
				'.price-item--regular:not(.has-coupon-applied)',
				'.price-value'
			],
			priceRoot
		);
	}

	function getCurrentVariantIdForOriginalButtonPrice() {
		var select =
			productInfo.querySelector('#variant-select-main') ||
			productInfo.querySelector('select[name="id"]');

		var input =
			productInfo.querySelector('input[type="hidden"][name="id"]') ||
			productInfo.querySelector('input[name="id"]');

		if (select && select.value) {
			return String(select.value);
		}

		if (input && input.value) {
			return String(input.value);
		}

		return '';
	}

	function getVariantPriceTextForOriginalButton() {
		var configScript = productInfo.querySelector('.sov-variant-state-json');
		var currentVariantId = getCurrentVariantIdForOriginalButtonPrice();
		var config;
		var variants;
		var index;
		var variant;

		if (!configScript || !currentVariantId) {
			return '';
		}

		try {
			config = JSON.parse(configScript.textContent || '{}');
		} catch (error) {
			return '';
		}

		variants = Array.isArray(config.variants) ? config.variants : [];

		for (index = 0; index < variants.length; index++) {
			variant = variants[index];

			if (String(variant.id) !== currentVariantId) {
				continue;
			}

			return variant.price || '';
		}

		return '';
	}

	function ensurePriceMarkupInsideOriginalButton() {
		/*
		  sov — preserva markup prezzo server-side del bottone ATC
		  ultimo aggiornamento: 2026-06-20 11:25 europe/rome

		  prima:
		  il controller poteva ricostruire il contenuto del bottone via JavaScript,
		  eliminando il markup Liquid dedicato al prezzo e alla valuta.

		  dopo:
		  la struttura del prezzo resta generata da sov-atc-button-price.liquid.
		  JavaScript aggiorna solo il valore numerico già presente nel markup.
		*/
	}

	function syncPriceInsideOriginalButton() {
		var priceValueNode;
		var priceText;

		if (mode !== 'original_sticky_price') {
			return;
		}

		if (wrapper.getAttribute('data-sov-price-sync') === '0') {
			return;
		}

		priceValueNode = wrapper.querySelector(
			'[data-sov-atc-button-price-value], .sov-atc-button-with-price__price-value'
		);

		if (!priceValueNode) {
			return;
		}

		priceText = getVariantPriceTextForOriginalButton();

		if (!priceText) {
			return;
		}

		priceValueNode.textContent = priceText;
	}

	function lockOriginalMobileAtcProductFormNaturalHeight() {
		var naturalProductFormHeight;

		if (
			!originalMobileAtcProductFormHost ||
			!originalMobileAtcAcceleratedCheckoutStatic ||
			wrapper.classList.contains('is-sov-original-atc-sticky-active')
		) {
			return;
		}

		naturalProductFormHeight = Math.ceil(
			originalMobileAtcProductFormHost
				.getBoundingClientRect()
				.height
		);

		if (!naturalProductFormHeight || naturalProductFormHeight <= 0) {
			return;
		}

		originalMobileAtcProductFormHost.style.setProperty(
			'--sov-original-atc-product-form-natural-height',
			naturalProductFormHeight + 'px'
		);

		originalMobileAtcProductFormHost.classList.add(
			'sov-original-atc-product-form-height-locked'
		);
	}

	function unlockOriginalMobileAtcProductFormNaturalHeight() {
		if (!originalMobileAtcProductFormHost) {
			return;
		}

		originalMobileAtcProductFormHost.classList.remove(
			'sov-original-atc-product-form-height-locked'
		);

		originalMobileAtcProductFormHost.style.removeProperty(
			'--sov-original-atc-product-form-natural-height'
		);
	}

	function setStickyActiveState(isActive, stickyPlacement) {
		var normalizedStickyPlacement;

		if (!mobileMediaQuery.matches || !isActive) {
			originalMobileAtcStickyPlacement = '';
			wrapper.classList.remove('is-sov-original-atc-sticky-active');
			wrapper.classList.remove('is-sov-original-atc-sticky-at-top');
			wrapper.classList.remove('is-sov-original-atc-sticky-at-bottom');
			placeholder.classList.remove('is-active');
			placeholder.style.height = '0px';
			unlockOriginalMobileAtcProductFormNaturalHeight();
			return;
		}

		normalizedStickyPlacement = stickyPlacement === 'bottom'
			? 'bottom'
			: 'top';

		originalMobileAtcStickyPlacement = normalizedStickyPlacement;

		lockOriginalMobileAtcProductFormNaturalHeight();

		if (originalMobileAtcStickyDock) {
			placeholder.style.height =
				Math.max(
					1,
					Math.ceil(
						originalMobileAtcStickyDock
							.getBoundingClientRect()
							.height
					)
				) + 'px';

			placeholder.classList.add(
				'is-active'
			);
		}

		wrapper.classList.add('is-sov-original-atc-sticky-active');
		wrapper.classList.toggle(
			'is-sov-original-atc-sticky-at-top',
			normalizedStickyPlacement === 'top'
		);
		wrapper.classList.toggle(
			'is-sov-original-atc-sticky-at-bottom',
			normalizedStickyPlacement === 'bottom'
		);
	}

	function getWindowScrollYForOriginalMobileAtcButton() {
		return (
			window.scrollY ||
			document.documentElement.scrollTop ||
			document.body.scrollTop ||
			0
		);
	}

	function getOriginalMobileAtcVisualViewportTopDocument() {
		var visualViewport = window.visualViewport;

		if (visualViewport && typeof visualViewport.pageTop === 'number') {
			return Math.round(visualViewport.pageTop);
		}

		if (visualViewport && typeof visualViewport.offsetTop === 'number') {
			return Math.round(
				getWindowScrollYForOriginalMobileAtcButton() + visualViewport.offsetTop
			);
		}

		return getWindowScrollYForOriginalMobileAtcButton();
	}

	function getOriginalMobileAtcVisualViewportHeight() {
		var visualViewport = window.visualViewport;

		if (visualViewport && typeof visualViewport.height === 'number') {
			return Math.max(1, Math.round(visualViewport.height));
		}

		return Math.max(
			1,
			Math.round(window.innerHeight || document.documentElement.clientHeight || 0)
		);
	}

	function refreshOriginalMobileAtcAnchorMetrics(forceRefresh) {
		var anchorElement;
		var anchorRect;
		var scrollY;

		if (!forceRefresh && wrapper.classList.contains('is-sov-original-atc-sticky-active')) {
			return;
		}

		anchorElement =
			originalMobileAtcStickyDock ||
			wrapper;

		anchorRect =
			anchorElement.getBoundingClientRect();

		scrollY =
			getWindowScrollYForOriginalMobileAtcButton();

		originalMobileAtcAnchorTop =
			Math.round(
				scrollY +
				anchorRect.top
			);

		originalMobileAtcAnchorHeight =
			Math.max(
				1,
				Math.ceil(
					anchorRect.height
				)
			);
		originalMobileAtcAnchorBottom = originalMobileAtcAnchorTop + originalMobileAtcAnchorHeight;

		wrapper.dataset.sovOriginalAtcAnchorTopDocument = String(originalMobileAtcAnchorTop);
		wrapper.dataset.sovOriginalAtcAnchorBottomDocument = String(originalMobileAtcAnchorBottom);
	}

	function getOriginalMobileAtcStickyPlacementState() {
		var headerOffset;
		var viewportTopDocument;
		var viewportHeight;
		var stickyGap;
		var visibleTopDocument;
		var visibleBottomDocument;
		var anchorBottomDocument;

		if (!mobileMediaQuery.matches) {
			return {
				isActive: false,
				placement: ''
			};
		}

		if (document.documentElement.classList.contains('sov-menu-open')) {
			return {
				isActive: false,
				placement: ''
			};
		}

		refreshOriginalMobileAtcAnchorMetrics(false);

		headerOffset = getHeaderOffset();
		viewportTopDocument = getOriginalMobileAtcVisualViewportTopDocument();
		viewportHeight = getOriginalMobileAtcVisualViewportHeight();

		stickyGap = getOriginalMobileAtcStickyGapPx();
		visibleTopDocument = Math.round(viewportTopDocument + headerOffset + stickyGap);
		visibleBottomDocument = Math.round(viewportTopDocument + viewportHeight - stickyGap);
		anchorBottomDocument = parseFloat(wrapper.dataset.sovOriginalAtcAnchorBottomDocument || '');

		if (Number.isNaN(anchorBottomDocument) || anchorBottomDocument <= 0) {
			anchorBottomDocument = originalMobileAtcAnchorBottom || originalMobileAtcAnchorTop + originalMobileAtcAnchorHeight;
		}

		originalMobileAtcAnchorTop = parseFloat(wrapper.dataset.sovOriginalAtcAnchorTopDocument || '');

		if (Number.isNaN(originalMobileAtcAnchorTop) || originalMobileAtcAnchorTop <= 0) {
			originalMobileAtcAnchorTop = Math.max(0, anchorBottomDocument - originalMobileAtcAnchorHeight);
		}

		if (originalMobileAtcStickyPlacement === 'top') {
			if (originalMobileAtcAnchorTop <= visibleTopDocument + originalMobileAtcStickyHysteresisPx) {
				return {
					isActive: true,
					placement: 'top'
				};
			}

			return {
				isActive: false,
				placement: ''
			};
		}

		if (originalMobileAtcStickyPlacement === 'bottom') {
			if (anchorBottomDocument >= visibleBottomDocument - originalMobileAtcStickyHysteresisPx) {
				return {
					isActive: true,
					placement: 'bottom'
				};
			}

			return {
				isActive: false,
				placement: ''
			};
		}

		if (originalMobileAtcAnchorTop <= visibleTopDocument) {
			return {
				isActive: true,
				placement: 'top'
			};
		}

		if (anchorBottomDocument >= visibleBottomDocument) {
			return {
				isActive: true,
				placement: 'bottom'
			};
		}

		return {
			isActive: false,
			placement: ''
		};
	}

	function updateOriginalMobileAtcButtonMode() {
		var stickyPlacementState;

		rafId = 0;

		syncStickyTopOffsetVar();
		syncPriceInsideOriginalButton();

		stickyPlacementState = getOriginalMobileAtcStickyPlacementState();

		setStickyActiveState(
			stickyPlacementState.isActive,
			stickyPlacementState.placement
		);
	}

	function scheduleOriginalMobileAtcButtonModeUpdate() {
		if (rafId) {
			return;
		}

		rafId = window.requestAnimationFrame(updateOriginalMobileAtcButtonMode);
	}

	function runOriginalMobileAtcButtonModeUpdateImmediately() {
		if (rafId) {
			window.cancelAnimationFrame(rafId);
			rafId = 0;
		}

		updateOriginalMobileAtcButtonMode();
	}

	function scheduleOriginalMobileAtcButtonModeUpdateDuringTouchScroll() {
		if (originalMobileAtcTouchScrollFrameId) {
			return;
		}

		originalMobileAtcTouchScrollFrameId = window.requestAnimationFrame(function () {
			originalMobileAtcTouchScrollFrameId = 0;
			runOriginalMobileAtcButtonModeUpdateImmediately();
		});
	}

	function scheduleOriginalMobileAtcInitialPositionChecks() {
		var delays = [
			0,
			50,
			150,
			300,
			700,
			1200,
			1800
		];

		window.requestAnimationFrame(function () {
			window.requestAnimationFrame(runOriginalMobileAtcButtonModeUpdateImmediately);
		});

		delays.forEach(function (delayMs) {
			window.setTimeout(scheduleOriginalMobileAtcButtonModeUpdate, delayMs);
		});
	}

	function observeOriginalMobileAtcLayoutChanges() {
		if (typeof ResizeObserver === 'undefined') {
			return;
		}

		layoutResizeObserver = new ResizeObserver(function () {
			refreshOriginalMobileAtcAnchorMetrics(false);
			scheduleOriginalMobileAtcButtonModeUpdate();
		});

		layoutResizeObserver.observe(productInfo);
		layoutResizeObserver.observe(wrapper);

		if (originalMobileAtcStickyDock) {
			layoutResizeObserver.observe(
				originalMobileAtcStickyDock
			);
		}
	}

	function observePriceChanges() {
		var priceRoot =
			productInfo.querySelector('.sov-info-sticky .price') ||
			productInfo.querySelector('.product__info-container .price') ||
			productInfo.querySelector('.price');

		if (!priceRoot || typeof MutationObserver === 'undefined') {
			return;
		}

		priceMutationObserver = new MutationObserver(scheduleOriginalMobileAtcButtonModeUpdate);

		priceMutationObserver.observe(priceRoot, {
			subtree: true,
			childList: true,
			characterData: true,
			attributes: true
		});
	}

	window.addEventListener('scroll', scheduleOriginalMobileAtcButtonModeUpdate, { passive: true });
	window.addEventListener('resize', scheduleOriginalMobileAtcButtonModeUpdate, { passive: true });
	window.addEventListener('orientationchange', scheduleOriginalMobileAtcButtonModeUpdate, { passive: true });
	window.addEventListener('variantGalleryUpdated', scheduleOriginalMobileAtcButtonModeUpdate, { passive: true });
	window.addEventListener('load', scheduleOriginalMobileAtcInitialPositionChecks, { passive: true });
	window.addEventListener('pageshow', scheduleOriginalMobileAtcInitialPositionChecks, { passive: true });
	window.addEventListener('touchmove', scheduleOriginalMobileAtcButtonModeUpdateDuringTouchScroll, { passive: true });
	window.addEventListener('touchend', scheduleOriginalMobileAtcButtonModeUpdateDuringTouchScroll, { passive: true });
	window.addEventListener('touchcancel', scheduleOriginalMobileAtcButtonModeUpdateDuringTouchScroll, { passive: true });

	if (window.visualViewport) {
		window.visualViewport.addEventListener('resize', scheduleOriginalMobileAtcButtonModeUpdate, { passive: true });
		window.visualViewport.addEventListener('scroll', scheduleOriginalMobileAtcButtonModeUpdate, { passive: true });
	}

	document.addEventListener(
		'readystatechange',
		function () {
			scheduleOriginalMobileAtcInitialPositionChecks();
		},
		{ passive: true }
	);

	document.addEventListener(
		'visibilitychange',
		function () {
			if (!document.hidden) {
				scheduleOriginalMobileAtcInitialPositionChecks();
			}
		},
		{ passive: true }
	);

	document.addEventListener(
		'change',
		function (event) {
			if (event.target && event.target.name === 'id') {
				scheduleOriginalMobileAtcButtonModeUpdate();
			}
		},
		true
	);

	bindMediaQueryChange(mobileMediaQuery, scheduleOriginalMobileAtcButtonModeUpdate);
	observePriceChanges();
	observeOriginalMobileAtcLayoutChanges();
	refreshOriginalMobileAtcAnchorMetrics(true);
	scheduleOriginalMobileAtcInitialPositionChecks();

	productInfo.dataset.sovOriginalMobileAtcButtonModeInit = 'true';
}

/*
sov - gestione thumbnail, varianti e picker multilayer

ultimo aggiornamento: 2026-03-24  europe/rome

prima:
script inline con runtime liquid diretto per varianti, opzioni, label tradotta,
product id, product handle e aggiornamento prezzo.

dopo:
payload json nel liquid + init esterno scoped al singolo product-info.
la logica mantiene:
- click su thumbnail variante
- click su thumbnail family
- picker multilayer
- init variante da url o select o thumb selezionata
- aggiornamento prezzo
- scroll gallery verso media variante
- evento globale variantgalleryupdated
- telemetria gtag
*/
function updateSovProductPriceDomFromVariant(productInfo, variant) {
	if (!productInfo || !variant) {
		return;
	}

	var priceStr = variant.price || '';
	var compareStr = variant.compare_at_price || '';
	var priceInsideButtonValue = productInfo.querySelector(
		'[data-sov-atc-button-price-value], .sov-atc-button-with-price__price-value'
	);

	if (priceInsideButtonValue) {
		priceInsideButtonValue.textContent = priceStr;
	}

	var priceFinal = productInfo.querySelector('.price-item--sale.price-final .price-value');
	var priceRegular = productInfo.querySelector('.price-item--regular .price-value');
	var compareValue = productInfo.querySelector('.price-compare-wrapper .price-value');

	if (!priceFinal || !priceRegular) {
		return;
	}

	priceFinal.textContent = priceStr;
	priceRegular.textContent = priceStr;

	function toNum(value) {
		return parseFloat(String(value || '').replace(/[^0-9,.\-]/g, '').replace(',', '.'));
	}

	if (compareValue) {
		var compareWrap = compareValue.parentElement;

		if (toNum(compareStr) > toNum(priceStr)) {
			compareValue.textContent = compareStr;

			if (compareWrap) {
				compareWrap.style.display = '';
			}
		} else {
			compareValue.textContent = '';

			if (compareWrap) {
				compareWrap.style.display = 'none';
			}
		}
	}

	var unitPriceBlock = productInfo.querySelector('.unit-price');

	if (unitPriceBlock) {
		unitPriceBlock.classList.add('hidden');
	}
}

function initSovVariantPickerRails(productInfo) {
	if (
		!productInfo ||
		productInfo.dataset.sovVariantPickerRailsInit === 'true'
	) {
		return;
	}

	var pickers = Array.prototype.slice.call(
		productInfo.querySelectorAll(
			'[data-sov-variant-rail-picker="1"]'
		)
	);

	if (!pickers.length) {
		return;
	}

	function ensureRailStructure(picker) {
		var rail = picker.querySelector(
			'.variant-thumbnails-list'
		);

		if (!rail) {
			return null;
		}

		rail.setAttribute(
			'data-sov-variant-rail',
			'1'
		);

		var viewport =
			rail.parentElement &&
			rail.parentElement.classList.contains(
				'sov-variant-rail-viewport'
			)
				? rail.parentElement
				: null;

		if (!viewport) {
			viewport =
				document.createElement('div');

			viewport.className =
				'sov-variant-rail-viewport';

			rail.parentNode.insertBefore(
				viewport,
				rail
			);

			viewport.appendChild(
				rail
			);
		}

		var progress = picker.querySelector(
			'[data-sov-variant-rail-progress="1"]'
		);

		if (!progress) {
			progress =
				document.createElement('div');

			progress.className =
				'sov-mini-slider sov-variant-rail-progress';

			progress.setAttribute(
				'data-sov-variant-rail-progress',
				'1'
			);

			progress.setAttribute(
				'aria-hidden',
				'true'
			);

			progress.setAttribute(
				'hidden',
				''
			);

			var progressTrack =
				document.createElement('div');

			progressTrack.className =
				'sov-mini-slider__track';

			var progressKnob =
				document.createElement('div');

			progressKnob.className =
				'sov-mini-slider__knob';

			progressKnob.innerHTML =
				'&nbsp;';

			progressTrack.appendChild(
				progressKnob
			);

			progress.appendChild(
				progressTrack
			);

			viewport.insertAdjacentElement(
				'afterend',
				progress
			);
		}

		var progressTrack =
			progress.querySelector(
				'.sov-mini-slider__track'
			);

		var progressKnob = progressTrack
			? progressTrack.querySelector(
				'.sov-mini-slider__knob'
			)
			: null;

		if (!progressTrack || !progressKnob) {
			return null;
		}

		return {
			viewport: viewport,
			rail: rail,
			progress: progress,
			progressTrack: progressTrack,
			progressKnob: progressKnob,
		};
	}

	function initializeRailPicker(picker) {
		var structure =
			ensureRailStructure(
				picker
			);

		if (!structure) {
			return;
		}

		var viewport =
			structure.viewport;

		var rail =
			structure.rail;

		var progress =
			structure.progress;

		var progressTrack =
			structure.progressTrack;

		var progressKnob =
			structure.progressKnob;

		var mobileMediaQuery =
			window.matchMedia('(max-width: 749px)');

		var resizeObserver = null;
		var intersectionObserver = null;
		var updateFrame = 0;
		var railDemonstrationAnimationFrame = 0;
		var railDemonstrationPauseTimer = 0;
		var railDemonstrationStarted = false;
		var railDemonstrationCompleted = false;
		var railDemonstrationFallbackScrollListening = false;
		var railDemonstrationViewportSafetyPixels = 24;
		var railDemonstrationMotionStylesActive = false;
		var railDemonstrationOriginalScrollSnapType = '';
		var railDemonstrationOriginalScrollBehavior = '';

	function bindMediaQueryChange(mediaQuery, handler) {
		if (
			typeof mediaQuery.addEventListener ===
			'function'
		) {
			mediaQuery.addEventListener(
				'change',
				handler
			);

			return;
		}

		if (
			typeof mediaQuery.addListener ===
			'function'
		) {
			mediaQuery.addListener(
				handler
			);
		}
	}

	function railHasOverflow() {
		return (
			rail.scrollWidth -
			rail.clientWidth >
			2
		);
	}

	function updateProgress(
		hasOverflow
	) {
		if (
			!mobileMediaQuery.matches ||
			!hasOverflow
		) {
			progress.setAttribute(
				'hidden',
				''
			);

			progressKnob.style.transform =
				'translateX(0)';

			return;
		}

		progress.removeAttribute(
			'hidden'
		);

		var trackWidth =
			progressTrack.clientWidth;

		var scrollWidth =
			rail.scrollWidth;

		var clientWidth =
			rail.clientWidth;

		if (
			trackWidth <= 0 ||
			scrollWidth <= 0 ||
			clientWidth <= 0
		) {
			progress.setAttribute(
				'hidden',
				''
			);

			return;
		}

		var maxScroll =
			Math.max(
				0,
				scrollWidth -
					clientWidth
			);

		if (maxScroll <= 0) {
			progress.setAttribute(
				'hidden',
				''
			);

			return;
		}

		var knobWidth =
			Math.max(
				16,
				(
					clientWidth /
					scrollWidth
				) *
				trackWidth
			);

		knobWidth =
			Math.min(
				trackWidth,
				knobWidth
			);

		progressKnob.style.width =
			knobWidth + 'px';

		var maxTranslate =
			Math.max(
				0,
				trackWidth -
					knobWidth
			);

		var ratio =
			rail.scrollLeft /
			maxScroll;

		ratio =
			Math.max(
				0,
				Math.min(
					1,
					ratio
				)
			);

		progressKnob.style.transform =
			'translateX(' +
			(
				maxTranslate *
					ratio
			) +
			'px)';
	}

	function updateRailState() {
		if (!mobileMediaQuery.matches) {
			picker.classList.remove(
				'has-sov-variant-rail-overflow',
				'is-sov-variant-rail-at-start',
				'is-sov-variant-rail-at-end'
			);

			progress.setAttribute(
				'hidden',
				''
			);

			return;
		}

		var maxScroll =
			Math.max(
				0,
				rail.scrollWidth -
					rail.clientWidth
			);

		var hasOverflow =
			railHasOverflow();

		picker.classList.toggle(
			'has-sov-variant-rail-overflow',
			hasOverflow
		);

		picker.classList.toggle(
			'is-sov-variant-rail-at-start',
			rail.scrollLeft <= 1
		);

		picker.classList.toggle(
			'is-sov-variant-rail-at-end',
			rail.scrollLeft >=
				maxScroll - 1
		);

		updateProgress(
			hasOverflow
		);
	}

	function scheduleUpdate() {
		if (updateFrame) {
			return;
		}

		updateFrame =
			window.requestAnimationFrame(
				function () {
					updateFrame = 0;
					updateRailState();
				}
			);
	}

	function getRailItems() {
		return Array.prototype.slice.call(
			rail.children
		).filter(function (item) {
			return (
				item &&
				item.nodeType === 1
			);
		});
	}

	function getSelectedRailItem() {
		var items = getRailItems();

		for (
			var itemIndex = 0;
			itemIndex < items.length;
			itemIndex++
		) {
			var item = items[itemIndex];

			if (
				item.classList.contains(
					'is-selected'
				) ||
				item.querySelector(
					'.is-selected'
				)
			) {
				return item;
			}
		}

		return null;
	}

	function getSelectedRailCenteredScroll(
		selected
	) {
		if (!selected) {
			return rail.scrollLeft;
		}

		var railRect =
			rail.getBoundingClientRect();

		var selectedRect =
			selected.getBoundingClientRect();

		var selectedCenter =
			selectedRect.left -
			railRect.left +
			rail.scrollLeft +
			selectedRect.width / 2;

		var targetScroll =
			selectedCenter -
			rail.clientWidth / 2;

		var maxScroll =
			Math.max(
				0,
				rail.scrollWidth -
					rail.clientWidth
			);

		return Math.max(
			0,
			Math.min(
				maxScroll,
				targetScroll
			)
		);
	}

	function centerSelectedIfOutsideRail() {
		if (
			!mobileMediaQuery.matches ||
			!railHasOverflow()
		) {
			return;
		}

		var selected =
			getSelectedRailItem();

		if (!selected) {
			return;
		}

		var railRect =
			rail.getBoundingClientRect();

		var selectedRect =
			selected.getBoundingClientRect();

		var isFullyVisible =
			selectedRect.left >=
				railRect.left + 1 &&
			selectedRect.right <=
				railRect.right - 1;

		if (isFullyVisible) {
			return;
		}

		rail.scrollLeft =
			getSelectedRailCenteredScroll(
				selected
			);
	}

	function prefersReducedRailMotion() {
		return (
			typeof window.matchMedia ===
				'function' &&
			window.matchMedia(
				'(prefers-reduced-motion: reduce)'
			).matches
		);
	}

	function enableRailDemonstrationMotionStyles() {
		if (railDemonstrationMotionStylesActive) {
			return;
		}

		railDemonstrationOriginalScrollSnapType =
			rail.style.scrollSnapType;

		railDemonstrationOriginalScrollBehavior =
			rail.style.scrollBehavior;

		rail.style.scrollSnapType =
			'none';

		rail.style.scrollBehavior =
			'auto';

		railDemonstrationMotionStylesActive =
			true;
	}

	function restoreRailDemonstrationMotionStyles() {
		if (!railDemonstrationMotionStylesActive) {
			return;
		}

		rail.style.scrollSnapType =
			railDemonstrationOriginalScrollSnapType;

		rail.style.scrollBehavior =
			railDemonstrationOriginalScrollBehavior;

		railDemonstrationMotionStylesActive =
			false;

		railDemonstrationOriginalScrollSnapType =
			'';

		railDemonstrationOriginalScrollBehavior =
			'';
	}

	function cancelRailDemonstrationAnimation(
		markCompleted
	) {
		if (railDemonstrationAnimationFrame) {
			window.cancelAnimationFrame(
				railDemonstrationAnimationFrame
			);

			railDemonstrationAnimationFrame = 0;
		}

		if (railDemonstrationPauseTimer) {
			window.clearTimeout(
				railDemonstrationPauseTimer
			);

			railDemonstrationPauseTimer = 0;
		}

		railDemonstrationStarted = false;

		restoreRailDemonstrationMotionStyles();

		if (markCompleted) {
			railDemonstrationCompleted = true;
		}
	}

	function getRailDemonstrationAdaptiveDuration(
		targetScroll,
		baseDurationMilliseconds
	) {
		var distancePixels =
			Math.abs(
				targetScroll -
					rail.scrollLeft
			);

		var viewportPixels =
			Math.max(
				1,
				rail.clientWidth
			);

		var distanceInViewports =
			distancePixels /
				viewportPixels;

		if (distanceInViewports <= 1) {
			return baseDurationMilliseconds;
		}

		var logarithmicExtraMilliseconds =
			(
				Math.log(
					distanceInViewports
				) /
				Math.LN2
			) *
			280;

		var adaptiveDurationMilliseconds =
			baseDurationMilliseconds +
			logarithmicExtraMilliseconds;

		var maximumSpeedPixelsPerSecond =
			800;

		var speedLimitedDurationMilliseconds =
			(
				distancePixels /
					maximumSpeedPixelsPerSecond
			) *
			1000;

		return Math.round(
			Math.max(
				baseDurationMilliseconds,
				adaptiveDurationMilliseconds,
				speedLimitedDurationMilliseconds
			)
		);
	}

	function animateRailScrollTo(
		targetScroll,
		durationMilliseconds,
		completedCallback
	) {
		var startScroll =
			rail.scrollLeft;

		var distance =
			targetScroll -
			startScroll;

		if (Math.abs(distance) <= 1) {
			rail.scrollLeft =
				targetScroll;

			if (
				typeof completedCallback ===
				'function'
			) {
				completedCallback();
			}

			return;
		}

		var startedAt =
			window.performance &&
			typeof window.performance.now ===
				'function'
				? window.performance.now()
				: Date.now();

		function step(timestamp) {
			if (!railDemonstrationStarted) {
				return;
			}

			var now =
				typeof timestamp === 'number'
					? timestamp
					: Date.now();

			var progressValue =
				Math.max(
					0,
					Math.min(
						1,
						(
							now -
							startedAt
						) /
							durationMilliseconds
					)
				);

			var easedProgress =
				-(
					Math.cos(
						Math.PI *
							progressValue
					) -
					1
				) /
				2;

			rail.scrollLeft =
				startScroll +
				distance *
					easedProgress;

			if (progressValue < 1) {
				railDemonstrationAnimationFrame =
					window.requestAnimationFrame(
						step
					);

				return;
			}

			railDemonstrationAnimationFrame = 0;
			rail.scrollLeft =
				targetScroll;

			if (
				typeof completedCallback ===
				'function'
			) {
				completedCallback();
			}
		}

		railDemonstrationAnimationFrame =
			window.requestAnimationFrame(
				step
			);
	}

	function disconnectRailDemonstrationObserver() {
		if (intersectionObserver) {
			intersectionObserver.disconnect();
			intersectionObserver = null;
			picker.__sovVariantRailIntersectionObserver =
				null;
		}

		if (railDemonstrationFallbackScrollListening) {
			window.removeEventListener(
				'scroll',
				checkRailDemonstrationViewport
			);

			railDemonstrationFallbackScrollListening =
				false;
		}
	}

	function prepareRailDemonstrationStartPosition() {
		if (
			!mobileMediaQuery.matches ||
			railDemonstrationStarted ||
			railDemonstrationCompleted ||
			!railHasOverflow()
		) {
			return false;
		}

		if (prefersReducedRailMotion()) {
			railDemonstrationCompleted = true;
			centerSelectedIfOutsideRail();
			return false;
		}

		var items =
			getRailItems();

		var selected =
			getSelectedRailItem();

		if (
			!selected ||
			items.length < 2
		) {
			return false;
		}

		var selectedIndex =
			items.indexOf(
				selected
			);

		if (selectedIndex < 0) {
			return false;
		}

		var maxScroll =
			Math.max(
				0,
				rail.scrollWidth -
					rail.clientWidth
			);

		if (maxScroll <= 0) {
			return false;
		}

		var selectedIsInFirstHalf =
			selectedIndex <
				items.length / 2;

		rail.scrollLeft =
			selectedIsInFirstHalf
				? maxScroll
				: 0;

		updateRailState();

		return true;
	}

	function completeRailDemonstration() {
		railDemonstrationStarted = false;
		railDemonstrationCompleted = true;
		railDemonstrationPauseTimer = 0;

		restoreRailDemonstrationMotionStyles();
		disconnectRailDemonstrationObserver();
		updateRailState();
	}

	function startRailDemonstration() {
		if (
			railDemonstrationStarted ||
			railDemonstrationCompleted ||
			!mobileMediaQuery.matches ||
			!railHasOverflow()
		) {
			return;
		}

		var selected =
			getSelectedRailItem();

		var items =
			getRailItems();

		if (
			!selected ||
			items.length < 2
		) {
			railDemonstrationCompleted = true;
			disconnectRailDemonstrationObserver();
			centerSelectedIfOutsideRail();
			return;
		}

		if (prefersReducedRailMotion()) {
			railDemonstrationCompleted = true;
			disconnectRailDemonstrationObserver();
			centerSelectedIfOutsideRail();
			return;
		}

		var selectedIndex =
			items.indexOf(
				selected
			);

		if (selectedIndex < 0) {
			railDemonstrationCompleted = true;
			disconnectRailDemonstrationObserver();
			return;
		}

		var maxScroll =
			Math.max(
				0,
				rail.scrollWidth -
					rail.clientWidth
			);

		if (maxScroll <= 0) {
			railDemonstrationCompleted = true;
			disconnectRailDemonstrationObserver();
			return;
		}

		var selectedIsInFirstHalf =
			selectedIndex <
				items.length / 2;

		var startScroll =
			selectedIsInFirstHalf
				? maxScroll
				: 0;

		var oppositeScroll =
			selectedIsInFirstHalf
				? 0
				: maxScroll;

		enableRailDemonstrationMotionStyles();

		railDemonstrationStarted = true;
		rail.scrollLeft =
			startScroll;

		updateRailState();

		animateRailScrollTo(
			oppositeScroll,
			getRailDemonstrationAdaptiveDuration(
				oppositeScroll,
				1050
			),
			function () {
				if (!railDemonstrationStarted) {
					return;
				}

				railDemonstrationPauseTimer =
					window.setTimeout(
						function () {
							if (!railDemonstrationStarted) {
								return;
							}

							var selectedAtReturn =
								getSelectedRailItem() ||
								selected;

							var selectedTargetScroll =
								getSelectedRailCenteredScroll(
									selectedAtReturn
								);

							animateRailScrollTo(
								selectedTargetScroll,
								getRailDemonstrationAdaptiveDuration(
									selectedTargetScroll,
									520
								),
								completeRailDemonstration
							);
						},
						120
					);
			}
		);
	}

	function railIsInsideSafeViewport() {
		var viewportRect =
			viewport.getBoundingClientRect();

		return (
			viewportRect.bottom >=
				railDemonstrationViewportSafetyPixels &&
			viewportRect.top <=
				window.innerHeight -
					railDemonstrationViewportSafetyPixels
		);
	}

	function checkRailDemonstrationViewport() {
		if (
			railDemonstrationStarted ||
			railDemonstrationCompleted ||
			!mobileMediaQuery.matches
		) {
			return;
		}

		if (railIsInsideSafeViewport()) {
			startRailDemonstration();
		}
	}

	function initializeRailDemonstrationObserver() {
		if (
			railDemonstrationCompleted ||
			!mobileMediaQuery.matches ||
			!railHasOverflow() ||
			intersectionObserver ||
			railDemonstrationFallbackScrollListening
		) {
			return;
		}

		if (
			typeof IntersectionObserver ===
			'undefined'
		) {
			window.addEventListener(
				'scroll',
				checkRailDemonstrationViewport,
				{
					passive: true
				}
			);

			railDemonstrationFallbackScrollListening =
				true;

			checkRailDemonstrationViewport();
			return;
		}

		intersectionObserver =
			new IntersectionObserver(
				function (entries) {
					for (
						var entryIndex = 0;
						entryIndex < entries.length;
						entryIndex++
					) {
						if (
							entries[entryIndex].isIntersecting
						) {
							startRailDemonstration();
							break;
						}
					}
				},
				{
					root: null,
					rootMargin:
						'-' +
						railDemonstrationViewportSafetyPixels +
						'px 0px -' +
						railDemonstrationViewportSafetyPixels +
						'px 0px',
					threshold: 0.01,
				}
			);

		intersectionObserver.observe(
			viewport
		);

		picker.__sovVariantRailIntersectionObserver =
			intersectionObserver;
	}

	function handleRailUserInteraction() {
		if (
			railDemonstrationCompleted ||
			!mobileMediaQuery.matches
		) {
			return;
		}

		var demonstrationWasStarted =
			railDemonstrationStarted;

		cancelRailDemonstrationAnimation(
			true
		);

		disconnectRailDemonstrationObserver();

		if (!demonstrationWasStarted) {
			centerSelectedIfOutsideRail();
		}

		updateRailState();
	}

	function refreshRail() {
		window.requestAnimationFrame(
			function () {
				if (
					!railDemonstrationStarted &&
					!railDemonstrationCompleted
				) {
					var demonstrationPrepared =
						prepareRailDemonstrationStartPosition();

					if (demonstrationPrepared) {
						initializeRailDemonstrationObserver();
					}
				} else if (
					!railDemonstrationStarted
				) {
					centerSelectedIfOutsideRail();
				}

				updateRailState();
				checkRailDemonstrationViewport();
			}
		);
	}

	function handleMobileMediaQueryChange() {
		if (!mobileMediaQuery.matches) {
			cancelRailDemonstrationAnimation(
				true
			);

			disconnectRailDemonstrationObserver();
			rail.scrollLeft = 0;
		} else if (
			!railDemonstrationCompleted
		) {
			prepareRailDemonstrationStartPosition();
			initializeRailDemonstrationObserver();
		}

		refreshRail();
	}

	rail.addEventListener(
		'scroll',
		scheduleUpdate,
		{
			passive: true
		}
	);

	rail.addEventListener(
		'pointerdown',
		handleRailUserInteraction,
		{
			passive: true
		}
	);

	rail.addEventListener(
		'wheel',
		handleRailUserInteraction,
		{
			passive: true
		}
	);

	rail.addEventListener(
		'keydown',
		handleRailUserInteraction
	);

	window.addEventListener(
		'resize',
		refreshRail,
		{
			passive: true
		}
	);

	bindMediaQueryChange(
		mobileMediaQuery,
		handleMobileMediaQueryChange
	);

	if (
		typeof ResizeObserver !==
		'undefined'
	) {
		resizeObserver =
			new ResizeObserver(
				refreshRail
			);

		resizeObserver.observe(
			rail
		);

		resizeObserver.observe(
			viewport
		);

		picker.__sovVariantRailResizeObserver =
			resizeObserver;
	}

	prepareRailDemonstrationStartPosition();
	updateRailState();
	initializeRailDemonstrationObserver();
	refreshRail();
	}

	pickers.forEach(
		initializeRailPicker
	);

	productInfo.dataset.sovVariantPickerRailsInit =
		'true';
}

function initSovVariantThumbsAndPickers(productInfo) {
	if (!productInfo || productInfo.dataset.sovVariantThumbsAndPickersInit === 'true') {
		return;
	}

	var configScript = productInfo.querySelector('.sov-variant-state-json');
	var config = null;

	if (!configScript) {
		return;
	}

	try {
		config = JSON.parse(configScript.textContent || '{}');
	} catch (error) {
		return;
	}

	var variants = Array.isArray(config.variants) ? config.variants : [];
	var numLayers = parseInt(config.numLayers, 10) || 0;
	var optionNames = Array.isArray(config.optionNames) ? config.optionNames : [];
	var chooseOptionsLabel = config.chooseOptionsLabel || '';
	var selectedOptions = [];
	var thumbs = [];
	var variantThumbs = [];
	var gallery = null;
	var sectionId = productInfo.getAttribute('data-section') || 'main';

	if (!variants.length) {
		return;
	}

	for (var selectionIndex = 0; selectionIndex < numLayers; selectionIndex++) {
		selectedOptions.push(null);
	}

	function q(selector, root) {
		return (root || productInfo).querySelector(selector);
	}

	function qa(selector, root) {
		return Array.prototype.slice.call((root || productInfo).querySelectorAll(selector));
	}

	function findVariantById(variantId) {
		var variantIdString = String(variantId || '');

		for (var index = 0; index < variants.length; index++) {
			if (String(variants[index].id) === variantIdString) {
				return variants[index];
			}
		}

		return null;
	}

	function updateAllVariantInputs(variantId) {
		var select = q('#variant-select-main') || q('select[name="id"]');
		var hiddenInputs = qa('input[type="hidden"][name="id"]');
		var variantIdString = String(variantId || '');

		if (select) {
			select.value = variantIdString;
			select.dispatchEvent(new Event('input', { bubbles: true }));
			select.dispatchEvent(new Event('change', { bubbles: true }));
		}

		hiddenInputs.forEach(function (input) {
			input.value = variantIdString;
		});
	}

	function highlightVariantThumb(variantId, shouldScroll) {
		if (typeof shouldScroll === 'undefined') {
			shouldScroll = true;
		}

		var variantIdString = String(variantId || '');
		var variant = findVariantById(variantIdString);
		var option1 =
			variant && variant.options && variant.options[0]
				? variant.options[0]
				: null;
		var targetThumb = null;

		if (!variantThumbs.length) {
			return;
		}

		for (var directIndex = 0; directIndex < variantThumbs.length; directIndex++) {
			if (String(variantThumbs[directIndex].getAttribute('data-variant-id')) === variantIdString) {
				targetThumb = variantThumbs[directIndex];
				break;
			}
		}

		if (!targetThumb && option1) {
			for (var fallbackIndex = 0; fallbackIndex < variantThumbs.length; fallbackIndex++) {
				if (variantThumbs[fallbackIndex].getAttribute('data-option-value') === option1) {
					targetThumb = variantThumbs[fallbackIndex];
					break;
				}
			}
		}

		if (!targetThumb) {
			return;
		}

		variantThumbs.forEach(function (thumb) {
			thumb.classList.remove('is-selected');
			thumb.style.border = '1.5px solid #e0e0e0';

			if (thumb === targetThumb) {
				thumb.classList.add('is-selected');
				thumb.style.border = '1.5px solid #000';
			}
		});

		var picker = targetThumb.closest('.variant-thumbnails-picker');
		var pickerMode = picker ? picker.getAttribute('data-sov-picker') || '' : '';
		var label = picker
			? q('[id="selected-option-1-label"]', picker)
			: q('#selected-option-1-label');

		if (label && pickerMode !== 'capsule' && pickerMode !== 'family') {
			var optionValue = targetThumb.getAttribute('data-option-value');
			label.textContent = optionValue || '';
		}

		if (!variant || !variant.mediaId || !shouldScroll || !gallery) {
			return;
		}

		var targetMedia = q(
			'.vignette[data-media-id="' + variant.mediaId + '"]:not([data-sov-clone="1"])',
			gallery
		);

		function scrollToMedia(mediaElement) {
			if (!mediaElement) {
				return;
			}

			var isMobile =
				typeof window.matchMedia === 'function' &&
				window.matchMedia('(max-width: 900px)').matches;

			if (isMobile) {
				var left =
					mediaElement.offsetLeft -
					Math.max(0, (gallery.clientWidth - mediaElement.clientWidth) / 2);

				gallery.scrollTo({
					left: Math.max(0, left),
					behavior: 'smooth',
				});
			} else {
				var rect = mediaElement.getBoundingClientRect();
				var top = window.scrollY + rect.top;

				window.scrollTo({
					top: Math.max(0, top),
					behavior: 'smooth',
				});
			}
		}

		if (targetMedia) {
			scrollToMedia(targetMedia);
		}

		window.dispatchEvent(
			new CustomEvent('variantGalleryUpdated', {
				detail: {
					variantId: variant.id,
					mediaId: variant.mediaId,
					mediaElement: targetMedia,
				},
			})
		);
	}

	function renderLayerCombo(layer, filteredVariants) {
		var picker = q('.variants-layer-' + layer + '-picker');

		if (!picker) {
			return;
		}

		picker.innerHTML = '';

		var valuesSeen = {};
		var combos = [];

		filteredVariants.forEach(function (variant) {
			var value = variant.options[layer - 1];

			if (!valuesSeen[value]) {
				valuesSeen[value] = true;
				combos.push({
					label: value,
					id: variant.id,
				});
			}
		});

		if (combos.length === 0) {
			picker.style.display = 'none';
			return;
		}

		var select = document.createElement('select');
		select.className = 'model-combo-select luxury-combo';
		select.setAttribute('data-layer', String(layer));

		var selectId = 'sov-layer-' + layer + '-select-' + sectionId;
		select.id = selectId;

		var label = document.createElement('label');
		label.className = 'visually-hidden';
		label.setAttribute('for', selectId);
		label.textContent = optionNames[layer - 1] || chooseOptionsLabel;

		var placeholder = document.createElement('option');
		placeholder.value = '';
		placeholder.textContent = optionNames[layer - 1] || chooseOptionsLabel;
		select.appendChild(placeholder);

		combos.forEach(function (combo) {
			var option = document.createElement('option');
			option.value = combo.id;
			option.textContent = combo.label;
			select.appendChild(option);
		});

		if (selectedOptions[layer - 1]) {
			for (var comboIndex = 0; comboIndex < combos.length; comboIndex++) {
				if (combos[comboIndex].label === selectedOptions[layer - 1]) {
					select.value = combos[comboIndex].id;
					break;
				}
			}
		}

		select.addEventListener('change', function () {
			if (!this.value) {
				selectedOptions[layer - 1] = null;

				for (var resetIndex = layer; resetIndex < numLayers; resetIndex++) {
					selectedOptions[resetIndex] = null;
				}

				updateAllVariantInputs('');
				updateAllLayerCombos(layer + 1);
				return;
			}

			var variant = findVariantById(this.value);

			if (!variant) {
				return;
			}

			selectedOptions = variant.options.slice();

			updateAllVariantInputs(variant.id);
			highlightVariantThumb(variant.id);
			updateAllLayerCombos(layer + 1);
			updateSovProductPriceDomFromVariant(productInfo, variant);

			if (typeof window.gtag === 'function') {
				window.gtag('event', 'pdp_variant_select', {
					variant_id: variant.id,
					variant_name: variant.options.join(' / '),
				});
			}
		});

		var wrapper = document.createElement('div');
		wrapper.className = 'model-picker-combo';
		wrapper.appendChild(label);
		wrapper.appendChild(select);

		picker.appendChild(wrapper);
		picker.style.display = 'block';
	}

	function updateAllLayerCombos(startLayer) {
		var filteredVariants = variants.slice();

		for (var filterIndex = 0; filterIndex < startLayer - 1; filterIndex++) {
			if (selectedOptions[filterIndex]) {
				filteredVariants = filteredVariants.filter(function (variant) {
					return variant.options[filterIndex] === selectedOptions[filterIndex];
				});
			}
		}

		for (var layer = startLayer; layer <= numLayers; layer++) {
			renderLayerCombo(layer, filteredVariants);

			var layerPicker = q('.variants-layer-' + layer + '-picker select');

			if (layerPicker && layerPicker.value) {
				var selectedVariant = findVariantById(layerPicker.value);

				if (selectedVariant) {
					filteredVariants = filteredVariants.filter(function (variant) {
						return String(variant.id) === String(selectedVariant.id);
					});
				}
			}
		}
	}

	function getInitialVariantId() {
		try {
			var urlParams = new URLSearchParams(window.location.search || '');
			var urlVariantId = urlParams.get('variant');

			if (urlVariantId && findVariantById(urlVariantId)) {
				return String(urlVariantId);
			}
		} catch (error) {}

		var select = q('select[name="id"]');

		if (select && select.value && findVariantById(select.value)) {
			return String(select.value);
		}

		var selectedThumb = q('.variant-thumb-img.is-selected');

		if (selectedThumb) {
			var thumbVariantId = selectedThumb.getAttribute('data-variant-id');

			if (thumbVariantId && findVariantById(thumbVariantId)) {
				return String(thumbVariantId);
			}
		}

		return null;
	}

	function applyInitialVariant() {
		var initialVariantId = getInitialVariantId();

		if (!initialVariantId) {
			return;
		}

		var variant = findVariantById(initialVariantId);

		if (!variant) {
			return;
		}

		selectedOptions = variant.options.slice();

		updateAllVariantInputs(variant.id);
		highlightVariantThumb(variant.id, false);
		updateAllLayerCombos(2);
		updateSovProductPriceDomFromVariant(productInfo, variant);
	}

	function wireThumbClicks() {
		thumbs.forEach(function (thumb) {
			if (thumb.dataset.sovVariantThumbClickWired === 'true') {
				return;
			}

			thumb.addEventListener('click', function (event) {
				var isFamily = thumb.getAttribute('data-sov-family') === '1';

				if (isFamily) {
					var url = thumb.getAttribute('data-sov-family-url') || '';
					var handle = thumb.getAttribute('data-sov-family-handle') || '';

					if (!url || handle === (productInfo.getAttribute('data-product-handle') || '')) {
						if (event) {
							event.preventDefault();
						}

						return;
					}

					if (typeof window.gtag === 'function') {
						window.gtag('event', 'pdp_family_thumb_click', {
							transport_type: 'beacon',
							event_category: 'pdp_navigation',
							from_product_id: productInfo.getAttribute('data-product-id') || '',
							from_product_handle: productInfo.getAttribute('data-product-handle') || '',
							to_product_handle: handle,
							to_url: url,
						});
					}

					return;
				}

				var variantId = thumb.getAttribute('data-variant-id');

				if (!variantId) {
					return;
				}

				updateAllVariantInputs(variantId);
				highlightVariantThumb(variantId);

				var variant = findVariantById(variantId);

				if (!variant) {
					return;
				}

				selectedOptions[0] = variant.options[0];

				for (var resetLayerIndex = 1; resetLayerIndex < numLayers; resetLayerIndex++) {
					selectedOptions[resetLayerIndex] = null;
				}

				updateAllLayerCombos(2);
				updateSovProductPriceDomFromVariant(productInfo, variant);

				if (typeof window.gtag === 'function') {
					window.gtag('event', 'pdp_variant_thumb_click', {
						variant_id: variant.id,
						variant_name: variant.options.join(' / '),
					});
				}
			});

			thumb.dataset.sovVariantThumbClickWired = 'true';
		});
	}

	function wireGalleryScrollTelemetry() {
		if (!gallery || gallery.dataset.sovGalleryHorizontalTelemetryInit === 'true') {
			return;
		}

		var lastTrackedStep = 0;

		gallery.addEventListener(
			'scroll',
			function () {
				var maxScrollLeft = gallery.scrollWidth - gallery.clientWidth;

				if (maxScrollLeft <= 0) {
					return;
				}

				var percent = Math.round((gallery.scrollLeft / maxScrollLeft) * 100);
				var step = Math.floor(percent / 10) * 10;

				while (step >= lastTrackedStep + 10) {
					lastTrackedStep += 10;

					if (typeof window.gtag === 'function') {
						window.gtag('event', 'pdp_gallery_scroll_horizontal', {
							scroll_percent: lastTrackedStep,
						});
					}
				}
			},
			{ passive: true }
		);

		gallery.dataset.sovGalleryHorizontalTelemetryInit = 'true';
	}

	thumbs = qa('.variant-thumb-img');
	variantThumbs = qa('.variant-thumb-img[data-variant-id]');
	gallery = q('.sov-gallery');

	wireThumbClicks();
	updateAllLayerCombos(2);
	applyInitialVariant();
	wireGalleryScrollTelemetry();

	productInfo.dataset.sovVariantThumbsAndPickersInit = 'true';
}

/*
	gestisce lo scroll interno della colonna .sov-info-sticky su desktop

	ultimo aggiornamento: conversione da script inline a asset esterno
	prima: blocco inline con commento liquid e logica legacy commentata
	dopo: listener wheel esterno che devia lo scroll sulla colonna sticky quando può ancora scorrere
*/
addEventListener(
	'wheel',
	(e) => {
		const s = document.querySelector('.sov-info-sticky');

		if (!s || innerWidth < 992) return;

		const y = e.deltaY;
		const t = s.scrollTop;
		const m = s.scrollHeight - s.clientHeight;

		if ((y > 0 && t < m) || (y < 0 && t > 0)) {
			e.preventDefault();
			s.scrollTop += y;
		}
	},
	{ passive: false }
);
/*
	restituisce il media della gallery con area visibile maggiore nella viewport

	ultimo aggiornamento: 2026-03-18 Europe/Rome
	prima: funzione inline nello script della vecchia logica overlay/logo
	dopo: funzione globale esposta su window per riuso da altri script della pdp
*/
window.getVisibleMediaInGallery = function () {
	var items = Array.from(document.querySelectorAll('.sov-gallery-image'));

	var bestMatch = null;
	var maxVisibleArea = 0;

	for (var i = 0; i < items.length; i++) {
		var item = items[i];
		var rect = item.getBoundingClientRect();

		var visibleHeight = Math.max(
			0,
			Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0)
		);

		var visibleWidth = Math.max(
			0,
			Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0)
		);

		var visibleArea = visibleHeight * visibleWidth;

		var isLoaded =
			(item.tagName === 'IMG' && item.complete && item.naturalWidth > 0) ||
			(item.tagName === 'VIDEO' && item.readyState >= 2);

		if (visibleArea > maxVisibleArea && isLoaded) {
			bestMatch = item;
			maxVisibleArea = visibleArea;
		}
	}

	return bestMatch;
};
(function () {
	const fired = {};

	for (let i = 10; i <= 100; i += 10) {
		fired[i] = false;
	}

	function trackScroll() {
		if (typeof window.gtag !== 'function') return;

		const h = document.documentElement;
		const scrollTop = h.scrollTop || document.body.scrollTop;
		const scrollHeight = h.scrollHeight - h.clientHeight;

		if (scrollHeight <= 0) return;

		const pct = (scrollTop / scrollHeight) * 100;

		for (let p = 10; p <= 100; p += 10) {
			if (!fired[p] && pct >= p) {
				window.gtag('event', 'pdp_vertical_scroll', {
					percent: p,
					event_category: 'scroll',
					event_label: 'product page',
				});

				fired[p] = true;
			}
		}
	}

	window.addEventListener('scroll', trackScroll);
})();
/* sov — sticky right: top dinamico senza sentinel
 - riduce il top solo in base a vh e all'altezza contenuti
 - nessuna osservazione dello scroll → zero ping-pong
 - desktop (≥901px) soltanto
*/
(function () {
	var BASE_TOP = 134; /* px di partenza */
	var MIN_TOP = -1000; /* non scendere oltre */
	var CUSHION = 50; /* margine sotto */
	var MQ = '(min-width: 901px)';

	var mql = matchMedia(MQ);
	var sticky = null;
	var last = null;

	function clamp(v, min, max) {
		return Math.min(max, Math.max(min, v));
	}

	function debounce(fn, ms) {
		var t;
		return function () {
			clearTimeout(t);
			t = setTimeout(fn, ms);
		};
	}

	function computeTop() {
		if (!sticky) return;

		/* mobile: lascia il valore base */
		if (!mql.matches) {
			if (last !== BASE_TOP) {
				last = BASE_TOP;
				sticky.style.top = BASE_TOP + 'px';
			}
			return;
		}

		/* misure stabili: niente getBoundingClientRect qui */
		var vh = window.innerHeight || document.documentElement.clientHeight;
		var H = sticky.scrollHeight;

		/* top ideale per tenere il fondo dentro la viewport con un cuscinetto */
		var ideal = vh - CUSHION - H;

		/* clamp tra MIN_TOP e BASE_TOP */
		var target = clamp(Math.round(ideal), MIN_TOP, BASE_TOP);

		if (target !== last) {
			last = target;
			sticky.style.top = target + 'px';
		}
	}

	function init() {
		sticky = document.querySelector('.sov-info-sticky');
		if (!sticky) return;

		/* valore base coerente con il markup */
		sticky.style.top = BASE_TOP + 'px';
		last = BASE_TOP;

		/* ricalcolo solo quando serve: resize, variazioni di contenuto, font */
		window.addEventListener('resize', debounce(computeTop, 120), { passive: true });

		try {
			new ResizeObserver(debounce(computeTop, 16)).observe(sticky);
		} catch (e) {}

		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(computeTop);
		}

		/* primo pass dopo il layout */
		requestAnimationFrame(function () {
			requestAnimationFrame(computeTop);
		});
	}

	(mql.addEventListener || mql.addListener).call(mql, 'change', function () {
		computeTop();
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
})();

/* sov — header bg desktop (semplice, on/off immediato)
 - toggla anche la visibilità delle thumbs sovGalleryThumbs quando scrolled-after-pdp cambia
*/
(function () {
	function boot() {
		var header = document.querySelector('.header-wrapper');
		var wrapper = document.querySelector('.fullpage-wrapper');
		var thumbs = document.getElementById('sovGalleryThumbs');
		var mql = matchMedia('(min-width: 901px)');
		if (!header) return;

		function isMobile() {
			return !mql.matches;
		}

		function getHeaderH() {
			var v =
				parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
			return v || Math.round(header.getBoundingClientRect().height) || 0;
		}

		/* vero quando la sticky è a contatto dell'header (tolleranza 2px) */
		function stickyNearHeader() {
			var s = document.querySelector('.sov-info-sticky');
			if (!s || isMobile()) return false;
			var y = s.getBoundingClientRect().top;
			return y <= getHeaderH() + 2;
		}

		function updateHeaderState() {
			if (isMobile()) {
				var info = document.querySelector('.sov-info-sticky') || document.querySelector('.sov-column-right');
				var headerH = getHeaderH();

				if (!info) {
					header.classList.toggle('scrolled', window.scrollY > 0);
					header.classList.remove('scrolled-after-pdp');
					return;
				}

				var infoTop = info.getBoundingClientRect().top;
				var shouldBeOpaque = infoTop <= headerH + 8;

				header.classList.toggle('scrolled', shouldBeOpaque);
				header.classList.remove('scrolled-after-pdp');
				return;
			}

			header.classList.remove('scrolled');

			/* marcia indietro immediato rispetto alla wrapper */
			var outOfWrapper = false;
			var outOfWrapperForThumbs = false;
			if (wrapper) {
				var bottom = wrapper.getBoundingClientRect().bottom;
				var headerH = getHeaderH();

				outOfWrapper = bottom <= 0;

				var THUMBS_HIDE_OFFSET = 820;
				outOfWrapperForThumbs = bottom <= (headerH + THUMBS_HIDE_OFFSET);
			}

			var headerState = outOfWrapper || stickyNearHeader();
			var thumbsState = outOfWrapperForThumbs;

			header.classList.toggle('scrolled-after-pdp', headerState);
			if (thumbs) thumbs.classList.toggle('is-hidden', thumbsState);
		}


		updateHeaderState();
		addEventListener('scroll', updateHeaderState, { passive: true });
		addEventListener('resize', updateHeaderState, { passive: true });
		(mql.addEventListener || mql.addListener).call(mql, 'change', updateHeaderState);

		document.addEventListener(
			'shopify:section:load',
			function () {
				wrapper = document.querySelector('.fullpage-wrapper');
				thumbs = document.getElementById('sovGalleryThumbs');
				updateHeaderState();
			},
			{ passive: true }
		);

		if ('ResizeObserver' in window && wrapper) {
			try {
				new ResizeObserver(updateHeaderState).observe(wrapper);
			} catch (e) {}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot, { once: true });
	} else {
		boot();
	}
})();

/* inizio gestore gallery miniature */
(function(){
  function q(sel, root){ return (root || document).querySelector(sel); }
  function qa(sel, root){ return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function thumbUrl(url){
    if(!url) return '';
    var s = String(url);

    // shopify: query param width=...
    s = s.replace(/([?&]width=)\d+/i, '$150');

    // shopify: filename_XXXx.ext
    s = s.replace(/_(\d+)x(?=\.)/i, '_50x');

    return s;
  }

  function canScrollX(el){
    return !!el && (el.scrollWidth > el.clientWidth + 2);
  }

  function scrollToVignette(gallery, vignette){
    if(!gallery || !vignette) return;

    if(canScrollX(gallery)){
      var left = vignette.offsetLeft - (gallery.clientWidth - vignette.clientWidth) / 2;
      gallery.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      return;
    }

    vignette.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
  }

  function getVisibleMedia(){
    if(typeof window.getVisibleMediaInGallery === 'function'){
      return window.getVisibleMediaInGallery();
    }

    var items = qa('.sov-gallery img.sov-gallery-image, .sov-gallery video.sov-gallery-image');
    var best = null;
    var bestArea = 0;

    for(var i=0;i<items.length;i++){
      var r = items[i].getBoundingClientRect();
      var vh = Math.max(0, Math.min(r.bottom, innerHeight) - Math.max(r.top, 0));
      var vw = Math.max(0, Math.min(r.right, innerWidth) - Math.max(r.left, 0));
      var area = vh * vw;
      if(area > bestArea){
        bestArea = area;
        best = items[i];
      }
    }

    return best;
  }

  function currentMediaId(){
    var m = getVisibleMedia();
    if(!m) return null;
    var v = m.closest('.vignette');
    return v ? v.getAttribute('data-media-id') : null;
  }

function setActive(id){
	var wrap = document.getElementById('sovGalleryThumbs');
	if(!wrap) return;

	qa('.sov-gallery-thumb', wrap).forEach(function(b){
		var on = b.getAttribute('data-media-id') === String(id);
		b.classList.toggle('is-active', on);
		b.setAttribute('aria-current', on ? 'true' : 'false');
	});

	var inner = q('.sov-gallery-thumbs__inner', wrap);
	if(!inner) return;

	if(!inner.classList.contains('is-overflowing')) return;

	var active = q('.sov-gallery-thumb.is-active', wrap);
	if(!active) return;

	var reduceMotion = false;
	try{
		reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}catch(e){}

	var behavior = reduceMotion ? 'auto' : 'smooth';

	var targetLeft = active.offsetLeft - (inner.clientWidth - active.clientWidth) / 2;
	var maxLeft = inner.scrollWidth - inner.clientWidth;

	if(targetLeft < 0) targetLeft = 0;
	if(targetLeft > maxLeft) targetLeft = maxLeft;

	inner.scrollTo({
		left: targetLeft,
		behavior: behavior
	});
}

  function updateThumbsFadeState(wrap, inner){
	if(!wrap || !inner) return;

	var maxScrollLeft = inner.scrollWidth - inner.clientWidth;
	var sl = inner.scrollLeft;

	var atStart = sl <= 1;
	var atEnd = sl >= (maxScrollLeft - 1);

	wrap.classList.toggle('is-at-start', atStart);
	wrap.classList.toggle('is-at-end', atEnd);
}

  function build(){
    var wrap = document.getElementById('sovGalleryThumbs');
    var inner = wrap ? q('.sov-gallery-thumbs__inner', wrap) : null;
    var gallery = q('.sov-gallery');
    if(!wrap || !inner || !gallery) return;

    inner.innerHTML = '';

    var vignettes = qa('.sov-gallery .vignette:not([data-sov-clone="1"])', gallery);
    if(!vignettes.length){
      wrap.style.display = 'none';
      return;
    }

    wrap.style.display = '';

    vignettes.forEach(function(v, idx){
      var id = v.getAttribute('data-media-id') || String(idx);
      var mediaEl = q('.sov-gallery-image', v);

      var src = '';
      if(mediaEl){
        if(mediaEl.tagName === 'IMG'){
          src = thumbUrl(mediaEl.currentSrc || mediaEl.src || '');
        } else if(mediaEl.tagName === 'VIDEO'){
          var pimg = q('picture img', v);
          src = thumbUrl((pimg && (pimg.currentSrc || pimg.src)) || mediaEl.poster || '');
        }
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sov-gallery-thumb';
      btn.setAttribute('data-media-id', id);
      btn.setAttribute('aria-label', (idx + 1) + ' / ' + vignettes.length);
      btn.setAttribute('aria-current', 'false');
      btn.setAttribute('role', 'listitem');

      if(src){
        var img = document.createElement('img');
        img.className = 'sov-gallery-thumb__img';
        img.alt = '';
        img.decoding = 'async';
        img.loading = 'lazy';
        img.src = src;
        btn.appendChild(img);
      }

      if(mediaEl && mediaEl.tagName === 'VIDEO'){
        var badge = document.createElement('span');
        badge.className = 'sov-gallery-thumb__badge';
        badge.setAttribute('aria-hidden', 'true');
        badge.textContent = '▶';
        btn.appendChild(badge);
      }

      btn.addEventListener('click', function(){
        scrollToVignette(gallery, v);
        setActive(id);

        if(typeof window.gtag === 'function'){
          window.gtag('event', 'pdp_gallery_thumb_click', {
            media_id: id,
            index: idx + 1
          });
        }
      });

      inner.appendChild(btn);
    });

    var overflowing = inner.scrollWidth > inner.clientWidth + 2;
    inner.classList.toggle('is-overflowing', overflowing);
    wrap.classList.toggle('is-overflowing', overflowing);
    updateThumbsFadeState(wrap, inner);
    if(!inner.__sovFadeBound){
      inner.__sovFadeBound = true;
      inner.addEventListener('scroll', function(){
        updateThumbsFadeState(wrap, inner);
      }, 
      { passive: true });
    }
    var idNow = currentMediaId();
    if(idNow != null) setActive(idNow);    
  }

  var raf = 0;
  function schedule(){
    if(raf) return;
    raf = requestAnimationFrame(function(){
      raf = 0;
      var idNow = currentMediaId();
      if(idNow != null) setActive(idNow);
    });
  }

  function boot(){
    build();

    var gallery = q('.sov-gallery');
    if(gallery) gallery.addEventListener('scroll', schedule, { passive: true });

    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });

    window.addEventListener('variantGalleryUpdated', function(){
      setTimeout(build, 0);
    }, { passive: true });

    document.addEventListener('shopify:section:load', function(){
      setTimeout(build, 0);
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
/* fine gestione gallery miniature */
(function () {
	function q(sel, root) {
		return (root || document).querySelector(sel);
	}

	function qa(sel, root) {
		return Array.prototype.slice.call((root || document).querySelectorAll(sel));
	}

	function isMobile() {
		return matchMedia('(max-width: 900px)').matches;
	}

	function getGallery() {
		return q('.sov-gallery');
	}

	function getOriginalVignettes(gallery) {
		return qa('.vignette:not([data-sov-clone="1"])', gallery);
	}

	function getCloneVignettes(gallery) {
		return qa('.vignette[data-sov-clone="1"]', gallery);
	}

	function getModal() {
		return (
			document.querySelector('product-modal[id^="ProductModal-"]') ||
			document.querySelector('modal-dialog.product-media-modal') ||
			document.querySelector('product-modal')
		);
	}

	function wireCloneLightbox(clone) {
		if (!clone || clone.__sovCloneLightboxWired) return;

		if (clone.hasAttribute('data-sov-product-choice-main-gallery-item')) {
			return;
		}

		var modal = getModal();
		if (!modal) return;

		clone.__sovCloneLightboxWired = true;
		clone.style.cursor = 'zoom-in';

		clone.addEventListener('click', function (ev) {
			ev.preventDefault();

			if (typeof modal.show === 'function') {
				modal.show(clone);
			} else {
				modal.setAttribute('open', '');
			}
		});
	}

	function createClone(source, role) {
		var clone = source.cloneNode(true);

		clone.setAttribute('data-sov-clone', '1');
		clone.setAttribute('data-sov-clone-role', role);

		wireCloneLightbox(clone);

		return clone;
	}

	function buildLoopLazy(gallery) {
		if (!gallery || gallery.__sovInfiniteBuilt) return false;

		var originals = getOriginalVignettes(gallery);
		if (originals.length < 2) return false;

		var firstOriginal = originals[0];
		var lastOriginal = originals[originals.length - 1];

		var headClone = createClone(lastOriginal, 'head');
		var tailClone = createClone(firstOriginal, 'tail');

		var preserveLeft = gallery.scrollLeft;
		var prevBehavior = gallery.style.scrollBehavior;

		gallery.insertBefore(headClone, firstOriginal);
		gallery.appendChild(tailClone);

		gallery.style.scrollBehavior = 'auto';
		gallery.scrollLeft = preserveLeft + headClone.getBoundingClientRect().width;
		gallery.style.scrollBehavior = prevBehavior || '';

		gallery.__sovInfiniteBuilt = true;

		window.dispatchEvent(new Event('variantGalleryUpdated'));

		return true;
	}

	function destroyLoop(gallery) {
		if (!gallery) return;

		getCloneVignettes(gallery).forEach(function (node) {
			node.remove();
		});

		gallery.__sovInfiniteBuilt = false;
	}

	var jumpLock = false;

	function jumpTo(gallery, left) {
		if (!gallery || jumpLock) return;

		jumpLock = true;

		var prevBehavior = gallery.style.scrollBehavior;
		gallery.style.scrollBehavior = 'auto';
		gallery.scrollLeft = left;

		requestAnimationFrame(function () {
			gallery.style.scrollBehavior = prevBehavior || '';
			jumpLock = false;
			window.dispatchEvent(new Event('variantGalleryUpdated'));
		});
	}

	function isNearLastOriginal(gallery) {
		var originals = getOriginalVignettes(gallery);
		if (originals.length < 2) return false;

		var lastOriginal = originals[originals.length - 1];
		var activationPoint = Math.max(0, lastOriginal.offsetLeft - gallery.clientWidth * 0.45);

		return gallery.scrollLeft >= activationPoint;
	}

	function maybeActivate(gallery) {
		if (!gallery || !isMobile() || gallery.__sovInfiniteBuilt) return;

		if (isNearLastOriginal(gallery)) {
			buildLoopLazy(gallery);
		}
	}

	function maybeWrap(gallery) {
		if (!gallery || !isMobile() || !gallery.__sovInfiniteBuilt || jumpLock) return;

		var originals = getOriginalVignettes(gallery);
		if (originals.length < 2) return;

		var firstOriginal = originals[0];
		var lastOriginal = originals[originals.length - 1];

		var x = gallery.scrollLeft;
		var maxScroll = Math.max(0, gallery.scrollWidth - gallery.clientWidth);

		var headLimit = firstOriginal.offsetLeft * 0.5;
		var tailLimit = lastOriginal.offsetLeft + Math.max(8, (maxScroll - lastOriginal.offsetLeft) * 0.5);

		if (x <= headLimit) {
			jumpTo(gallery, lastOriginal.offsetLeft);
			return;
		}

		if (x >= tailLimit) {
			jumpTo(gallery, firstOriginal.offsetLeft);
		}
	}

	var settleTimer = 0;

	function scheduleSettle(gallery) {
		clearTimeout(settleTimer);

		settleTimer = setTimeout(function () {
			maybeActivate(gallery);
			maybeWrap(gallery);
		}, 72);
	}

	function wireGallery(gallery) {
		if (!gallery || gallery.__sovInfiniteLazyWired) return;

		gallery.__sovInfiniteLazyWired = true;

		gallery.addEventListener(
			'scroll',
			function () {
				scheduleSettle(gallery);
			},
			{ passive: true }
		);
	}

	function syncMode() {
		var gallery = getGallery();
		if (!gallery) return;

		if (!isMobile()) {
			destroyLoop(gallery);
			window.dispatchEvent(new Event('variantGalleryUpdated'));
		}
	}

	function boot() {
		var gallery = getGallery();
		if (!gallery) return;

		wireGallery(gallery);
		syncMode();

		addEventListener(
			'resize',
			function () {
				syncMode();
				var g = getGallery();
				if (g) scheduleSettle(g);
			},
			{ passive: true }
		);

		addEventListener(
			'orientationchange',
			function () {
				syncMode();
				var g = getGallery();
				if (g) scheduleSettle(g);
			},
			{ passive: true }
		);

		document.addEventListener('shopify:section:load', function () {
			var g = getGallery();
			if (!g) return;
			wireGallery(g);
			syncMode();
		});

		window.addEventListener(
			'variantGalleryUpdated',
			function () {
				var g = getGallery();
				if (!g || !isMobile()) return;
				scheduleSettle(g);
			},
			{ passive: true }
		);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot, { once: true });
	} else {
		boot();
	}
})();

/*
	SOV — init sticky mobile semplice
	-Ultimo aggiornamento: 2025-10-05 19:05 Europe/Rome
	Funzioni: mostra la barra quando il form esce dalla viewport;
	mantiene testo/stato del bottone; sincronizza titolo; sincronizza il prezzo
	clonando il nodo del prezzo principale
*/
(function () {
	function isMobile() {
		return matchMedia('(max-width: 900px)').matches;
	}

	function syncTitle() {
		var src = document.querySelector('.sov-title') || document.querySelector('h1.product__title');
		var dst = document.getElementById('sovStickyAtcTitle');

		if (src && dst) dst.textContent = (src.textContent || '').trim();
	}

	function syncButton() {
	if (syncButton.__wired) return;
	syncButton.__wired = true;

	var form = document.getElementById('sov-buy-form');
	var stickyBtn = document.getElementById('sovStickyAtcBtn');
	var routerBtn = document.querySelector('.buy-buttons-wrapper [data-sov-bundle-router-open="1"]');

	if (!stickyBtn) return;

	if (routerBtn && !form) {
		var routerLabelEl =
			stickyBtn.querySelector('.sov-bundle-router-btn__label') ||
			stickyBtn.querySelector('.sov-sticky-atc__btnlabel') ||
			stickyBtn.querySelector('span');

		if (routerLabelEl) {
			routerLabelEl.textContent = (routerBtn.textContent || '').trim();
		}

		return;
	}

	if (!form) return;

	var mainBtn = form.querySelector('.product-form__submit');
	if (!mainBtn) return;

	var mainLabel = (mainBtn.textContent || '').trim();
	var labelEl = stickyBtn.querySelector('.sov-sticky-atc__btnlabel');
	if (labelEl) labelEl.textContent = mainLabel;

		// funzione che “rispecchia” stato/attributi dal bottone principale
		var stickySpinner = stickyBtn.querySelector(
			'.loading-overlay__spinner, .loading__spinner, .button__spinner'
		);

		function mirrorLoadingState() {
			// Dawn/temi affini usano .loading + aria-busy + hidden sulla spinner
			var mainSpinner = mainBtn.querySelector(
				'.loading-overlay__spinner, .loading__spinner, .button__spinner'
			);
			var isLoading =
				mainBtn.classList.contains('loading') ||
				mainBtn.getAttribute('aria-busy') === 'true' ||
				(mainSpinner &&
					!mainSpinner.classList.contains('hidden') &&
					!mainSpinner.hasAttribute('hidden'));

			// disabilitazione
			stickyBtn.disabled = !!mainBtn.disabled;
			stickyBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
			stickyBtn.classList.toggle('loading', isLoading);

			// mostra/nasconde la spinner sticky come fa il tema
			if (stickySpinner) {
				if (isLoading) {
					stickySpinner.classList.remove('hidden');
					stickySpinner.removeAttribute('hidden');
				} else {
					stickySpinner.classList.add('hidden');
					stickySpinner.setAttribute('hidden', '');
				}
			}

			// nascondi/mostra l’etichetta quando loading
			if (labelEl) labelEl.style.visibility = isLoading ? 'hidden' : '';
		}

		// osserva cambi di class/attr sul bottone principale e li copia sullo sticky
		new MutationObserver(mirrorLoadingState).observe(mainBtn, {
			attributes: true,
			attributeFilter: ['class', 'disabled', 'aria-busy'],
		});

		// sync immediato allo start
		mirrorLoadingState();

		// feedback immediato alla pressione dello sticky (mentre parte il submit)
		stickyBtn.addEventListener(
			'click',
			function () {
				// non blocchiamo il submit; solo UI
				stickyBtn.classList.add('loading');
				stickyBtn.setAttribute('aria-busy', 'true');

				if (stickySpinner) {
					stickySpinner.classList.remove('hidden');
					stickySpinner.removeAttribute('hidden');
				}

				if (labelEl) labelEl.style.visibility = 'hidden';

				// il MutationObserver riallineerà tutto quando il tema imposta lo stato reale
			},
			{ passive: true }
		);
	}

	// syncTitle(); syncPrice(); observePrice(); visController();
	// e anche:
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', syncButton, { once: true });
	} else {
		syncButton();
	}

	function syncPrice() {
		var src =
			document.querySelector('.sov-info-sticky .price, .product__info-container .price') ||
			document.querySelector('.price');
		var wrap = document.getElementById('sovStickyAtcPriceWrap');
		if (!src || !wrap) return;

		// Legge prezzo "attivo"
		var hasFirst = (function () {
			var fl = src.querySelector('.price-line-first');
			if (!fl) return false;
			var s = getComputedStyle(fl);
			return s.display !== 'none' && !fl.hidden;
		})();

		var value = '',
			curr = '',
			percent = '',
			timer = '';

		if (hasFirst) {
			var v = src.querySelector('.price-line-first .price-item--discounted');
			var c = src.querySelector('.price-line-first .currency-symbol.price-item--discounted');
			if (v) value = (v.textContent || '').trim();
			if (c) curr = (c.textContent || '').trim();

			var pill = src.querySelector('.price-coupon-code-pill');
			if (pill && !pill.hidden) {
				var t = (pill.textContent || '').replace(/\s+/g, ' ').trim();
				var mP = t.match(/[−-]?\d+\s*%/);
				if (mP) percent = mP[0].replace(/\s+/g, '');

				var mT = t.match(/(\d{1,2}:\d{2}:\d{2})/);
				if (mT) timer = mT[1];
			}
		} else {
			var rv = src.querySelector('.price-line-second .price-item--regular .price-value');
			var rc = src.querySelector('.price-line-second .price-item--regular .currency-symbol');
			if (rv) value = (rv.textContent || '').trim();
			if (rc) curr = (rc.textContent || '').trim();
		}

		// Crea struttura minimale (nessuna classe del tema)
		var root = wrap.querySelector('.sov-price-min');
		if (!root) {
			root = document.createElement('div');
			root.className = 'sov-price-min price-coupon-code-pill-sticky';

			var row = document.createElement('div');
			row.className = 'sov-price-min__row';

			var val = document.createElement('span');
			val.className = 'sov-price-min__value';

			var per = document.createElement('span');
			per.className = 'sov-price-min__percent';

			var tim = document.createElement('div');
			tim.className = 'sov-price-min__timer';

			row.appendChild(val);
			row.appendChild(per);
			root.appendChild(row);
			root.appendChild(tim);

			// svuota e monta
			while (wrap.firstChild) wrap.removeChild(wrap.firstChild);
			wrap.appendChild(root);
		}

		// Aggiorna contenuti
		var valEl = root.querySelector('.sov-price-min__value');
		var perEl = root.querySelector('.sov-price-min__percent');
		var timEl = root.querySelector('.sov-price-min__timer');

		valEl.textContent = (value ? value : '') + (curr ? '\u00A0' + curr : '');

		if (percent) {
			var clean = percent.replace(/\s+/g, '');
			if (!/^[−-]/.test(clean)) clean = '−' + clean;
			perEl.textContent = ' ' + clean;
			perEl.style.display = '';
			root.classList.add('has-discount');
		} else {
			perEl.textContent = '';
			perEl.style.display = 'none';
			root.classList.remove('has-discount');
		}

		if (timer) {
			timEl.textContent = timer;
			timEl.style.display = '';
		} else {
			timEl.textContent = '';
			timEl.style.display = 'none';
		}
	}

	function observePrice() {
		var src =
			document.querySelector('.sov-info-sticky .price, .product__info-container .price') ||
			document.querySelector('.price');
		if (!src) return;

		var rafId = null;
		var mo = new MutationObserver(function () {
			if (rafId) cancelAnimationFrame(rafId);
			rafId = requestAnimationFrame(syncPrice); // debounce (es. timer della pill)
		});

		mo.observe(src, {
			subtree: true,
			childList: true,
			characterData: true,
			attributes: true,
		});
	}

	function getHeaderHeight() {
		// legge la CSS var --header-height (es. 72px)
		var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
		var n = parseInt(raw, 10);
		if (!isNaN(n) && n > 0) return n;

		var hw = document.querySelector('.header-wrapper');
		return hw ? Math.round(hw.getBoundingClientRect().height) : 0;
	}

function getEffectiveHeaderOffset() {
	var header = document.querySelector('.header-wrapper');
	var fallback = getHeaderHeight();

	if (!header) {
		return fallback;
	}

	var rect = header.getBoundingClientRect();
	var visibleBottom = Math.min(rect.bottom, fallback);
	var effectiveOffset = Math.max(0, Math.round(visibleBottom));

	return effectiveOffset;
}

function syncStickyTopOffsetVar() {
	var offset = getEffectiveHeaderOffset();
	document.documentElement.style.setProperty('--sov-sticky-top-offset', offset + 'px');
}


	function visControllerTop() {
	var sticky = document.getElementById('sov-sticky-atc');
	var form = document.getElementById('sov-buy-form');
	var routerBtn = document.querySelector('.buy-buttons-wrapper [data-sov-bundle-router-open="1"]');

	if (!sticky) return;

	var btn = routerBtn || (form ? (form.querySelector('.product-form__submit') || form) : null);
	if (!btn) return;

		/* allineamento iniziale con aria-hidden presente nel markup */
		applyA11yState(sticky.getAttribute('aria-hidden') === 'true');

		/* sincronizza stato a11y con visibilità */
		function applyA11yState(hidden) {
			var btn = document.getElementById('sovStickyAtcBtn');
			if (!btn) return;

			if (hidden) {
				sticky.setAttribute('aria-hidden', 'true');
				sticky.setAttribute('inert', '');
				btn.setAttribute('disabled', '');
				btn.setAttribute('aria-disabled', 'true');
				btn.setAttribute('tabindex', '-1');
			} else {
				sticky.setAttribute('aria-hidden', 'false');
				sticky.removeAttribute('inert');
				btn.removeAttribute('disabled');
				btn.removeAttribute('aria-disabled');
				btn.removeAttribute('tabindex');
			}
		}

		var stickyShowRafA = 0;
		var stickyShowRafB = 0;
		var stickyHideCleanupTimer = 0;
		var currentStickyMode = null;

		function clearStickyAnimationState() {
			if (stickyShowRafA) {
				cancelAnimationFrame(stickyShowRafA);
				stickyShowRafA = 0;
			}

			if (stickyShowRafB) {
				cancelAnimationFrame(stickyShowRafB);
				stickyShowRafB = 0;
			}

			if (stickyHideCleanupTimer) {
				clearTimeout(stickyHideCleanupTimer);
				stickyHideCleanupTimer = 0;
			}
		}

		function setStickyMode(mode) {
			currentStickyMode = mode;

			sticky.classList.remove('at-top');
			sticky.classList.remove('at-bottom');

			if (mode === 'top') {
				sticky.classList.add('at-top');
			} else if (mode === 'bottom') {
				sticky.classList.add('at-bottom');
			}
		}

		function syncStickyButtonDisabledState() {
	var main =
		document.querySelector('#sov-buy-form .product-form__submit') ||
		document.querySelector('.product-form__submit');
	var stickyBtn = document.getElementById('sovStickyAtcBtn');
	var routerBtn = document.querySelector('.buy-buttons-wrapper [data-sov-bundle-router-open="1"]');

	if (!stickyBtn) {
		return;
	}

	if (routerBtn && !form) {
		stickyBtn.removeAttribute('disabled');
		stickyBtn.setAttribute('aria-disabled', 'false');
		return;
	}

	if (!main) {
		return;
	}

	if (main.disabled) {
		stickyBtn.setAttribute('disabled', '');
		stickyBtn.setAttribute('aria-disabled', 'true');
	} else {
		stickyBtn.removeAttribute('disabled');
		stickyBtn.setAttribute('aria-disabled', 'false');
	}
}

		function show(mode) {
			clearStickyAnimationState();

			setStickyMode(mode);
			applyA11yState(false);
			syncStickyButtonDisabledState();

			sticky.classList.remove('is-visible');

			void sticky.offsetHeight;

			stickyShowRafA = requestAnimationFrame(function () {
				stickyShowRafB = requestAnimationFrame(function () {
					sticky.classList.add('is-visible');
					stickyShowRafA = 0;
					stickyShowRafB = 0;
				});
			});
		}

		function hide() {
			clearStickyAnimationState();

			sticky.classList.remove('is-visible');

			stickyHideCleanupTimer = window.setTimeout(function () {
				applyA11yState(true);
				sticky.classList.remove('at-top');
				sticky.classList.remove('at-bottom');
				currentStickyMode = null;
				stickyHideCleanupTimer = 0;
			}, 280);
		}

		function recomputeThreshold() {
			update();
		}

		var lastMode = null;

		function update() {
			if (!isMobile()) {
				hide();
				lastMode = 'hidden';
				return;
			}

var rect = btn.getBoundingClientRect();
var headerOffset = getEffectiveHeaderOffset();
var viewportH = window.innerHeight || document.documentElement.clientHeight;

syncStickyTopOffsetVar();

var isAboveViewport = rect.bottom <= headerOffset + 4;
var isBelowViewport = rect.top >= viewportH - 24;

			var nextMode = 'hidden';

			if (isAboveViewport) {
				nextMode = 'top';
			} else if (isBelowViewport) {
				nextMode = 'bottom';
			}

			if (nextMode === lastMode) {
				return;
			}

			if (nextMode === 'top') {
				show('top');
			} else if (nextMode === 'bottom') {
				show('bottom');
			} else {
				hide();
			}

			lastMode = nextMode;
		}

		// ascoltatori leggeri
		window.addEventListener(
	'scroll',
	function () {
		syncStickyTopOffsetVar();
		update();
	},
	{ passive: true }
);

window.addEventListener(
	'resize',
	function () {
		syncStickyTopOffsetVar();
		recomputeThreshold();
	},
	{ passive: true }
);

window.addEventListener(
	'orientationchange',
	function () {
		syncStickyTopOffsetVar();
		recomputeThreshold();
	},
	{ passive: true }
);

		// se il bottone cambia dimensione/posizione
		try {
			new ResizeObserver(recomputeThreshold).observe(btn);
		} catch (e) {
			/* ok se non supportato */
		}

		// eventi di tema comuni che possono spostare il bottone
		document.addEventListener('variant:changed', recomputeThreshold, { passive: true });
		document.addEventListener('product:variant:change', recomputeThreshold, { passive: true });
		window.addEventListener('variantGalleryUpdated', recomputeThreshold, { passive: true });

		function runLoadedViewportCheck() {
			recomputeThreshold();

			window.setTimeout(function () {
				recomputeThreshold();
			}, 160);
		}

		// stato iniziale
		recomputeThreshold();

		if (document.readyState === 'complete') {
			runLoadedViewportCheck();
		} else {
			window.addEventListener(
				'load',
				function () {
					runLoadedViewportCheck();
				},
				{ once: true }
			);
		}
	}

	function init() {
		syncTitle();
		syncButton();
		syncPrice();
		observePrice();
		visControllerTop();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init, { once: true });
	} else {
		init();
	}
})();

(function () {
	function mark(open) {
		document.documentElement.classList.toggle('sov-menu-open', !!open);
	}

	function watchDrawer() {
		// prova vari selettori comuni ai temi
		var d = document.querySelector('details[id*="menu"], .menu-drawer, [data-menu-drawer], header-drawer details');
		if (!d) return;

		if (d.tagName.toLowerCase() === 'details') {
			d.addEventListener('toggle', function () {
				mark(d.open);
			});
			mark(d.open);
		} else {
			// osserva visibilità/cambi classe
			var mo = new MutationObserver(function () {
				var cs = getComputedStyle(d);
				var visible = (d.matches('[open]') || cs.display !== 'none') && d.getBoundingClientRect().height > 0;
				mark(visible);
			});

			mo.observe(d, {
				attributes: true,
				attributeFilter: ['open', 'class', 'style', 'hidden', 'aria-hidden'],
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', watchDrawer, { once: true });
	} else {
		watchDrawer();
	}
})();

/*
	aggiorna stato e label dei pulsanti add to cart quando la variante corrente è esaurita

	ultimo aggiornamento: 2025-11-07 01:40 Europe/Rome
	prima: stato varianti esaurite non sincronizzato tra bottone principale e sticky
	dopo: label e disabled sincronizzati su bottone principale e sticky con fallback sul bottone nativo
*/
(() => {
	const ROOT = document.querySelector('.buy-buttons-wrapper');
	const ROUTER_BTN = document.querySelector('.buy-buttons-wrapper [data-sov-bundle-router-open="1"]');
	const IS_BUNDLE_MEGA = !!ROUTER_BTN;
	const LABEL_ADD = IS_BUNDLE_MEGA
		? ((ROUTER_BTN && ROUTER_BTN.textContent) || '').trim()
		: (ROOT && ROOT.dataset.labelAdd);
	const LABEL_OOS = ROOT && ROOT.dataset.labelOos;

	const MAIN_BTN = document.querySelector('#sov-buy-form .product-form__submit');
	const STICKY_BTN = document.getElementById('sovStickyAtcBtn');

	function setBtnLabel(btn, text) {
		if (!btn) return;

		const span = btn.querySelector('.sov-sticky-atc__btnlabel') || btn.querySelector('span');

		if (span) {
			span.textContent = text;
		} else {
			btn.textContent = text;
		}
	}

	function setDisabled(btn, on) {
		if (!btn) return;

		if (on) {
			btn.setAttribute('disabled', '');
			btn.setAttribute('aria-disabled', 'true');
		} else {
			btn.removeAttribute('disabled');
			btn.setAttribute('aria-disabled', 'false');
		}
	}

	function currentVariantId() {
		const s = document.querySelector('select[name="id"]');
		return (s && s.value) || '';
	}

	function isCurrentOOS() {
		if (IS_BUNDLE_MEGA) {
			return false;
		}

		const vid = currentVariantId();

		if (vid) {
			const t = document.querySelector('.variant-thumb-img[data-variant-id="' + vid + '"]');

			if (t && t.hasAttribute('data-esaurito')) {
				return t.getAttribute('data-esaurito') === '1';
			}
		}

		const btn = MAIN_BTN || document.querySelector('.product-form__submit');
		return !!(btn && btn.disabled);
	}

	function applyState() {
		const oos = isCurrentOOS();
		const label = oos ? LABEL_OOS : LABEL_ADD;

		[MAIN_BTN, STICKY_BTN].forEach((b) => {
			setDisabled(b, oos);
			setBtnLabel(b, label);
		});

		if (ROUTER_BTN) {
			setDisabled(ROUTER_BTN, false);
			setBtnLabel(ROUTER_BTN, LABEL_ADD);
		}
	}

	function boot() {
		applyState();

		setTimeout(applyState, 0);
		setTimeout(applyState, 120);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot, { once: true });
	} else {
		boot();
	}

	document.addEventListener('variant:changed', applyState, true);
	document.addEventListener('product:variant:change', applyState, true);

	document.addEventListener(
		'change',
		function (e) {
			if (e.target && e.target.name === 'id') {
				applyState();
			}
		},
		true
	);
})();

/*
	gestisce la mini progress bar sotto la gallery orizzontale mobile

	ultimo aggiornamento: 2026-03-21 Europe/Rome
	prima: calcolo lineare su scrollWidth reale
	dopo: calcolo clone-aware con fallback lineare quando i cloni non esistono ancora
*/
(function () {
	var gallery = document.querySelector('.sov-gallery');
	if (!gallery) return;

	function qa(sel, root) {
		return Array.prototype.slice.call((root || document).querySelectorAll(sel));
	}

	function isMobile() {
		return matchMedia('(max-width: 900px)').matches;
	}

	function ensureBar() {
		var bar = document.getElementById('sovMiniSlider');

		if (!bar) {
			bar = document.createElement('div');
			bar.id = 'sovMiniSlider';
			bar.className = 'sov-mini-slider';
			bar.setAttribute('hidden', '');
			bar.innerHTML =
				'<div class="sov-mini-slider__track"><div class="sov-mini-slider__knob">&nbsp;</div></div>';

			gallery.insertAdjacentElement('afterend', bar);
		}

		return bar;
	}

	var bar = ensureBar();
	var track = bar.querySelector('.sov-mini-slider__track');
	var knob = bar.querySelector('.sov-mini-slider__knob');

	var squelchUntil = 0;

	function startSquelch(ms) {
		squelchUntil = performance.now() + (ms || 150);
	}

	function getOriginalVignettes() {
		return qa('.vignette:not([data-sov-clone="1"])', gallery);
	}

	function hasInfiniteClones() {
		return qa('.vignette[data-sov-clone="1"]', gallery).length > 0;
	}

	function getMetrics() {
		var clientW = gallery.clientWidth;

		if (clientW <= 0) {
			return null;
		}

		if (isMobile() && hasInfiniteClones()) {
			var originals = getOriginalVignettes();

			if (originals.length >= 2) {
				var firstOriginal = originals[0];
				var lastOriginal = originals[originals.length - 1];

				var maxScroll = Math.max(0, lastOriginal.offsetLeft - firstOriginal.offsetLeft);
				var currentScroll = gallery.scrollLeft - firstOriginal.offsetLeft;

				if (currentScroll < 0) currentScroll = 0;
				if (currentScroll > maxScroll) currentScroll = maxScroll;

				return {
					scrollWidth: maxScroll + clientW,
					clientWidth: clientW,
					scrollLeft: currentScroll,
					maxScroll: maxScroll
				};
			}
		}

		var scrollW = gallery.scrollWidth;
		var maxScrollNormal = Math.max(0, scrollW - clientW);

		return {
			scrollWidth: scrollW,
			clientWidth: clientW,
			scrollLeft: gallery.scrollLeft,
			maxScroll: maxScrollNormal
		};
	}

	function updateBar() {
		if (!isMobile()) {
			bar.setAttribute('hidden', '');
			return;
		}

		var metrics = getMetrics();
		if (!metrics || metrics.maxScroll <= 0) {
			bar.setAttribute('hidden', '');
			return;
		}

		bar.removeAttribute('hidden');

		var trackW = track.clientWidth;
		var knobPx = Math.max(16, (metrics.clientWidth / metrics.scrollWidth) * trackW);
		knob.style.width = knobPx + 'px';

		var now = performance.now();
		var noAnim = now < squelchUntil;

		var maxTX = Math.max(0, trackW - knobPx);
		var ratio = metrics.maxScroll ? metrics.scrollLeft / metrics.maxScroll : 0;
		var targetX = maxTX * ratio;

		if (noAnim) {
			var prev = knob.style.transition;
			knob.style.transition = 'none';
			knob.style.transform = 'translateX(' + targetX + 'px)';

			requestAnimationFrame(function () {
				if (performance.now() >= squelchUntil) {
					knob.style.transition = prev || '';
				}
			});
		} else {
			knob.style.transform = 'translateX(' + targetX + 'px)';
		}
	}

	var raf = 0;

	function rq() {
		if (raf) cancelAnimationFrame(raf);
		raf = requestAnimationFrame(updateBar);
	}

	gallery.addEventListener('scroll', rq, { passive: true });
	addEventListener('resize', rq, { passive: true });
	addEventListener('orientationchange', rq, { passive: true });

	function onVariantChangeNoBounce() {
		startSquelch(180);
		rq();
	}

	addEventListener('variantGalleryUpdated', onVariantChangeNoBounce, { passive: true });
	addEventListener('variant:changed', onVariantChangeNoBounce, { passive: true });
	addEventListener('product:variant:change', onVariantChangeNoBounce, { passive: true });

	gallery.querySelectorAll('img,video').forEach(function (el) {
		if (el.tagName === 'IMG') {
			el.addEventListener('load', rq, { once: true });
		} else {
			el.addEventListener('loadeddata', rq, { once: true });
		}
	});

	try {
		new ResizeObserver(rq).observe(gallery);
	} catch (e) {}

	setTimeout(updateBar, 300);
})();